(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2393],{

/***/ 36899:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order/[[...brand]]",
      function () {
        return __webpack_require__(45231);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53918);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45388);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 0;\n    border-radius: 0px;\n    width: ",
        ";\n    background: transparent;\n    color: ",
        ";\n    border: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var IconButtonV2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5ffd0d51-0"
})(_templateObject(), function(param) {
    var scale = param.scale;
    return scale === "sm" ? "32px" : "48px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
/* harmony default export */ __webpack_exports__["Z"] = (IconButtonV2);


/***/ }),

/***/ 54379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53918);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8774);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    appearance: none;\n    overflow: hidden;\n    cursor: pointer;\n    position: relative;\n    display: inline-block;\n    height: ",
        ";\n    width: ",
        ";\n    /* vertical-align: middle; */\n    transition: background-color 0.2s ease-in-out;\n    border: 0;\n    border-radius: 50%;\n    background-color: ",
        ';\n    border: transparent;\n    &:after {\n        content: "";\n        position: absolute;\n        top: 35%;\n        left: 0;\n        right: 0;\n        width: 30%;\n        height: 30%;\n        border-radius: 50%;\n        margin: auto;\n        background: ',
        ";\n    }\n    &:checked {\n        background-color: ",
        ";\n        border: none;\n        &:after {\n            border-color: ",
        ";\n        }\n    }\n\n    &:disabled {\n        cursor: not-allowed;\n        background: #9596A6;\n        opacity: 0.6;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var getScale = function(param) {
    var scale = param.scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "24px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "32px";
    }
};
var CheckboxV2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.attrs */ .ZP.input.attrs({
    type: "checkbox"
}).withConfig({
    componentId: "sc-e97af0b1-0"
})(_templateObject(), getScale, getScale, function(param) {
    var theme = param.theme;
    return theme.colors.default;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.default;
});
CheckboxV2.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckboxV2);


/***/ }),

/***/ 8774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md"
};


/***/ }),

/***/ 76376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53918);
/* harmony import */ var _Box_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6538);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43605);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71849);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: ",
        ";\n    border-radius: 12px;\n    ",
        " {\n        padding-left: ",
        ";\n        padding-right: ",
        ";\n        background-color: transparent;\n        font-weight: 700;\n        font-size: 14px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    align-items: center;\n    display: flex;\n    height: 100%;\n    position: absolute;\n    top: 0;\n\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var getPadding = function(scale, hasIcon) {
    if (!hasIcon) {
        return "16px";
    }
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.LG */ .Q.LG:
            return "56px";
        case _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.MD */ .Q.MD:
        default:
            return "48px";
    }
};
var StyledInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_Box_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-809825c4-0"
})(_templateObject(), function(param) {
    var isHiddenBorder = param.isHiddenBorder, theme = param.theme;
    return isHiddenBorder ? "none" : "1px solid ".concat(theme.colors.cardBorder);
}, _Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, function(param) {
    var hasStartIcon = param.hasStartIcon, scale = param.scale;
    return getPadding(scale, hasStartIcon);
}, function(param) {
    var hasEndIcon = param.hasEndIcon, scale = param.scale;
    return getPadding(scale, hasEndIcon);
});
var InputIcon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-809825c4-1"
})(_templateObject1(), function(param) {
    var isEndIcon = param.isEndIcon, scale = param.scale;
    return isEndIcon ? "\n    right: ".concat(scale === _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.SM */ .Q.SM ? "8px" : "16px", ";\n  ") : "\n    left: ".concat(scale === _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.SM */ .Q.SM ? "8px" : "16px", ";\n  ");
});
var InputGroup = function(_param) /*#__PURE__*/ {
    var _scale = _param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.MD */ .Q.MD : _scale, startIcon = _param.startIcon, endIcon = _param.endIcon, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "scale",
        "startIcon",
        "endIcon",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledInputGroup, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        scale: scale,
        width: "100%",
        position: "relative",
        hasStartIcon: !!startIcon,
        hasEndIcon: !!endIcon
    }, props), {
        children: [
            startIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InputIcon, {
                scale: scale,
                children: startIcon
            }),
            /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(children, {
                scale: scale
            }),
            endIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InputIcon, {
                scale: scale,
                isEndIcon: true,
                children: endIcon
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InputGroup);


/***/ }),

/***/ 44305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6538);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53918);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    @media screen and (min-width: 821px) and (max-width: 1024px) {\n        padding: 0px 20px 0px 20px !important;\n    }\n    @media screen and (max-width: 768px){\n        padding: 0 20px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Container = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CsBox, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        px: [
            "16px",
            "10px"
        ],
        paddingBottom: "1.5rem",
        mx: "auto",
        maxWidth: "1320px"
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);
var CsBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-73f8e6bf-0"
})(_templateObject());


/***/ }),

/***/ 38047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13193);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_meta_tags__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81372);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53918);
/* harmony import */ var config_constants_meta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31574);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width:100%;\n    height: auto;\n    display:flex;\n    justify-content: flex-start;\n    margin-top: 70px;\n    align-items: center;\n    flex-direction: column;\n    min-height: 80vh;\n    margin-bottom: 300px;\n    @media screen and (max-width: 600px) {\n        margin-top: 40px;\n        margin-bottom: 100px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var PageMeta = function() {
    var ref = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().pathname;
    var pageMeta = (0,config_constants_meta__WEBPACK_IMPORTED_MODULE_4__/* .getCustomMeta */ .S)(pathname, t, locale) || {};
    var ref1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, config_constants_meta__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META */ .k, pageMeta), title = ref1.title, description = ref1.description, image = ref1.image;
    var pageTitle = title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_meta_tags__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                property: "og:image",
                content: image
            })
        ]
    });
};
var PageFullWidth = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageMeta, {}),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageFullWidth);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-668451c7-0"
})(_templateObject());


/***/ }),

/***/ 85621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53918);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74566);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29439);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51421);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(76376);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19881);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43605);
/* harmony import */ var utils_latinise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75660);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);







function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 16px;\n    transition: border-radius 0.15s;\n    color: #fdb533;\n    > svg {\n        fill: #fff !important;\n    }\n\n    @media screen and (max-width: 600px) {\n        padding: 0 10px;\n        width: 80%;\n        font-size: 12px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 16px;\n    @media screen and (max-width: 600px) {\n        font-size: 15px;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 180px;\n    height: 100%;\n    max-height: 250px;\n    padding: 0px;\n    position: absolute;\n    overflow-y: auto;\n    overflow-x: hidden;\n    z-index: ",
        ";\n    transition: transform 0.15s, opacity 0.15s;\n    transform: scaleY(0);\n    transform-origin: top;\n    opacity: 0;\n    box-sizing: border-box;\n    box-shadow: 0px 8px 28px 0px rgba(66, 66, 66, 0.10);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            ",
        " {\n                height: auto;\n                transform: scaleY(1);\n                opacity: 1;\n                border-top-width: 0;\n                width: 100%;\n                background: ",
        ";\n                top: 49px;\n                border-radius: 12px;\n                z-index: 20;\n            }\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    cursor: pointer;\n    position: relative;\n    width: 100%;\n    height: 48px;\n    border-radius: 12px;\n    box-sizing: border-box;\n    background-color: transparent;\n    border: 1px solid ",
        ";\n    ",
        " {\n        min-width: 100px;\n    }\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 0;\n    box-sizing: border-box;\n    z-index: ",
        ";\n    /* display: ",
        "; */\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    list-style: none;\n    padding: 8px 28px;\n    border-radius: 0px;\n    :hover {\n        background: ",
        ";\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var DropDownHeader = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-64f50ac5-0"
})(_templateObject());
var CsText = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-64f50ac5-1"
})(_templateObject1());
var DropDownListContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-64f50ac5-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var DropDownContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-64f50ac5-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(props) {
    return props.isOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject3(), DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.colors.background;
    });
});
var DropDownList = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-64f50ac5-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "none" : "block";
});
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-64f50ac5-5"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt2;
});
var SelectProvinceHome = function(_param) {
    var options = _param.options, onOptionChange = _param.onOptionChange, placeHolderText = _param.placeHolderText, isDefaultProvince = _param.isDefaultProvince, isLoading = _param.isLoading, selectedOption = _param.selectedOption, disabled = _param.disabled, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "options",
        "onOptionChange",
        "placeHolderText",
        "isDefaultProvince",
        "isLoading",
        "selectedOption",
        "disabled"
    ]);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), optionSelected = ref1[0], setOptionSelected = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        width: 0,
        height: 0
    }), containerSize = ref2[0], setContainerSize = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(options)), filterData = ref3[0], setFillterData = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), query = ref4[0], setQuery = ref4[1];
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)().theme;
    var toggling = function(event) {
        if (options.length > 0 && !disabled) {
            setIsOpen(!isOpen);
        }
        event.stopPropagation();
    };
    var handleClicked = function(data) {
        return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                setIsOpen(false);
                setOptionSelected(true);
                setQuery("");
                if (onOptionChange) {
                    onOptionChange(data);
                }
                return [
                    2
                ];
            });
        });
    };
    var handleClickOutside = function() {
        if (containerRef.current && !containerRef.current.contains(document.activeElement)) {
            setIsOpen(false);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setContainerSize({
            width: dropdownRef.current.offsetWidth,
            height: dropdownRef.current.offsetHeight
        });
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    var handleChangeQuery = function(event) {
        console.log("event", event);
        var re = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s\W|_]+$/;
        if (event.target.value === "" || re.test(event.target.value)) {
            var values = event.target.value;
            var replace = values.replace(/[.*+?^${}()|[\]\\!@#%&_~]/g, "");
            setQuery(replace);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var lowercaseQuery = (0,utils_latinise__WEBPACK_IMPORTED_MODULE_4__/* .toLowerCaseNonAccentVietnamese */ .HO)(query.toLowerCase());
        if ((query === null || query === void 0 ? void 0 : query.length) > 0) {
            setFillterData((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(options.filter(function(it) {
                return (0,utils_latinise__WEBPACK_IMPORTED_MODULE_4__/* .toLowerCaseNonAccentVietnamese */ .HO)(it === null || it === void 0 ? void 0 : it.provinceName.toLowerCase()).includes(lowercaseQuery);
            })));
        } else {
            setFillterData((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(options));
        }
    }, [
        options,
        query
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isDefaultProvince && !optionSelected) {
            onOptionChange({
                provinceId: "0",
                provinceName: "Tất cả"
            });
        }
    }, [
        isDefaultProvince,
        onOptionChange,
        optionSelected
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DropDownContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        isOpen: isOpen
    }, props), {
        ref: containerRef
    }), containerSize), {
        children: [
            containerSize.width !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownHeader, {
                onClick: toggling,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CsText, {
                    color: !optionSelected && placeHolderText ? "text" : "text",
                    children: selectedOption === undefined ? "Tất cả khu vực" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: "Loading..."
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: (options === null || options === void 0 ? void 0 : options.length) === 0 ? "Kh\xf4ng c\xf3 tỉnh th\xe0nh" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: !optionSelected && placeHolderText ? placeHolderText : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceName
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                position: "absolute",
                right: "16px",
                top: "13px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    color: "black",
                    onClick: toggling,
                    style: {
                        transform: isOpen && "rotate(180deg)"
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DropDownListContainer, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        width: "100%",
                        height: "auto",
                        padding: "12px 12px 0px 12px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {}),
                            mb: "2px",
                            scale: "sm",
                            isHiddenBorder: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                type: "text",
                                placeholder: "T\xecm kiếm",
                                value: query,
                                onChange: function(evt) {
                                    return handleChangeQuery(evt);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        width: "100%",
                        borderBottom: "1px solid ".concat(theme.colors.backgroundTab)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownList, {
                        ref: dropdownRef,
                        isDisabled: isLoading,
                        children: filterData.map(function(option) {
                            return placeHolderText || (option === null || option === void 0 ? void 0 : option.provinceId) !== (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceId) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItem, {
                                onClick: handleClicked(option),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CsText, {
                                    color: (option === null || option === void 0 ? void 0 : option.provinceId) === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceId) ? "gold" : "text",
                                    children: [
                                        option === null || option === void 0 ? void 0 : option.provinceName,
                                        " ",
                                        (option === null || option === void 0 ? void 0 : option.amount) && "(".concat(option === null || option === void 0 ? void 0 : option.amount, ")"),
                                        " "
                                    ]
                                })
                            }, option === null || option === void 0 ? void 0 : option.provinceName) : null;
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectProvinceHome);


/***/ }),

/***/ 86930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ historyApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6154);
/* harmony import */ var config_api_API_URL__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10307);




var history = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(config_api_API_URL__WEBPACK_IMPORTED_MODULE_0__/* .API_URL.HISTORY */ .T.HISTORY, {
                            params: data,
                            timeout: 100000
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function history(data) {
        return _ref.apply(this, arguments);
    };
}();
var vouchers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(config_api_API_URL__WEBPACK_IMPORTED_MODULE_0__/* .API_URL.VOUCHERS */ .T.VOUCHERS)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function vouchers() {
        return _ref.apply(this, arguments);
    };
}();
var resendMail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post(config_api_API_URL__WEBPACK_IMPORTED_MODULE_0__/* .API_URL.RESENDMAIL */ .T.RESENDMAIL, data, {
                            timeout: 100000
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function resendMail(data) {
        return _ref.apply(this, arguments);
    };
}();
var vouchersStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(config_api_API_URL__WEBPACK_IMPORTED_MODULE_0__/* .API_URL.VOUCHERS_STATUS */ .T.VOUCHERS_STATUS, {
                            params: data
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function vouchersStatus(data) {
        return _ref.apply(this, arguments);
    };
}();
var reVerify = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post(config_api_API_URL__WEBPACK_IMPORTED_MODULE_0__/* .API_URL.REVERIFY */ .T.REVERIFY, data, {
                            timeout: 100000
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function reVerify(data) {
        return _ref.apply(this, arguments);
    };
}();
var giftCardVoucher = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(config_api_API_URL__WEBPACK_IMPORTED_MODULE_0__/* .API_URL.GIFT_CARD_VOUCHER */ .T.GIFT_CARD_VOUCHER)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function giftCardVoucher() {
        return _ref.apply(this, arguments);
    };
}();
var historyApi = {
    history: history,
    vouchers: vouchers,
    resendMail: resendMail,
    vouchersStatus: vouchersStatus,
    reVerify: reVerify,
    giftCardVoucher: giftCardVoucher
};


/***/ }),

/***/ 45231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _brand_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/giftCards/index.ts
var giftCards = __webpack_require__(61418);
// EXTERNAL MODULE: ./src/state/giftCards/actions.ts
var actions = __webpack_require__(59494);
// EXTERNAL MODULE: ./src/utils/wagmi.ts + 6 modules
var wagmi = __webpack_require__(92835);
// EXTERNAL MODULE: ./src/views/BrandDetails/components/NotFound.tsx
var NotFound = __webpack_require__(64950);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(95867);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(62255);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowLeftCircle.tsx
var ArrowLeftCircle = __webpack_require__(41061);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(55421);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/LocationV2.tsx
var LocationV2 = __webpack_require__(69929);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/IconSort.tsx
var IconSort = __webpack_require__(51421);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(83024);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDownIcon.tsx
var ArrowDownIcon = __webpack_require__(41864);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js + 4 modules
var spin = __webpack_require__(35410);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(7447);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
// EXTERNAL MODULE: ./src/components/Layout/PageFullWidth.tsx
var PageFullWidth = __webpack_require__(38047);
// EXTERNAL MODULE: ./src/components/Select/SelectProvinceHome.tsx
var SelectProvinceHome = __webpack_require__(85621);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
// EXTERNAL MODULE: ./src/config/api/brand.ts
var brand = __webpack_require__(72070);
// EXTERNAL MODULE: ./src/config/constants/address/province.json
var province = __webpack_require__(8126);
// EXTERNAL MODULE: ./src/config/constants/contracts.ts
var contracts = __webpack_require__(87338);
// EXTERNAL MODULE: ./src/config/giftcards.ts
var giftcards = __webpack_require__(65807);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./src/state/auth/index.ts + 1 modules
var auth = __webpack_require__(97957);
// EXTERNAL MODULE: ./src/state/giftCards/fetchData.ts + 1 modules
var fetchData = __webpack_require__(82993);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(965);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(69352);
// EXTERNAL MODULE: ./src/utils/formatNumber.ts
var formatNumber = __webpack_require__(20012);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(91375);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Plus.tsx
var Plus = __webpack_require__(89325);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/InputGroup.tsx
var InputGroup = __webpack_require__(76376);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Search.tsx
var Search = __webpack_require__(19881);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(43605);
// EXTERNAL MODULE: ./src/utils/latinise.ts
var latinise = __webpack_require__(75660);
;// CONCATENATED MODULE: ./src/components/Select/SelectProvince.tsx







function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 16px;\n    transition: border-radius 0.15s;\n    color: #fdb533;\n    > svg {\n        fill: #fff !important;\n    }\n\n    @media screen and (max-width: 600px) {\n        padding: 0 10px;\n        width: 80%;\n        font-size: 12px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    @media screen and (max-width: 600px) {\n        font-size: 15px;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 180px;\n    height: 100%;\n    max-height: 250px;\n    padding: 0px;\n    position: absolute;\n    overflow-y: auto;\n    overflow-x: hidden;\n    z-index: ",
        ";\n    transition: transform 0.15s, opacity 0.15s;\n    transform: scaleY(0);\n    transform-origin: top;\n    opacity: 0;\n    box-sizing: border-box;\n    box-shadow: 0px 8px 28px 0px rgba(66, 66, 66, 0.10);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            ",
        " {\n                height: auto;\n                transform: scaleY(1);\n                opacity: 1;\n                border-top-width: 0;\n                width: 100%;\n                background: ",
        ";\n                top: 49px;\n                border-radius: 12px;\n                z-index: 20;\n            }\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n    position: relative;\n    width: 100%;\n    height: 48px;\n    border-radius: 12px;\n    box-sizing: border-box;\n    background-color: transparent;\n    border: 1px solid ",
        ";\n    ",
        " {\n        min-width: 100px;\n    }\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n    box-sizing: border-box;\n    z-index: ",
        ";\n    /* display: ",
        "; */\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    list-style: none;\n    padding: 8px 28px;\n    border-radius: 0px;\n    :hover {\n        background: ",
        ";\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









var DropDownHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5b937a0-0"
})(_templateObject());
var CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b5b937a0-1"
})(_templateObject1());
var DropDownListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5b937a0-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var DropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5b937a0-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(props) {
    return props.isOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.colors.background;
    });
});
var DropDownList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-b5b937a0-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "none" : "block";
});
var ListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-b5b937a0-5"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt2;
});
var Select = function(_param) {
    var options = _param.options, onOptionChange = _param.onOptionChange, placeHolderText = _param.placeHolderText, isDefaultProvince = _param.isDefaultProvince, selectCategory = _param.selectCategory, isLoading = _param.isLoading, selectBrand = _param.selectBrand, setSelectedOption = _param.setSelectedOption, selectedOption = _param.selectedOption, priceRoute = _param.priceRoute, brandRoute = _param.brandRoute, setOptionSelected = _param.setOptionSelected, optionSelected = _param.optionSelected, props = (0,_object_without_properties/* default */.Z)(_param, [
        "options",
        "onOptionChange",
        "placeHolderText",
        "isDefaultProvince",
        "selectCategory",
        "isLoading",
        "selectBrand",
        "setSelectedOption",
        "selectedOption",
        "priceRoute",
        "brandRoute",
        "setOptionSelected",
        "optionSelected"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var containerRef = (0,react.useRef)(null);
    var dropdownRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)({
        width: 0,
        height: 0
    }), containerSize = ref1[0], setContainerSize = ref1[1];
    var ref2 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(options)), filterData = ref2[0], setFillterData = ref2[1];
    var ref3 = (0,react.useState)(""), query = ref3[0], setQuery = ref3[1];
    var theme = (0,useTheme/* default */.ZP)().theme;
    var toggling = function(event) {
        if (options.length > 0) {
            setIsOpen(!isOpen);
        }
        event.stopPropagation();
    };
    var handleClicked = function(data) {
        /*#__PURE__*/ return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSelectedOption(data);
                        setIsOpen(false);
                        setOptionSelected(true);
                        setQuery("");
                        if (!((data === null || data === void 0 ? void 0 : data.provinceId) === "0")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            dispatch((0,actions/* fetchListProvince */.ee)({
                                listProvince: province
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* fetchListProvinceByBrandId */.XN)({
                                brandId: "0"
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* fetchProvinceId */.ar)({
                                cityId: "0"
                            }))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (onOptionChange) {
                            onOptionChange(data);
                        }
                        return [
                            2
                        ];
                }
            });
        });
    };
    var handleClickOutside = function() {
        if (containerRef.current && !containerRef.current.contains(document.activeElement)) {
            setIsOpen(false);
        }
    };
    (0,react.useEffect)(function() {
        setContainerSize({
            width: dropdownRef.current.offsetWidth,
            height: dropdownRef.current.offsetHeight
        });
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    var handleChangeQuery = function(event) {
        console.log("event", event);
        var re = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s\W|_]+$/;
        if (event.target.value === "" || re.test(event.target.value)) {
            var values = event.target.value;
            var replace = values.replace(/[.*+?^${}()|[\]\\!@#%&_~]/g, "");
            setQuery(replace);
        }
    };
    (0,react.useEffect)(function() {
        var lowercaseQuery = (0,latinise/* toLowerCaseNonAccentVietnamese */.HO)(query.toLowerCase());
        if ((query === null || query === void 0 ? void 0 : query.length) > 0) {
            setFillterData((0,_to_consumable_array/* default */.Z)(options.filter(function(it) {
                return (0,latinise/* toLowerCaseNonAccentVietnamese */.HO)(it === null || it === void 0 ? void 0 : it.provinceName.toLowerCase()).includes(lowercaseQuery);
            })));
        } else {
            setFillterData((0,_to_consumable_array/* default */.Z)(options));
        }
    }, [
        options,
        query
    ]);
    (0,react.useEffect)(function() {
        if (isDefaultProvince && !optionSelected) {
            onOptionChange({
                provinceId: "0",
                provinceName: "Tất cả"
            });
        }
    }, [
        isDefaultProvince,
        selectCategory,
        onOptionChange,
        optionSelected
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isOpen: isOpen
    }, props), {
        ref: containerRef
    }), containerSize), {
        children: [
            containerSize.width !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownHeader, {
                onClick: toggling,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                    color: !optionSelected && placeHolderText ? "text" : undefined,
                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: "Loading..."
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: (options === null || options === void 0 ? void 0 : options.length) === 0 ? "Kh\xf4ng c\xf3 tỉnh th\xe0nh" : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: !optionSelected && placeHolderText ? placeHolderText : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceName
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                position: "absolute",
                right: "16px",
                top: "13px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                    color: "black",
                    onClick: toggling,
                    style: {
                        transform: isOpen && "rotate(180deg)"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownListContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        height: "auto",
                        padding: "12px 12px 0px 12px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup/* default */.Z, {
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {}),
                            mb: "2px",
                            scale: "sm",
                            isHiddenBorder: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                type: "text",
                                placeholder: "T\xecm kiếm",
                                value: query,
                                onChange: function(evt) {
                                    return handleChangeQuery(evt);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        borderBottom: "1px solid ".concat(theme.colors.backgroundTab)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownList, {
                        ref: dropdownRef,
                        isDisabled: isLoading,
                        children: filterData.map(function(option) {
                            return placeHolderText || (option === null || option === void 0 ? void 0 : option.provinceId) !== (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceId) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                onClick: handleClicked(option),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsText, {
                                    color: (option === null || option === void 0 ? void 0 : option.provinceId) === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceId) ? "gold" : "text",
                                    children: [
                                        option === null || option === void 0 ? void 0 : option.provinceName,
                                        " ",
                                        (option === null || option === void 0 ? void 0 : option.amount) && "(".concat(option === null || option === void 0 ? void 0 : option.amount, ")"),
                                        " "
                                    ]
                                })
                            }, option === null || option === void 0 ? void 0 : option.provinceName) : null;
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var SelectProvince = (Select);

;// CONCATENATED MODULE: ./src/components/Select/SelectToken.tsx




function SelectToken_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 0px 16px;\n    transition: border-radius 0.15s;\n    color: #fdb533;\n    gap: 1rem;\n    > svg {\n        fill: #fff !important;\n    }\n\n    @media screen and (max-width: 600px) {\n        padding: 0 10px;\n        width: 80%;\n        font-size: 12px;\n    }\n"
    ]);
    SelectToken_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectToken_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    @media screen and (max-width: 600px) {\n        font-size: 15px;\n    }\n"
    ]);
    SelectToken_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SelectToken_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 180px;\n    height: 100%;\n    max-height: 250px;\n    padding: 0;\n    position: absolute;\n    overflow-y: auto;\n    overflow-x: hidden;\n    z-index: ",
        ";\n    transition: transform 0.15s, opacity 0.15s;\n    transform: scaleY(0);\n    transform-origin: top;\n    opacity: 0;\n    box-sizing: border-box;\n    box-shadow: 0px 8px 28px 0px rgba(66, 66, 66, 0.1);\n"
    ]);
    SelectToken_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SelectToken_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            ",
        " {\n                height: auto;\n                transform: scaleY(1);\n                opacity: 1;\n                border-top-width: 0;\n                width: 100%;\n                background: ",
        ";\n                top: 49px;\n                border-radius: 12px;\n            }\n        "
    ]);
    SelectToken_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SelectToken_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n    position: relative;\n    width: 100%;\n    height: 48px;\n    border-radius: 12px;\n    box-sizing: border-box;\n    background-color: transparent;\n    border: 1px solid ",
        ";\n    ",
        " {\n        min-width: 100px;\n    }\n    ",
        "\n"
    ]);
    SelectToken_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SelectToken_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    z-index: ",
        ";\n"
    ]);
    SelectToken_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SelectToken_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    list-style: none;\n    display: flex;\n    padding: 8px 16px;\n    border-radius: 0px;\n"
    ]);
    SelectToken_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: center;\n    gap:12px;\n    @media screen and (max-width: 320px) {\n        padding: 0px;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var SelectToken_DropDownHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b3f3ee7-0"
})(SelectToken_templateObject());
var SelectToken_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-2b3f3ee7-1"
})(SelectToken_templateObject1());
var SelectToken_DropDownListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b3f3ee7-2"
})(SelectToken_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var SelectToken_DropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b3f3ee7-3"
})(SelectToken_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(props) {
    return props.isOpen && (0,styled_components_browser_esm/* css */.iv)(SelectToken_templateObject3(), SelectToken_DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.colors.background;
    });
});
var SelectToken_DropDownList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-2b3f3ee7-4"
})(SelectToken_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var SelectToken_ListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-2b3f3ee7-5"
})(SelectToken_templateObject6());
var SelectToken = function(_param) {
    var renderItems = function renderItems(label) {
        return label ? "/images/coins/".concat(label.toLowerCase(), ".png") : null;
    };
    var options = _param.options, onOptionChange = _param.onOptionChange, _defaultOptionIndex = _param.defaultOptionIndex, defaultOptionIndex = _defaultOptionIndex === void 0 ? 0 : _defaultOptionIndex, placeHolderText = _param.placeHolderText, value = _param.value, props = (0,_object_without_properties/* default */.Z)(_param, [
        "options",
        "onOptionChange",
        "defaultOptionIndex",
        "placeHolderText",
        "value"
    ]);
    var containerRef = (0,react.useRef)(null);
    var dropdownRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(false), optionSelected = ref1[0], setOptionSelected = ref1[1];
    var ref2 = (0,react.useState)(defaultOptionIndex), selectedOptionIndex = ref2[0], setSelectedOptionIndex = ref2[1];
    var ref3 = (0,react.useState)({
        width: 0,
        height: 0
    }), containerSize = ref3[0], setContainerSize = ref3[1];
    var toggling = function(event) {
        if (options.length > 0) {
            setIsOpen(!isOpen);
        }
        event.stopPropagation();
    };
    var onOptionClicked = function(selectedIndex) {
        return function() {
            setSelectedOptionIndex(selectedIndex);
            setIsOpen(false);
            setOptionSelected(true);
            if (onOptionChange) {
                onOptionChange(options[selectedIndex]);
            }
        };
    };
    (0,react.useEffect)(function() {
        setContainerSize({
            width: dropdownRef.current.offsetWidth,
            height: dropdownRef.current.offsetHeight
        });
        var handleClickOutside = function() {
            setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (defaultOptionIndex) {
            setSelectedOptionIndex(defaultOptionIndex - 1);
            setOptionSelected(true);
        }
    }, [
        defaultOptionIndex
    ]);
    var findActiveItem = (0,react.useMemo)(function() {
        return options === null || options === void 0 ? void 0 : options.find(function(dt) {
            var ref;
            return (dt === null || dt === void 0 ? void 0 : (ref = dt.value) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (value === null || value === void 0 ? void 0 : value.toLowerCase());
        });
    }, [
        options,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectToken_DropDownContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            isOpen: isOpen
        }, props), {
            ref: containerRef
        }), containerSize), {
            children: [
                containerSize.width !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectToken_DropDownHeader, {
                    onClick: toggling,
                    children: [
                        (findActiveItem === null || findActiveItem === void 0 ? void 0 : findActiveItem.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: renderItems(findActiveItem === null || findActiveItem === void 0 ? void 0 : findActiveItem.label),
                            alt: "logo_currency",
                            style: {
                                width: "30px",
                                height: "30px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: !optionSelected && placeHolderText ? "text" : undefined,
                            children: (findActiveItem === null || findActiveItem === void 0 ? void 0 : findActiveItem.label) || placeHolderText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    position: "absolute",
                    right: "16px",
                    top: "13px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                        color: "black",
                        onClick: toggling,
                        style: {
                            transform: isOpen && "rotate(180deg)"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectToken_DropDownListContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectToken_DropDownList, {
                        ref: dropdownRef,
                        children: options.map(function(option, index) {
                            return placeHolderText || index !== selectedOptionIndex ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomListItem, {
                                onClick: onOptionClicked(index),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: renderItems(option.label),
                                        alt: "logo_currency",
                                        style: {
                                            width: "30px",
                                            height: "30px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: option.label
                                    })
                                ]
                            }, option.label) : null;
                        })
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ var Select_SelectToken = (SelectToken);
var CustomListItem = (0,styled_components_browser_esm/* default */.ZP)(SelectToken_ListItem).withConfig({
    componentId: "sc-2b3f3ee7-6"
})(_templateObject7());

// EXTERNAL MODULE: ./node_modules/rc-virtual-list/es/index.js + 22 modules
var rc_virtual_list_es = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
;// CONCATENATED MODULE: ./src/components/Select/SelectWidthImg.tsx







function SelectWidthImg_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 0px 16px;\n    transition: border-radius 0.15s;\n    color: #fdb533;\n    gap: 1rem;\n    > svg {\n        fill: #fff !important;\n    }\n\n    @media screen and (max-width: 600px) {\n        padding: 0 10px;\n        width: 80%;\n        font-size: 12px;\n    }\n"
    ]);
    SelectWidthImg_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectWidthImg_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    @media screen and (max-width: 600px) {\n        font-size: 15px;\n    }\n"
    ]);
    SelectWidthImg_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SelectWidthImg_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 180px;\n    height: 100%;\n    max-height: 250px;\n    padding: 0;\n    position: absolute;\n    overflow-y: auto;\n    overflow-x: hidden;\n    z-index: ",
        ";\n    transition: transform 0.15s, opacity 0.15s;\n    transform: scaleY(0);\n    transform-origin: top;\n    opacity: 0;\n    box-sizing: border-box;\n    box-shadow: 0px 8px 28px 0px rgba(66, 66, 66, 0.10);\n"
    ]);
    SelectWidthImg_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SelectWidthImg_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            ",
        " {\n                height: auto;\n                transform: scaleY(1);\n                opacity: 1;\n                border-top-width: 0;\n                width: 100%;\n                background: ",
        ";\n                top: 49px;\n                border-radius: 12px;\n            }\n        "
    ]);
    SelectWidthImg_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SelectWidthImg_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n    position: relative;\n    width: 100%;\n    height: 48px;\n    border-radius: 12px;\n    box-sizing: border-box;\n    background-color: transparent;\n    border: 1px solid ",
        ";\n    ",
        " {\n        min-width: 100px;\n    }\n    ",
        "\n"
    ]);
    SelectWidthImg_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SelectWidthImg_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    z-index: ",
        ";\n"
    ]);
    SelectWidthImg_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SelectWidthImg_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    list-style: none;\n    display:flex;\n    padding: 8px 16px;\n    border-radius: 0px;\n"
    ]);
    SelectWidthImg_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SelectWidthImg_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n"
    ]);
    SelectWidthImg_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 28px;\n    height: 28px;\n    img{\n        object-fit: contain;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}









var SelectWidthImg_DropDownHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e9d1e03-0"
})(SelectWidthImg_templateObject());
var SelectWidthImg_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-3e9d1e03-1"
})(SelectWidthImg_templateObject1());
var SelectWidthImg_DropDownListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e9d1e03-2"
})(SelectWidthImg_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var SelectWidthImg_DropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e9d1e03-3"
})(SelectWidthImg_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(props) {
    return props.isOpen && (0,styled_components_browser_esm/* css */.iv)(SelectWidthImg_templateObject3(), SelectWidthImg_DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.colors.background;
    });
});
var SelectWidthImg_DropDownList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-3e9d1e03-4"
})(SelectWidthImg_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var SelectWidthImg_ListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-3e9d1e03-5"
})(SelectWidthImg_templateObject6());
var SelectWidthImg = function(_param) {
    var options = _param.options, onOptionChange = _param.onOptionChange, defaultOptionIndex = _param.defaultOptionIndex, placeHolderText = _param.placeHolderText, defaultValue = _param.defaultValue, isDefaultBrand = _param.isDefaultBrand, setIsDefaultBrand = _param.setIsDefaultBrand, isLoading = _param.isLoading, props = (0,_object_without_properties/* default */.Z)(_param, [
        "options",
        "onOptionChange",
        "defaultOptionIndex",
        "placeHolderText",
        "defaultValue",
        "isDefaultBrand",
        "setIsDefaultBrand",
        "isLoading"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var containerRef = (0,react.useRef)(null);
    var dropdownRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(false), optionSelected = ref1[0], setOptionSelected = ref1[1];
    var ref2 = (0,react.useState)(defaultOptionIndex), selectedOptionIndex = ref2[0], setSelectedOptionIndex = ref2[1];
    var ref3 = (0,react.useState)({
        width: 0,
        height: 0
    }), containerSize = ref3[0], setContainerSize = ref3[1];
    var ref4 = (0,react.useState)(""), searchQuery = ref4[0], setSearchQuery = ref4[1];
    var searchListBrand = (0,react.useMemo)(function() {
        var listItem = (0,_to_consumable_array/* default */.Z)(options);
        if (searchQuery !== "") {
            return listItem === null || listItem === void 0 ? void 0 : listItem.filter(function(item) {
                var ref, ref1;
                return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.title) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.toLowerCase());
            });
        }
        return listItem;
    }, [
        options,
        searchQuery
    ]);
    var theme = (0,useTheme/* default */.ZP)().theme;
    var toggling = function(event) {
        if (options.length >= 1) {
            setIsOpen(!isOpen);
        }
        event.stopPropagation();
    };
    var onOptionClicked = function(selectedIndex) {
        /*#__PURE__*/ return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSelectedOptionIndex(selectedIndex);
                        setIsDefaultBrand(false);
                        setIsOpen(false);
                        setOptionSelected(true);
                        return [
                            4,
                            dispatch((0,actions/* fetchListProvinceByBrandId */.XN)({
                                brandId: selectedIndex === null || selectedIndex === void 0 ? void 0 : selectedIndex.toString()
                            }))
                        ];
                    case 1:
                        _state.sent();
                        if (onOptionChange) {
                            onOptionChange(selectedIndex);
                        }
                        return [
                            2
                        ];
                }
            });
        });
    };
    var handleClickOutside = function() {
        if (containerRef.current && !containerRef.current.contains(document.activeElement)) {
            setIsOpen(false);
        }
    };
    (0,react.useEffect)(function() {
        setContainerSize({
            width: dropdownRef.current.offsetWidth,
            height: dropdownRef.current.offsetHeight
        });
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    var handleChangeBrand = function(evt) {
        var values = evt.target.value;
        var replace = values.replace(/[.*+?^${}()|[\]\\!@#%&_~]/g, "");
        setSearchQuery(replace);
    };
    var findActiveItem = options === null || options === void 0 ? void 0 : options.find(function(item) {
        var ref, ref1;
        return (item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === ((ref1 = selectedOptionIndex === null || selectedOptionIndex === void 0 ? void 0 : selectedOptionIndex.toString()) === null || ref1 === void 0 ? void 0 : ref1.toLocaleLowerCase());
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWidthImg_DropDownContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            isOpen: isOpen
        }, props), {
            ref: containerRef
        }), containerSize), {
            children: [
                containerSize.width !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectWidthImg_DropDownHeader, {
                    onClick: toggling,
                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: "Loading..."
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !optionSelected && placeHolderText && !defaultValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectWidthImg_CsText, {
                            color: !optionSelected && placeHolderText ? "text" : undefined,
                            children: placeHolderText
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsImg, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: !optionSelected && placeHolderText ? isDefaultBrand ? "/images/logo/noLogo.png" : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.images : findActiveItem === undefined ? "/images/logo/noLogo.png" : isDefaultBrand ? "/images/logo/noLogo.png" : findActiveItem === null || findActiveItem === void 0 ? void 0 : findActiveItem.images,
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectWidthImg_CsText, {
                                    color: !optionSelected && placeHolderText ? "text" : undefined,
                                    children: !optionSelected && placeHolderText ? isDefaultBrand ? "Chọn thương hiệu" : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.title : (options === null || options === void 0 ? void 0 : options.length) === 0 ? "Kh\xf4ng c\xf3 thương hiệu" : findActiveItem === undefined ? "Chọn thương hiệu" : isDefaultBrand ? "Chọn thương hiệu" : findActiveItem === null || findActiveItem === void 0 ? void 0 : findActiveItem.title
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    position: "absolute",
                    right: "16px",
                    top: "13px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                        color: "black",
                        onClick: toggling,
                        style: {
                            transform: isOpen && "rotate(180deg)"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWidthImg_DropDownListContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            height: "auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup/* default */.Z, {
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {}),
                                mb: "2px",
                                scale: "sm",
                                isHiddenBorder: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    type: "text",
                                    placeholder: "T\xecm kiếm",
                                    onChange: function(e) {
                                        return handleChangeBrand(e);
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            borderBottom: "1px solid ".concat(theme.colors.backgroundTab)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectWidthImg_DropDownList, {
                            ref: dropdownRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_virtual_list_es/* default */.Z, {
                                data: (searchListBrand === null || searchListBrand === void 0 ? void 0 : searchListBrand.length) > 0 ? searchListBrand : [],
                                height: 200,
                                itemHeight: 30,
                                itemKey: "id",
                                children: function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectWidthImg_ListItem, {
                                        onClick: onOptionClicked(item === null || item === void 0 ? void 0 : item.id),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsLazyLoad, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsImg, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (item === null || item === void 0 ? void 0 : item.images) || "/images/logo/noLogo.png",
                                                        alt: item === null || item === void 0 ? void 0 : item.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectWidthImg_CsText, {
                                                    ml: "1rem",
                                                    color: index === selectedOptionIndex ? "primary" : "text",
                                                    children: item === null || item === void 0 ? void 0 : item.title
                                                })
                                            ]
                                        })
                                    }, item === null || item === void 0 ? void 0 : item.title);
                                }
                            })
                        })
                    ]
                })
            ]
        }))
    });
};
var CsLazyLoad = (0,styled_components_browser_esm/* default */.ZP)(lib/* default */.ZP).withConfig({
    componentId: "sc-3e9d1e03-6"
})(SelectWidthImg_templateObject7());
var CsImg = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3e9d1e03-7"
})(_templateObject8());
/* harmony default export */ var Select_SelectWidthImg = (SelectWidthImg);

// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
;// CONCATENATED MODULE: ./src/views/GiftCards/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 40px;\n    @media screen and (max-width:600px) {\n        font-size: 22px;\n    }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 32px;\n    @media screen and (max-width:600px) {\n        font-size: 18px;\n    }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 40px;\n    color: ",
        ";\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    letter-spacing: 0.48px;\n    @media screen and (max-width:600px) {\n        font-size: 18px;\n    }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0px 4px;\n    font-size: 13px;\n    border-radius: 40px;\n    height: 48px;\n    @media screen and (max-width:600px){\n        font-size: 12px;\n        height: 40px;\n    }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 12px;\n    padding: 0px 4px;\n    font-size: 13px;\n    height: 48px;\n    /* &:hover{\n        background: linear-gradient(119deg, #FA9406 0%, #FFBD1D 100%);\n        color: ",
        "\n    } */\n    @media screen and (max-width:600px){\n        border-radius: 12px;\n        font-size: 12px;\n        height: 40px;\n        width: 50%;\n    }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    width: 100%;\n    grid-template-columns: repeat(4,1fr);\n    grid-gap: 1rem;\n    margin-top:2rem;\n    @media screen and (max-width:768px) {\n        grid-template-columns: repeat(2, 1fr);\n    }\n    @media screen and (max-width:600px) {\n        grid-template-columns: 1fr\n    }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 6px;\n    align-items: center;\n    background: ",
        ";\n    border: 1px solid #000;\n    border-radius: 12px;\n    width: 100%;\n    height: 47px;\n    padding: 4px;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 4px;\n    display: flex;\n    width: 36px;\n    height: 36px;\n    padding: 11px;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    box-shadow: none;\n    border-radius: 12px;\n    /* background: ",
        "; */\n    background: linear-gradient(90deg, #0367F3 0%, #03237C 100%);\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    padding: 0 1rem;\n    width: 100%;\n    height: 100%;\n    text-align: left;\n    border: none;\n    box-shadow: none;\n    font-size: 16px;\n    border-radius: 11.526px;\n    background: #EFEFEF;\n    min-width:320px;\n    width: 100%;\n    height: 48px;\n    &::placeholder {\n        color: ",
        ";\n    }\n    @media screen and (max-width: 1000px) {\n        font-size: 14px;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    padding: 0 1rem;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    border: none;\n    box-shadow: none;\n    font-size: 16px;\n    border-radius: 11.526px;\n    background: none;\n    width: 100%;\n    height: 48px;\n    font-weight: 700;\n    &::placeholder {\n        color: ",
        ";\n    }\n    @media screen and (max-width: 1000px) {\n        font-size: 14px;\n    }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #9596A6;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 124.5%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 8px;\n    border: 1px solid ",
        ";\n    padding: 1rem 2rem;\n    gap: 30px;\n    ",
        "{\n        font-size: 16px;\n    }\n    @media screen and (max-width: 768px){\n        gap: 0.5rem;\n        padding: 1rem;\n        flex-direction: column;\n        width:100%;\n        ",
        "{\n            font-size: 14px;\n        }\n    }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: block;\n    @media screen and (max-width: 768px){\n        display: none;\n    }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    flex-direction: column;\n    justify-content: space-between;\n    border-radius: 8px;\n    border: 1px solid ",
        ";\n    padding: 1rem 1rem;\n    \n    @media screen and (max-width: 768px){\n        display:none;\n        flex-direction: row;\n        padding: 1rem;\n    }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display:none;\n        @media screen and (max-width: 768px){\n            display: flex;\n            border-radius: 8px;\n            padding: 1rem 1rem;\n            flex-direction: column;\n            border: 1px solid ",
        ";\n        }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n    gap: 10px;\n    ",
        "{\n        font-size: 16px;\n        @media screen and (max-width: 768px){\n            font-size: 14px;\n        }\n    }\n    &:first-child{\n        padding-bottom: 0.5rem;\n        border-bottom: 1px solid ",
        ";\n        @media screen and (max-width: 768px){\n            padding-bottom: 0;\n        }\n    }\n    &:last-child{\n        margin-top: 1rem;\n    }\n    @media screen and (max-width: 768px){\n        flex-direction: column;\n        width: 50%;\n        &:first-child{\n            border-bottom: none;\n            padding-bottom: 0;\n            width: 32%;\n        }\n        &:last-child{\n            margin-top: 0rem;\n            width: 67%;\n        }\n    } \n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: ",
        ";\n    width: 20%;\n    @media screen and (max-width: 768px){\n        width: 100%;\n        text-align: right;\n    }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: ",
        ";\n    white-space: nowrap;\n    width: 20%;\n    @media screen and (max-width: 768px){\n        width: 100%;\n        text-align: left;\n    }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    height: 100px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    cursor: pointer;\n    padding: 0 40px;\n    .textPoint{\n        z-index: 10;\n        font-size: 20px;\n        @media screen and (max-width:768px){\n            font-size: 16px;\n        }\n    }\n    @media screen and (max-width:1000px){\n    padding: 0 20px;\n    }\n    @media screen and (max-width:768px) {\n        margin: 0 auto;\n        width: 100%;\n        height: 80px;\n    }\n    @media screen and (max-width:550px){\n        padding: 0 35px;\n    }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    justify-content: flex-start;\n    gap: 2rem;\n    @media screen and (max-width:600px) {\n        gap: 1rem;\n        flex-direction: column;    \n    }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}


var CsHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-de85f40a-0"
})(styles_templateObject());
var CsBack = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-de85f40a-1"
})(styles_templateObject1());
var CsSubHeading = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-de85f40a-2"
})(styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-de85f40a-3"
})(styles_templateObject3());
var CsButtonTab = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-de85f40a-4"
})(styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-de85f40a-5"
})(styles_templateObject5());
var GirdColum = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-de85f40a-6"
})(styles_templateObject6());
var WrapCount = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-de85f40a-7"
})(styles_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var ButtonQuanlity = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-de85f40a-8"
})(styles_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.bgBtn;
});
var CustomInput2 = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-de85f40a-9"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.default;
});
var CustomInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-de85f40a-10"
})(_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var SubBalance = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-de85f40a-11"
})(_templateObject11());
var CsButtonContinue = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-de85f40a-12"
})(_templateObject12());
var CsWrapInfo = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-de85f40a-13"
})(_templateObject13(), function(param) {
    var theme = param.theme;
    return theme.colors.border;
}, Text/* default */.Z, Text/* default */.Z);
var Hr = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-de85f40a-14"
})(_templateObject14());
var CsGiftCardInfoPC = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-de85f40a-15"
})(_templateObject15(), function(param) {
    var theme = param.theme;
    return theme.colors.border;
});
var CsGiftCardInfoMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-de85f40a-16"
})(_templateObject16(), function(param) {
    var theme = param.theme;
    return theme.colors.border;
});
var CsFlexLine = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-de85f40a-17"
})(_templateObject17(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.border;
});
var RowItem = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-de85f40a-18"
})(_templateObject18(), function(param) {
    var isFirst = param.isFirst;
    return isFirst ? "left" : "center";
});
var RowItemHeading = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-de85f40a-19"
})(_templateObject19(), function(param) {
    var isFirst = param.isFirst;
    return isFirst ? "left" : "center";
});
var Card = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-de85f40a-20"
})(_templateObject20());
var CsTagPrice = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-de85f40a-21"
})(_templateObject21());
var CsFlexCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-de85f40a-22"
})(_templateObject22());

;// CONCATENATED MODULE: ./src/views/GiftCards/components/Filter.tsx
/* eslint-disable no-param-reassign */ 
function Filter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: transparent;\n    outline: none;\n    border: none;\n    width: 100%;\n    height: 100%;\n    font-weight: bold;\n    font-size: 16px;\n    text-align: center;\n    color:",
        ";\n    &:focus-visible {\n        outline: none;\n    }\n    ::placeholder { \n        color:",
        ";\n        opacity: 1; \n    }\n"
    ]);
    Filter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var Filter = function(param) {
    var setFillAmount = param.setFillAmount, fillAmount = param.fillAmount, setSelectBrand = param.setSelectBrand, selectBrand = param.selectBrand, handleChangeInput = param.handleChangeInput, handleSelectReliGion = param.handleSelectReliGion, resultFilterProvince = param.resultFilterProvince, isError = param.isError, isDefaultBrand = param.isDefaultBrand, isDefaultProvince = param.isDefaultProvince, setIsDefaultBrand = param.setIsDefaultBrand, stockQuantity = param.stockQuantity, filterIsPrice = param.filterIsPrice, filterIsProduct = param.filterIsProduct, findProductRoute = param.findProductRoute, cardPrice = param.cardPrice, cardProduct = param.cardProduct, viewTag = param.viewTag, selectCategory = param.selectCategory, priceRoute = param.priceRoute, brandRoute = param.brandRoute, setOptionSelected = param.setOptionSelected, optionSelected = param.optionSelected, setCardPrice = param.setCardPrice;
    var dispatch = (0,es/* useDispatch */.I0)();
    var dataGiftcards = (0,giftCards/* GetDataGiftCards */.n3)();
    var ListBrand = dataGiftcards.ListBrand, ListProvinceByBrandStore = dataGiftcards.ListProvinceByBrand, isLoading = dataGiftcards.isLoading, tokenSupport = dataGiftcards.tokenSupport, activeTokenPayment = dataGiftcards.activeTokenPayment;
    var ref = (0,react.useState)([]), listProvinceByBrandState = ref[0], setListProvinceByBrandState = ref[1];
    var ref1 = (0,react.useState)(null), selectedOption = ref1[0], setSelectedOption = ref1[1];
    (0,react.useEffect)(function() {
        if (ListProvinceByBrandStore) {
            setListProvinceByBrandState(ListProvinceByBrandStore);
        }
    }, [
        ListProvinceByBrandStore
    ]);
    var handleChangeFillAmount = function(option) {
        if (option === 1) {
            setFillAmount(Number(fillAmount) - 1);
        }
        if (option === 2) {
            setFillAmount(Number(fillAmount) + 1);
        }
    };
    var handleSelectBrand = function(option) {
        if (option === undefined) {
            setSelectBrand(option === null || option === void 0 ? void 0 : option.id);
        }
        if (option !== undefined) {
            setSelectBrand(ListBrand === null || ListBrand === void 0 ? void 0 : ListBrand.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.id) === option;
            }));
        }
        setCardPrice(null);
    };
    var handleSelectToken = function(option) {
        dispatch((0,actions/* fetchActiveTokenPayment */.AY)({
            activeTokenPayment: option === null || option === void 0 ? void 0 : option.value
        }));
    };
    var allOption = [
        {
            provinceId: "0",
            provinceName: "Tất cả c\xe1c tỉnh th\xe0nh"
        }
    ];
    var FilterIsBrandId = function() {
        var mapListProvinceByBrband = listProvinceByBrandState === null || listProvinceByBrandState === void 0 ? void 0 : listProvinceByBrandState.map(function(item) {
            if (!item) {
                return [];
            }
            return province === null || province === void 0 ? void 0 : province.find(function(it) {
                var ref;
                return (it === null || it === void 0 ? void 0 : (ref = it.provinceId) === null || ref === void 0 ? void 0 : ref.toString()) === (item === null || item === void 0 ? void 0 : item.toString());
            });
        });
        var concatProvince = allOption === null || allOption === void 0 ? void 0 : allOption.concat(mapListProvinceByBrband);
        var filterRemoveUndefine = concatProvince === null || concatProvince === void 0 ? void 0 : concatProvince.filter(function(dt) {
            return dt !== undefined;
        });
        return filterRemoveUndefine;
    };
    var resultFilterIsBrandId = FilterIsBrandId();
    (0,react.useEffect)(function() {
        if (resultFilterIsBrandId && Number(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceId) !== 0 && !Number.isNaN(Number(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.provinceId))) {
            dispatch((0,actions/* fetchListProvince */.ee)({
                listProvince: resultFilterIsBrandId
            }));
        }
    // dispatch(fetchListProvince({listProvince: province}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listProvinceByBrandState,
        selectedOption,
        selectBrand,
        isLoading,
        dispatch
    ]);
    var renderOptionsToken = (0,react.useMemo)(function() {
        var option = tokenSupport === null || tokenSupport === void 0 ? void 0 : tokenSupport.map(function(dt) {
            var ref, ref1;
            return {
                label: dt === null || dt === void 0 ? void 0 : (ref = dt.token) === null || ref === void 0 ? void 0 : ref.symbol,
                value: dt === null || dt === void 0 ? void 0 : (ref1 = dt.token) === null || ref1 === void 0 ? void 0 : ref1.address,
                tokens: dt === null || dt === void 0 ? void 0 : dt.token
            };
        });
        return option;
    }, [
        tokenSupport
    ]);
    (0,react.useEffect)(function() {
        if (!activeTokenPayment) {
            var ref;
            dispatch((0,actions/* fetchActiveTokenPayment */.AY)({
                activeTokenPayment: (ref = renderOptionsToken[0]) === null || ref === void 0 ? void 0 : ref.value
            }));
        }
    }, [
        activeTokenPayment,
        dispatch,
        renderOptionsToken
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GirdColum, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
                mt: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontWeight: "bold",
                                children: "Tỉnh th\xe0nh"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProvince, {
                            style: {
                                marginTop: "10px"
                            },
                            options: resultFilterIsBrandId,
                            placeHolderText: "Chọn tỉnh th\xe0nh",
                            onOptionChange: function(e) {
                                return handleSelectReliGion(e);
                            },
                            isDefaultProvince: isDefaultProvince,
                            selectCategory: selectCategory,
                            isLoading: isLoading,
                            selectBrand: selectBrand,
                            setSelectedOption: setSelectedOption,
                            selectedOption: selectedOption,
                            priceRoute: priceRoute,
                            brandRoute: brandRoute,
                            setOptionSelected: setOptionSelected,
                            optionSelected: optionSelected
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
                mt: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            mb: "10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontWeight: "bold",
                                    children: "Thương hiệu"
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    ml: "4px",
                                    color: "red",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_SelectWidthImg, {
                            options: resultFilterProvince,
                            placeHolderText: "Chọn thương hiệu",
                            onOptionChange: handleSelectBrand,
                            defaultValue: selectBrand,
                            isDefaultBrand: isDefaultBrand,
                            setIsDefaultBrand: setIsDefaultBrand,
                            isLoading: isLoading
                        }),
                        isError && selectBrand === undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: [
                                "14px",
                                ,
                                "16px"
                            ],
                            mt: "0.5rem",
                            color: "red",
                            children: "Vui l\xf2ng chọn thương hiệu"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
                mt: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontWeight: "bold",
                                    children: "Số lượng đổi"
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    ml: "4px",
                                    color: "red",
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapCount, {
                            style: {
                                marginTop: "10px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonQuanlity, {
                                    disabled: fillAmount < 2,
                                    onClick: function() {
                                        return handleChangeFillAmount(1);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                                        fill: "white"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsNumericFormat, {
                                    value: fillAmount,
                                    decimalScale: 0,
                                    thousandSeparator: !false,
                                    placeholder: "1",
                                    // eslint-disable-next-line no-return-assign, no-param-reassign
                                    onFocus: function(e) {
                                        return e.target.placeholder = "";
                                    },
                                    onChange: function(evt) {
                                        var ref;
                                        var value = evt === null || evt === void 0 ? void 0 : (ref = evt.target) === null || ref === void 0 ? void 0 : ref.value;
                                        handleChangeInput(value.split(",").join(""));
                                    },
                                    maxLength: 35,
                                    allowNegative: false
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonQuanlity, {
                                    disabled: fillAmount >= 30 || fillAmount >= stockQuantity,
                                    onClick: function() {
                                        return handleChangeFillAmount(2);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {})
                                })
                            ]
                        }),
                        isError && Number(fillAmount) <= 0 && (cardProduct || cardPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "red",
                            mt: "0.5rem",
                            fontSize: [
                                "14px",
                                ,
                                "16px"
                            ],
                            children: "Số lượng đổi phải lớn hơn 0"
                        }),
                        viewTag === "2" && isError && Number(fillAmount) > Number(stockQuantity) && cardProduct || viewTag === "1" && isError && Number(fillAmount) > Number(stockQuantity) && cardPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            color: "red",
                            mt: "0.5rem",
                            fontSize: [
                                "14px",
                                ,
                                "16px"
                            ],
                            children: [
                                "Vui l\xf2ng nhập số lượng nhỏ hơn hoặc bằng ",
                                stockQuantity
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: Number(fillAmount) > 30 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "red",
                                mt: "0.5rem",
                                fontSize: [
                                    "14px",
                                    ,
                                    "16px"
                                ],
                                children: "Vui l\xf2ng nhập số lượng nhỏ hơn hoặc bằng 30"
                            })
                        }),
                        (filterIsPrice || cardPrice || filterIsProduct || cardProduct || findProductRoute) && !isDefaultBrand && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            maxWidth: "100%",
                            justifyContent: [
                                "space-between",
                                ,
                                "flex-end"
                            ],
                            mt: "1.5rem",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "50%",
                                    fontSize: [
                                        "14px",
                                        ,
                                        "16px"
                                    ],
                                    children: "Số lượng c\xf2n lại"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    textAlign: "right",
                                    width: "50%",
                                    fontSize: [
                                        "14px",
                                        ,
                                        "16px"
                                    ],
                                    children: [
                                        stockQuantity,
                                        " thẻ qu\xe0"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
                mt: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            mb: "10px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontWeight: "bold",
                                children: "Phương thức quy đổi"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_SelectToken, {
                            options: renderOptionsToken,
                            placeHolderText: "Chọn phương thức quy đổi",
                            onOptionChange: handleSelectToken,
                            value: activeTokenPayment
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_Filter = (Filter);
var CsNumericFormat = (0,styled_components_browser_esm/* default */.ZP)(react_number_format_es/* default */.Z).withConfig({
    componentId: "sc-636e5172-0"
})(Filter_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
function setSelectedToken(value) {
    throw new Error("Function not implemented.");
}

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TagPrice2.tsx
var TagPrice2 = __webpack_require__(21234);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TagPriceActive.tsx
var TagPriceActive = __webpack_require__(28245);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowRightCircle.tsx
var ArrowRightCircle = __webpack_require__(41057);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowLeftCircle2.tsx
var ArrowLeftCircle2 = __webpack_require__(40542);
;// CONCATENATED MODULE: ./src/views/GiftCards/components/Card.tsx

function Card_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 22px;\n    background: #FFF;\n    box-shadow: 0px 12px 54px 0px rgba(210, 208, 208, 0.337);\n    &:hover{\n        box-shadow: rgb(198 135 0 / 61%) 0px 1px 8px;\n        cursor: pointer;\n    }\n    @media screen and (max-width:768px) {\n        box-shadow: 0px 12px 54px 0px rgba(156, 156, 156, 0.335);\n            \n    ",
        "\n    }\n    \n    ",
        "\n"
    ]);
    Card_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Card_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 10px;\n    border-radius: 22px;\n    position: relative;\n    margin: 0 auto;\n    height: 230px;\n    overflow: hidden;\n    img{\n        height: 200px;\n        object-fit: cover;\n        margin: 0 auto;\n        width: 100%;\n    }\n    @media screen and (max-width:768px) {\n        padding: 10px;\n        height: 230px;\n        img{\n            height: 230px;\n        }\n    }\n    @media screen and (max-width:600px) {\n        padding: 8px;\n        height: 200px;\n        img{\n            height: 180px;\n        }\n    }\n"
    ]);
    Card_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Card_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #141416;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 140%;\n    padding: 0 20px;\n    @media screen and (max-width:1024px) {\n        font-size: 16px;\n    }\n"
    ]);
    Card_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Card_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #FCA912;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 140%;\n    @media screen and (max-width:1024px) {\n        font-size: 14px;\n    }\n"
    ]);
    Card_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Card_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #9596A6;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 140%;\n    text-decoration-line: line-through;\n    @media screen and (max-width:1024px) {\n        font-size: 14px;\n    }\n"
    ]);
    Card_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Card_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 30px;\n    right: 30px;\n    /* width: 60%; */\n    padding: 10px;\n    border-radius: 9.44px;\n    border: 1.18px solid rgba(28, 29, 32, 0.08);\n    background: rgba(28, 29, 32, 0.35);\n    box-shadow: 0px 4.72005033493042px 14.16015338897705px 0px rgba(28, 29, 32, 0.08);\n    backdrop-filter: blur(2.36002516746521px);\n    color: ",
        "\n"
    ]);
    Card_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var CardItem = function(param) {
    var name = param.name, image = param.image, pricePromo = param.pricePromo, priceOrigin = param.priceOrigin, unit = param.unit, date = param.date, index = param.index, onClick = param.onClick, activeItem = param.activeItem, itemId = param.itemId, isDefaultBrand = param.isDefaultBrand, isPromo = param.isPromo, startPromo = param.startPromo, endPromo = param.endPromo, isActive = param.isActive;
    var isActive2 = (0,react.useMemo)(function() {
        if (Number(activeItem === null || activeItem === void 0 ? void 0 : activeItem.id) === Number(itemId) && isDefaultBrand === false) return !false;
        return false;
    }, [
        activeItem === null || activeItem === void 0 ? void 0 : activeItem.id,
        itemId,
        isDefaultBrand
    ]);
    var currentTime = Math.floor(new Date().getTime() / 1000);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsWrapperCard, {
        onClick: onClick,
        isActive: isActive || isActive2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_CsImg, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: !image ? "/images/giftcards/noProduct.png" : image,
                        alt: name
                    }),
                    date !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsTextDate, {
                        children: [
                            "Hạn sử dụng: ",
                            date
                        ]
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsName, {
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                padding: "20px",
                mt: [
                    "0rem",
                    ,
                    "1rem"
                ],
                mb: [
                    "0rem",
                    ,
                    "1rem"
                ],
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextPrice, {
                        children: [
                            (0,formatNumber/* formatNumber */.u)(priceOrigin),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: unit
                            }),
                            " "
                        ]
                    }),
                    isPromo && Number(currentTime) > Number(startPromo) && Number(currentTime) < Number(endPromo) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextPriceOrigin, {
                        fontWeight: "700",
                        color: "white",
                        style: {
                            zIndex: 10
                        },
                        children: [
                            Number(pricePromo).toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            }),
                            unit
                        ]
                    }) : ""
                ]
            })
        ]
    }, index);
};
var CsWrapperCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9f8c5ea2-0"
})(Card_templateObject(), function(param) {
    var isActive = param.isActive;
    if (isActive) {
        return "\n                box-shadow: rgb(198 135 0 / 61%) 0px 1px 8px;\n            ";
    }
    return "";
}, function(param) {
    var isActive = param.isActive;
    if (isActive) {
        return "\n                box-shadow: rgb(198 135 0 / 61%) 0px 1px 8px;\n            ";
    }
    return "";
});
var Card_CsImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9f8c5ea2-1"
})(Card_templateObject1());
var CsName = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-9f8c5ea2-2"
})(Card_templateObject2());
var TextPrice = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-9f8c5ea2-3"
})(Card_templateObject3());
var TextPriceOrigin = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-9f8c5ea2-4"
})(Card_templateObject4());
var CsTextDate = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-9f8c5ea2-5"
})(Card_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
/* harmony default export */ var components_Card = (CardItem);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowRightIcon.tsx
var ArrowRightIcon = __webpack_require__(7728);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowLeftIcon.tsx
var ArrowLeftIcon = __webpack_require__(73482);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(11358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
;// CONCATENATED MODULE: ./src/views/GiftCards/components/CustomPaginate2.tsx


function CustomPaginate2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:100%;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    justify-content:center;\n    height:62px;\n    .pagination {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-around;\n        align-items: center;\n        @media screen and (max-width: 600px) {\n            width: 100%;\n            justify-content:center;\n        }\n        * {\n            list-style-type: none;\n        }\n    }\n    .page-item {\n        margin: 0 0.375rem;\n        &:first-child,\n        &:last-child {\n            a {\n                &:hover {\n                    color:#F78E01;\n                    border: none !important;\n                }\n            }\n        }\n        &:first-child,\n        &:last-child {\n            a {\n                border: none;\n                background: none !important;\n            }\n        }\n        &:last-child.disabled,\n        &:first-child.disabled {\n            cursor: not-allowed;\n        }\n        &:active{\n            a{\n                svg{\n                    fill: #F78E01;\n                    path{\n                        fill: white;\n                    }\n                }\n                circle{\n                    fill: #F78E01;\n                }\n            }\n        }\n        &:hover{\n            a{\n                svg{\n                    background: #F78E01;\n                    border-radius: 50%;\n                    fill: #F78E01;\n                    path{\n                        fill: white;\n                    }\n                }\n                circle{\n                    fill: #F78E01;\n                }\n            }\n        }\n    }\n    .page-link {\n        width: 32px;\n        height: 32px;\n        display: flex;\n        background: #fff;\n        align-items: center;\n        justify-content: center;\n        border-radius: 100% !important;\n        color: #9596A6;\n        border: 1px solid #efefef;\n        svg{\n            border-radius:100%;\n            background:linear-gradient(132deg, #FFC120 0%, #F78E01 100%) !important;\n        }\n        svg path{\n            fill: #fff !important;\n        }\n        @media screen and (max-width: 768px) {\n            padding: 12px;\n        }\n        @media screen and (max-width: 768px) {\n            padding: 12px;\n        }\n        &:focus {\n            box-shadow: none !important;\n        }\n        &:hover {\n            border: 2px solid #F78E01 !important;\n        }\n    }\n    .page-item.disabled .page-link {\n        background: ",
        ";\n        cursor: not-allowed !important;\n        opacity: 0.7;\n        pointer-events: none;\n        svg{\n            border-radius:100%;\n            background: #D9D9D9 !important;\n        }\n        svg path{\n            fill: #9596A6 !important;\n        }\n    }\n    .page-item.active .page-link {\n        border: 2px solid #F78E01 !important;\n    }\n"
    ]);
    CustomPaginate2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CustomPaginate2 = function(param) {
    var total = param.total, pageSize = param.pageSize, setItemOffset = param.setItemOffset;
    var offset = total % pageSize === 0 ? 0 : 1;
    var perPage = Math.floor(total / pageSize);
    var pageCount = perPage + offset;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), pageActive = ref[0], setPageActive = ref[1];
    var handlePageClick = function(event) {
        setPageActive(event.selected);
        setItemOffset(event.selected * pageSize);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFlex, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
            nextLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, {
                color: "#f6f6f6"
            }),
            previousLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* default */.Z, {
                color: "#f6f6f6"
            }),
            onPageChange: handlePageClick,
            pageCount: pageCount,
            pageClassName: "page-item",
            pageLinkClassName: "page-link",
            previousClassName: "page-item",
            previousLinkClassName: "page-link",
            nextClassName: "page-item",
            nextLinkClassName: "page-link",
            breakLabel: "...",
            breakClassName: "page-item",
            breakLinkClassName: "page-link",
            containerClassName: "pagination",
            activeClassName: "active",
            renderOnZeroPageCount: null,
            forcePage: pageActive
        })
    });
};
var CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-daf435aa-0"
})(CustomPaginate2_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
});

;// CONCATENATED MODULE: ./src/views/GiftCards/components/GiftCardList.tsx


function GiftCardList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 20px;\n    @media screen and (min-width:768px) and (max-width: 1000px) {\n        padding: 0 40px;\n    }\n    @media screen and (max-width:600px){\n        padding: 0 10px;\n    }\n"
    ]);
    GiftCardList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GiftCardList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        z-index: 10;\n        font-size: 20px;\n    @media screen and (min-width:768px) and (max-width: 1000px) {\n        font-size: 24px;\n    }\n    @media screen and (max-width:600px) {\n        font-size: 18px;\n    }\n"
    ]);
    GiftCardList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GiftCardList_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 2rem;\n    width: 100% !important;\n    height: 100%;\n    display: grid;\n    grid-gap: 1rem;\n    grid-template-columns: repeat(4, 1fr);\n    @media screen and (max-width:768px) {\n        display: none;\n    }\n"
    ]);
    GiftCardList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GiftCardList_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n    .swiper-initialized, .swiper-horizontal, .swiper-pointer-events{\n        width: 100%;\n        overflow: unset;\n    }\n    @media screen and (max-width:768px) {\n        display: flex;\n        gap: 1rem;\n    }\n"
    ]);
    GiftCardList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function GiftCardList_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 2rem;\n    width: 100%;\n    display: grid;\n    grid-gap: 1rem;\n    align-items: center;\n    grid-template-columns: repeat(5, 1fr);\n    z-index:0;\n    @media screen and (max-width:768px) {\n        width: 100%;\n        justify-content: center;\n        grid-template-columns: repeat(2, 1fr);\n    }\n"
    ]);
    GiftCardList_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function GiftCardList_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: flex;\n    @media screen and (max-width:768px) {\n        display: none;\n    }\n\n"
    ]);
    GiftCardList_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function GiftCardList_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 187px;\n    height: 74px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    @media screen and (max-width:768px) {\n        margin: 0 auto;\n        height: 120px;\n        width: 90%;\n    }\n    @media screen and (max-width:600px) {\n        margin: 0 auto;\n        width: 100%;\n        height: 74px;\n    }\n"
    ]);
    GiftCardList_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function GiftCardList_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n"
    ]);
    GiftCardList_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function GiftCardList_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n    @media screen and (max-width: 1023px){\n        display: flex;\n        cursor: pointer;\n        width: 40px;\n        height: 40px;\n        justify-content: center;\n        &:active{\n            border: 1px solid red;\n            border-radius: 50%;\n            border: 2px solid ",
        ";\n        }\n    }\n"
    ]);
    GiftCardList_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function GiftCardList_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-decoration: ",
        ";\n    color: ",
        ";\n    z-index: 100;\n    font-size: ",
        ";\n    font-weight: ",
        ";\n"
    ]);
    GiftCardList_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}











var GiftCardList = function(param) {
    var viewTag = param.viewTag, setViewTag = param.setViewTag, priceItem = param.priceItem, handleSelectPrice = param.handleSelectPrice, handleSelectCard = param.handleSelectCard, brandItem = param.brandItem, sortBrandItemOne = param.sortBrandItemOne, sortBrandItemTwo = param.sortBrandItemTwo, activeItem = param.activeItem, isDefaultBrand = param.isDefaultBrand, isDiffercent = param.isDiffercent, isResultFilterProvince = param.isResultFilterProvince;
    var sliderSettingsCard = {
        320: {
            slidesPerView: 1,
            spaceBetween: 4
        },
        680: {
            slidesPerView: 2,
            spaceBetween: 8
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 4
        },
        1366: {
            slidesPerView: 3,
            spaceBetween: 3
        }
    };
    var swiperRef = (0,react.useRef)();
    var ref = (0,react.useState)(0), itemOffset = ref[0], setItemOffset = ref[1];
    var ref1 = (0,react.useState)([]), currentItem = ref1[0], setCurrentItems = ref1[1];
    var total = Math.ceil(sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.length);
    (0,react.useEffect)(function() {
        var endOffset = itemOffset + config/* PAGE_SIZE */.IV;
        setCurrentItems(sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.slice(itemOffset, endOffset));
    }, [
        itemOffset,
        sortBrandItemTwo
    ]);
    var resultListByAddress = function() {
        return Array.from(new Set(sortBrandItemOne === null || sortBrandItemOne === void 0 ? void 0 : sortBrandItemOne.map(function(s) {
            var ref;
            return s === null || s === void 0 ? void 0 : (ref = s.price) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        }))).map(function(item) {
            return (0,_object_spread/* default */.Z)({
                item: item
            }, sortBrandItemOne === null || sortBrandItemOne === void 0 ? void 0 : sortBrandItemOne.find(function(it) {
                var ref;
                return (it === null || it === void 0 ? void 0 : (ref = it.price) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (item === null || item === void 0 ? void 0 : item.toLowerCase());
            }));
        });
    };
    var resultReduceData = resultListByAddress();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        children: viewTag === "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isResultFilterProvince && /*#__PURE__*/ (0,jsx_runtime.jsx)(CsListTagPrice, {
                children: resultReduceData === null || resultReduceData === void 0 ? void 0 : resultReduceData.map(function(item) {
                    var currentTime = Math.floor(new Date().getTime() / 1000);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GiftCardList_Card, {
                        onClick: function() {
                            return handleSelectPrice(item);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GiftCardList_CsFlexCard, {
                                width: "100%",
                                alignItems: "center",
                                flexDirection: "column",
                                children: [
                                    Number(item === null || item === void 0 ? void 0 : item.is_promo) === 2 && Number(currentTime) > Number(item === null || item === void 0 ? void 0 : item.start_promo) && Number(currentTime) < Number(item === null || item === void 0 ? void 0 : item.end_promo) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsTextCard, {
                                        fontWeight: "700",
                                        color: new bignumber/* default */.Z(priceItem).isEqualTo(Number(item === null || item === void 0 ? void 0 : item.price)) ? "white !important" : "primary",
                                        children: [
                                            Number(item === null || item === void 0 ? void 0 : item.price_promo).toLocaleString("en", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            }),
                                            config/* UNIT_TOKEN */.eC,
                                            "1"
                                        ]
                                    }) : "",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: isDefaultBrand ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextPromotion, {
                                            color: "primary",
                                            isPromo: Number(item === null || item === void 0 ? void 0 : item.is_promo) === 2,
                                            children: [
                                                Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0
                                                }),
                                                config/* UNIT_TOKEN */.eC,
                                                "2"
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextPromotion, {
                                            isPromo: Number(item === null || item === void 0 ? void 0 : item.is_promo) === 2,
                                            color: new bignumber/* default */.Z(priceItem).isEqualTo(Number(item === null || item === void 0 ? void 0 : item.price)) ? "white !important" : "primary",
                                            children: [
                                                Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0
                                                }),
                                                config/* UNIT_TOKEN */.eC
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftCardList_CsTagPrice, {
                                children: isDefaultBrand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TagPrice2/* default */.Z, {
                                    width: "100%"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: new bignumber/* default */.Z(priceItem).isEqualTo(item === null || item === void 0 ? void 0 : item.price) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TagPriceActive/* default */.Z, {
                                        width: "100%"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TagPrice2/* default */.Z, {
                                        width: "100%"
                                    })
                                })
                            })
                        ]
                    });
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isResultFilterProvince && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        height: (sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.length) !== 0 && "100%",
                        flexDirection: "column",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsListCard, {
                                children: currentItem === null || currentItem === void 0 ? void 0 : currentItem.map(function(item, index) {
                                    var ref;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Card, {
                                        index: index,
                                        name: item === null || item === void 0 ? void 0 : (ref = item.title) === null || ref === void 0 ? void 0 : ref.replaceAll("UrBox", "GiftCards"),
                                        image: item === null || item === void 0 ? void 0 : item.image,
                                        isPromo: Number(item === null || item === void 0 ? void 0 : item.is_promo) === 2,
                                        startPromo: item === null || item === void 0 ? void 0 : item.start_promo,
                                        endPromo: item === null || item === void 0 ? void 0 : item.end_promo,
                                        pricePromo: item === null || item === void 0 ? void 0 : item.price_promo,
                                        priceOrigin: item === null || item === void 0 ? void 0 : item.price,
                                        unit: config/* UNIT_TOKEN */.eC,
                                        date: item === null || item === void 0 ? void 0 : item.expire_duration,
                                        onClick: function() {
                                            return handleSelectCard(item);
                                        },
                                        activeItem: activeItem,
                                        itemId: item === null || item === void 0 ? void 0 : item.id,
                                        isDefaultBrand: isDefaultBrand
                                    });
                                })
                            }),
                            (sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexPagination, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPaginate2, {
                                    total: total,
                                    pageSize: config/* PAGE_SIZE */.IV,
                                    setItemOffset: setItemOffset
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsListCardMobile, {
                        flexDirection: "column",
                        width: "100%",
                        style: {
                            gap: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                alignItems: "center",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                style: {
                                    gap: "1rem"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                    slidesPerView: 5,
                                    pagination: {
                                        clickable: true
                                    },
                                    onSlideChange: function() {
                                        return console.log("slide change");
                                    },
                                    onSwiper: function(swiper) {
                                        return console.log(swiper);
                                    },
                                    spaceBetween: 0,
                                    breakpoints: sliderSettingsCard,
                                    modules: [
                                        swiper_esm/* Navigation */.W_
                                    ],
                                    onBeforeInit: function(swiper) {
                                        swiperRef.current = swiper;
                                    },
                                    children: sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: function(param) {
                                                var isActive = param.isActive;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_Card, {
                                                    name: item === null || item === void 0 ? void 0 : item.brand_name,
                                                    image: item === null || item === void 0 ? void 0 : item.image,
                                                    pricePromo: item === null || item === void 0 ? void 0 : item.price_promo,
                                                    priceOrigin: item === null || item === void 0 ? void 0 : item.price,
                                                    unit: config/* UNIT_TOKEN */.eC,
                                                    date: item === null || item === void 0 ? void 0 : item.expire_duration,
                                                    index: index,
                                                    onClick: function() {
                                                        return handleSelectCard(item);
                                                    },
                                                    itemId: item === null || item === void 0 ? void 0 : item.id,
                                                    activeItem: activeItem,
                                                    isDefaultBrand: isDefaultBrand,
                                                    isActive: Number(activeItem === null || activeItem === void 0 ? void 0 : activeItem.price) === Number(item === null || item === void 0 ? void 0 : item.price)
                                                });
                                            }
                                        });
                                    })
                                })
                            }),
                            (sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "row",
                                width: "100%",
                                justifyContent: "center",
                                style: {
                                    gap: "1rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexNext, {
                                        onClick: function() {
                                            var ref;
                                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightCircle/* default */.Z, {
                                            width: "32px",
                                            style: {
                                                cursor: "pointer",
                                                transform: "rotate(180deg)"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexNext, {
                                        onClick: function() {
                                            var ref;
                                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftCircle2/* default */.Z, {
                                            width: "32px",
                                            style: {
                                                cursor: "pointer",
                                                transform: "rotate(180deg)"
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var GiftCardList_CsFlexCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1a175d72-0"
})(GiftCardList_templateObject());
var CsTextCard = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-1a175d72-1"
})(GiftCardList_templateObject1());
var CsListCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1a175d72-2"
})(GiftCardList_templateObject2());
var CsListCardMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1a175d72-3"
})(GiftCardList_templateObject3());
var CsListTagPrice = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1a175d72-4"
})(GiftCardList_templateObject4());
var CsFlexPagination = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1a175d72-5"
})(GiftCardList_templateObject5());
var GiftCardList_Card = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1a175d72-6"
})(GiftCardList_templateObject6());
var GiftCardList_CsTagPrice = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1a175d72-7"
})(GiftCardList_templateObject7());
var CsFlexNext = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1a175d72-8"
})(GiftCardList_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
});
var TextPromotion = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-1a175d72-9"
})(GiftCardList_templateObject9(), function(param) {
    var isPromo = param.isPromo;
    return isPromo ? "line-through" : "none";
}, function(param) {
    var theme = param.theme, isPromo = param.isPromo;
    return isPromo ? theme.colors.default : theme.colors.primary;
}, function(param) {
    var isPromo = param.isPromo;
    return isPromo ? "14px" : "16px";
}, function(param) {
    var isPromo = param.isPromo;
    return isPromo ? "400" : "700";
});
/* harmony default export */ var components_GiftCardList = (GiftCardList);

// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/CheckboxV2.tsx
var CheckboxV2 = __webpack_require__(54379);
;// CONCATENATED MODULE: ./src/views/GiftCards/config.ts
var listPrice = [
    {
        value: "100000",
        unit: "VNDC"
    },
    {
        value: "200000",
        unit: "VNDC"
    },
    {
        value: "500000",
        unit: "VNDC"
    },
    {
        value: "1000000",
        unit: "VNDC"
    },
    {
        value: "2000000",
        unit: "VNDC"
    }
];
var listPrice2 = [
    {
        name: "50.000",
        value: 50000
    },
    {
        name: "100.000",
        value: 100000
    },
    {
        name: "200.000",
        value: 200000
    },
    {
        name: "500.000",
        value: 500000
    },
    {
        name: "1.000.000",
        value: 1000000
    }
];
var listBrand = [
    {
        name: "Tất cả",
        value: 0
    },
    {
        name: "Đồ uống",
        value: 1
    },
    {
        name: "Đồ ăn",
        value: 2
    },
    {
        name: "Giải tr\xed",
        value: 3
    },
    {
        name: "L\xe0m đẹp - Sức khoẻ",
        value: 4
    },
    {
        name: "Mua sắm",
        value: 5
    },
    {
        name: "Tiện \xedch",
        value: 6
    },
    {
        name: "Dịch vụ s\xe2n bay",
        value: 7
    }
];
var ListformReceipt = [
    {
        label: "Gửi qua Email",
        value: "email"
    },
    {
        label: "Gửi qua Zalo",
        value: "zalo"
    }
];
var ListRegion = [
    {
        label: "An Giang",
        value: 0,
        tokens: ""
    },
    {
        label: "B\xe0 Rịa - Vũng T\xe0u",
        value: 1
    },
    {
        label: "Cần Thơ",
        value: 2
    },
    {
        label: "B\xecnh Dương",
        value: 3
    },
    {
        label: "B\xecnh Thuận",
        value: 4
    },
    {
        label: "C\xe0 Mau",
        value: 5
    },
    {
        label: "Bạc Li\xeau",
        value: 6
    }, 
];
var listTradeMark = [
    {
        name: "highlands",
        image: "/images/logo/highlands.png"
    },
    {
        name: "phuclong",
        image: "/images/logo/phuclong.png"
    },
    {
        name: "coopmart",
        image: "/images/logo/coopmart.png"
    },
    {
        name: "dingtea",
        image: "/images/logo/dingtea.png"
    },
    {
        name: "jollibee",
        image: "/images/logo/jollibee.png"
    },
    {
        name: "cgv",
        image: "/images/logo/cgv.png"
    },
    {
        name: "vascara",
        image: "/images/logo/vascara.png"
    },
    {
        name: "manuah",
        image: "/images/logo/manuah.png"
    },
    {
        name: "sulwhasoo",
        image: "/images/logo/dingtea.png"
    },
    {
        name: "levis",
        image: "/images/logo/levis.png"
    },
    {
        name: "br",
        image: "/images/logo/br.png"
    },
    {
        name: "kfc",
        image: "/images/logo/kfc.png"
    },
    {
        name: "galaxyplay",
        image: "/images/logo/galaxyplay.png"
    },
    {
        name: "go",
        image: "/images/logo/go.png"
    },
    {
        name: "starbucks",
        image: "/images/logo/starbucks.png"
    }, 
];
var ViewTag = [
    {
        title: "Điểm voucher",
        value: "1"
    },
    {
        title: "Sản phẩm nổi bật",
        value: "2"
    }, 
];
var listCard = [
    {
        id: 1,
        name: "[E-voucher sản phẩm] KFC combo 5 B\xe1nh Trứng",
        image: "/images/banner/test.png",
        price: "69000",
        priceOrigin: "89000",
        unit: "VNDC",
        date: 60
    },
    {
        id: 2,
        name: "[E-voucher sản phẩm] KFC combo 5 B\xe1nh Trứng",
        image: "/images/banner/test.png",
        price: "69000",
        priceOrigin: "89000",
        unit: "VNDC",
        date: 60
    },
    {
        id: 3,
        name: "[E-voucher sản phẩm] KFC combo 5 B\xe1nh Trứng",
        image: "/images/banner/test.png",
        price: "69000",
        priceOrigin: "89000",
        unit: "VNDC",
        date: 60
    },
    {
        id: 4,
        name: "[E-voucher sản phẩm] KFC combo 5 B\xe1nh Trứng",
        image: "/images/banner/test.png",
        price: "69000",
        priceOrigin: "89000",
        unit: "VNDC",
        date: 60
    },
    {
        id: 5,
        name: "[E-voucher sản phẩm] KFC combo 5 B\xe1nh Trứng",
        image: "/images/banner/test.png",
        price: "69000",
        priceOrigin: "89000",
        unit: "VNDC",
        date: 60
    },
    {
        id: 6,
        name: "[E-voucher sản phẩm] KFC combo 5 B\xe1nh Trứng",
        image: "/images/banner/test.png",
        price: "69000",
        priceOrigin: "89000",
        unit: "VNDC",
        date: 60
    },
    {
        id: 7,
        name: "[E-voucher sản phẩm] KFC combo 5 B\xe1nh Trứng",
        image: "/images/banner/test.png",
        price: "69000",
        priceOrigin: "89000",
        unit: "VNDC",
        date: 60
    }, 
];

;// CONCATENATED MODULE: ./src/views/GiftCards/components/Info.tsx

function Info_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n    height:24px;\n    font-weight: 700;\n    width:fit-content;\n    background: transparent;\n    color: ",
        "\n"
    ]);
    Info_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Info_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n     width: 100%;\n     justify-content: space-between;\n     align-items: flex-start;\n     gap: 4rem;\n     flex-direction: row;\n     @media screen and (max-width: 768px){\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        gap: 0rem;\n    }\n"
    ]);
    Info_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Info_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n    &:active{\n        transform: translateY(1px);\n    }\n"
    ]);
    Info_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Info = function(param) {
    var phoneNumber = param.phoneNumber, setPhoneNumber = param.setPhoneNumber, email = param.email, setEmail = param.setEmail, setDeliveryMethod = param.setDeliveryMethod, deliveryMethod = param.deliveryMethod, isError = param.isError, handleChangeInfo = param.handleChangeInfo, account = param.account, priceRoute = param.priceRoute, brandRoute = param.brandRoute, productRoute = param.productRoute, router = param.router, phoneNumberRoute = param.phoneNumberRoute;
    var phoneno = /^\d{10}$/;
    // eslint-disable-next-line no-useless-escape
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var handleChangePhoneNumber = function(e) {
        var value = e.target.value;
        // const phoneno = /^\d{10}$/;
        setPhoneNumber(value);
    // if(value.match(phoneno)){
    // }
    };
    var handleChangeEmail = function(e) {
        var value = e.target.value;
        // const phoneno = /^\d{10}$/;
        setEmail(value);
    // if(value.match(phoneno)){
    // }
    };
    (0,react.useEffect)(function() {
        if (phoneNumberRoute !== undefined && !phoneNumber) {
            setPhoneNumber(phoneNumber);
        }
    }, [
        phoneNumber,
        phoneNumberRoute,
        setPhoneNumber
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                mt: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    flexWrap: "wrap",
                    style: {
                        gap: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            scale: "lg",
                            children: "Th\xf4ng tin người nhận qu\xe0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: [
                                "12px",
                                ,
                                "14px"
                            ],
                            children: "Vui l\xf2ng điền đầy đủ th\xf4ng tin số điện thoại người nhận v\xe0 gi\xe1 trị thẻ qu\xe0 điện tử."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontWeight: "bold",
                                children: "Chọn h\xecnh thức nhận"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "4px",
                                color: "red",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: [
                            "space-between",
                            ,
                            "flex-start"
                        ],
                        flexDirection: [
                            "row",
                            ,
                            "column"
                        ],
                        mt: "0.5rem",
                        children: ListformReceipt === null || ListformReceipt === void 0 ? void 0 : ListformReceipt.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                mt: "0.5rem",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxV2/* default */.Z, {
                                        scale: "sm",
                                        name: "confirmed",
                                        type: "checkbox",
                                        disabled: (item === null || item === void 0 ? void 0 : item.value) === "zalo",
                                        checked: deliveryMethod === (item === null || item === void 0 ? void 0 : item.value),
                                        onChange: function() {
                                            return setDeliveryMethod(item === null || item === void 0 ? void 0 : item.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        ml: [
                                            "6px",
                                            ,
                                            ,
                                            "16px"
                                        ],
                                        fontSize: [
                                            "12px",
                                            ,
                                            "14px"
                                        ],
                                        children: item === null || item === void 0 ? void 0 : item.label
                                    })
                                ]
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexInput, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            marginBottom: "20px",
                            maxWidth: "100%",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontWeight: "bold",
                                                children: "Số điện thoại"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                ml: "4px",
                                                color: "red",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CsConnectWalletButton, {
                                        routePath: router,
                                        children: "Kết nối v\xed"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsBtnChanges, {
                                            fontWeight: "bold",
                                            color: "change",
                                            onClick: handleChangeInfo,
                                            children: "Chỉnh sửa"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                mt: "0.5rem",
                                justifyContent: "flex-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput2, {
                                    type: "text",
                                    scale: "lg",
                                    value: phoneNumber,
                                    placeholder: "Nhập số điện thoại",
                                    onChange: function(e) {
                                        return handleChangePhoneNumber(e);
                                    },
                                    readOnly: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            marginBottom: "20px",
                            maxWidth: "100%",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontWeight: "bold",
                                                children: "Email"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                ml: "4px",
                                                color: "red",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CsConnectWalletButton, {
                                        routePath: router,
                                        children: "Kết nối v\xed"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsBtnChanges, {
                                            fontWeight: "bold",
                                            color: "change",
                                            onClick: handleChangeInfo,
                                            children: "Chỉnh sửa"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                mt: "0.5rem",
                                justifyContent: "flex-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput2, {
                                    type: "text",
                                    scale: "lg",
                                    value: email,
                                    placeholder: "Nhập email",
                                    readOnly: true,
                                    onChange: function(e) {
                                        return handleChangeEmail(e);
                                    }
                                })
                            }),
                            isError && !email.match(mailformat) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: [
                                    "14px",
                                    ,
                                    "16px"
                                ],
                                mt: "0.5rem",
                                color: "red",
                                children: "Vui l\xf2ng nhập email người nhận"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CsConnectWalletButton = (0,styled_components_browser_esm/* default */.ZP)(ConnectWalletButton/* default */.Z).withConfig({
    componentId: "sc-dbb486bb-0"
})(Info_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.change;
});
var CsFlexInput = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-dbb486bb-1"
})(Info_templateObject1());
var CsBtnChanges = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-dbb486bb-2"
})(Info_templateObject2());
/* harmony default export */ var components_Info = (Info);

// EXTERNAL MODULE: ./src/views/GiftCards/components/ModalInfo.tsx
var ModalInfo = __webpack_require__(93280);
;// CONCATENATED MODULE: ./src/views/GiftCards/ElectronicGiftCard.tsx
/* eslint-disable no-param-reassign */ /* eslint-disable no-useless-escape */ /* eslint-disable react-hooks/exhaustive-deps */ 






function ElectronicGiftCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 4px;\n"
    ]);
    ElectronicGiftCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ElectronicGiftCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n    @media screen and (max-width: 1023px){\n        display: flex;\n        cursor: pointer;\n        width: 40px;\n        height: 40px;\n        justify-content: center;\n        &:active{\n            border: 1px solid red;\n            border-radius: 50%;\n            border: 2px solid ",
        ";\n        }\n    }\n    @media screen and (max-width:600px){\n        width: 24px;\n        height: 24px;\n        z-index:1;\n    }\n"
    ]);
    ElectronicGiftCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ElectronicGiftCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media screen and (max-width:600px){\n        justify-content: flex-end;\n        ",
        "{\n            text-align: right;\n        }\n    }\n"
    ]);
    ElectronicGiftCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ElectronicGiftCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: none;\n        @media screen and (max-width:600px){\n        display: flex;\n    }\n"
    ]);
    ElectronicGiftCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ElectronicGiftCard_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: flex;\n        @media screen and (max-width:600px){\n            display: none;\n    }\n"
    ]);
    ElectronicGiftCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ElectronicGiftCard_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    height: ",
        ";\n    overflow-y: auto;\n    flex-direction: column;\n    gap:12px;\n    transition: 0.2s;\n    color:#000;\n    margin-bottom: 2rem;\n    ::-webkit-scrollbar-thumb {\n        border-radius: 6px;\n        background: linear-gradient(180deg, #0167F4 0%, #012179 100%);\n    }\n    > div {\n        padding-right: 12px;\n\n    }\n    > div > ul {\n        list-style:none;\n        list-style-position: outside;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%; /* 36px */\n        letter-spacing: -0.48px;\n        text-align:justify;\n        padding-top:12px;\n        font-size:16px;\n    }\n    > div > ul > li {\n        padding-bottom: 8px;\n        list-style:none;\n        list-style-position: outside;\n        font-size:14px;\n        @media screen and (max-width: 768px){\n            font-size:12px;\n        }\n    }\n    > ul {\n        line-height: 150%; /* 36px */\n        list-style:none;\n        list-style-position: outside;\n        font-size:16px;\n    }\n    ol, ul {\n        list-style: disc;\n        list-style-position: outside;\n        line-height: 150%; /* 36px */\n        text-align:justify;\n        font-size:16px;\n    }\n    span,p{\n        line-height: 150%; /* 36px */\n        font-size:14px !important;\n        @media screen and (max-width: 768px){\n            font-size:12px !important;\n        }\n    }\n"
    ]);
    ElectronicGiftCard_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ElectronicGiftCard_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: ",
        ";\n    transition: 0.2s;\n    flex-direction:column;\n    .select-office-main{\n        display: ",
        ";\n    }\n"
    ]);
    ElectronicGiftCard_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ElectronicGiftCard_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 1rem;\n    flex: 1;\n    overflow-y: auto;\n    flex-direction:column;\n    gap: 12px;\n    padding-right: 12px;\n    @media screen and (max-width: 768px){\n        gap: 6px;\n        margin-top: 0.5rem;\n    }\n    ::-webkit-scrollbar-thumb {\n        border-radius: 6px;\n        background: linear-gradient(180deg, #0167F4 0%, #012179 100%);\n    }\n"
    ]);
    ElectronicGiftCard_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ElectronicGiftCard_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: fit-content;\n    min-height: 88px;\n    background:",
        ";\n    box-shadow: 0px 8px 24px 0px rgba(216, 216, 216, 0.10);\n    border-radius: 8px;\n    padding: 1rem;\n    align-items: center;\n    @media screen and (max-width: 768px){\n        min-height: 60px;\n        padding: 0.5rem;\n    }\n"
    ]);
    ElectronicGiftCard_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ElectronicGiftCard_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* box-shadow: 0px 8px 24px 0px #d8d8d834; */\n    padding: 20px 0;\n    height: fit-content;\n    width: 100%;\n    justify-content: space-between;\n    flex-direction:row;\n    @media screen and (max-width: 768px){\n        flex-direction:column;\n        height: fit-content;\n    }\n"
    ]);
    ElectronicGiftCard_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ElectronicGiftCard_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 30px;\n    height: 30px;\n    padding: 8px;\n    border-radius: 50%;\n    border: 2px solid ",
        ";\n    cursor: pointer;\n"
    ]);
    ElectronicGiftCard_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


































var ElectronicGiftCard = function(param) {
    var priceRoute = param.priceRoute, brandRoute = param.brandRoute, productRoute = param.productRoute, phoneNumberRoute = param.phoneNumberRoute, newbrand = param.newbrand;
    var handleDecimalsOnValue = function handleDecimalsOnValue(value) {
        var regex = RegExp("([0-9]*[\\.|\\,]{0,1}[0-9]{0,2})", "s");
        return value.match(regex)[0];
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var router = (0,next_router.useRouter)();
    var ref29 = (0,useActiveWeb3React/* default */.Z)(), account = ref29.account, chainId = ref29.chainId, provider = ref29.provider;
    var swiperRef = (0,react.useRef)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var dataGiftcards = (0,giftCards/* GetDataGiftCards */.n3)();
    (0,auth/* UseCoreNonce */.A7)();
    var dataAuth = (0,auth/* GetDataAuth */.vN)();
    var emailAuth = dataAuth.email, phoneAuth = dataAuth.phone;
    var ListCategory = dataGiftcards.ListCategory, brandItemStore = dataGiftcards.brandItem, category = dataGiftcards.category, ListBrand = dataGiftcards.ListBrand, ListProvinceId = dataGiftcards.ListProvinceId, isLoading = dataGiftcards.isLoading, phoneNumber = dataGiftcards.phoneNumber, fillAmount = dataGiftcards.fillAmount, dataVouchers = dataGiftcards.dataVouchers, isUpdate = dataGiftcards.isUpdate, tokenSupport = dataGiftcards.tokenSupport, activeTokenPayment = dataGiftcards.activeTokenPayment;
    var brandItem = brandItemStore === null || brandItemStore === void 0 ? void 0 : brandItemStore.filter(function(item) {
        return Number(item === null || item === void 0 ? void 0 : item.price) !== 0;
    });
    var findNameItem = ListBrand === null || ListBrand === void 0 ? void 0 : ListBrand.find(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) === (brandRoute === null || brandRoute === void 0 ? void 0 : brandRoute.toString());
    });
    var findNameUpdateItem = ListBrand === null || ListBrand === void 0 ? void 0 : ListBrand.find(function(item) {
        var ref, ref1;
        return (item === null || item === void 0 ? void 0 : (ref = item.title) === null || ref === void 0 ? void 0 : ref.toString()) === (dataVouchers === null || dataVouchers === void 0 ? void 0 : (ref1 = dataVouchers.brandName) === null || ref1 === void 0 ? void 0 : ref1.toString());
    });
    var ref30 = (0,react.useState)("email"), deliveryMethod = ref30[0], setDeliveryMethod = ref30[1];
    var ref31 = (0,react.useState)("0"), selectCategory = ref31[0], setSelectCategory = ref31[1];
    var ref32 = (0,react.useState)(), selectRegion = ref32[0], setSelectProvince = ref32[1];
    var ref33 = (0,react.useState)(), selectBrand = ref33[0], setSelectBrand = ref33[1];
    var ref34 = (0,react.useState)("1"), viewTag = ref34[0], setViewTag = ref34[1];
    var ref35 = (0,react.useState)(), cardPrice = ref35[0], setCardPrice = ref35[1];
    var ref36 = (0,react.useState)(), cardProduct = ref36[0], setCardProduct = ref36[1];
    var ref37 = (0,react.useState)([]), noProduct = ref37[0], setNoProducts = ref37[1];
    var ref38 = (0,react.useState)(false), isError = ref38[0], setIsError = ref38[1];
    var ref39 = (0,react.useState)(false), isDefaultBrand = ref39[0], setIsDefaultBrand = ref39[1];
    var ref40 = (0,react.useState)(false), isDefaultProvince = ref40[0], setIsDefaultProvince = ref40[1];
    var ref41 = (0,react.useState)(false), optionSelected = ref41[0], setOptionSelected = ref41[1];
    var findProductRoute = brandItem === null || brandItem === void 0 ? void 0 : brandItem.find(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()) === (productRoute === null || productRoute === void 0 ? void 0 : productRoute.toLocaleLowerCase());
    });
    var findPriceRoute = brandItem === null || brandItem === void 0 ? void 0 : brandItem.find(function(item) {
        return Number(item === null || item === void 0 ? void 0 : item.price) === Number(priceRoute);
    });
    var findPriceUpdate = brandItem === null || brandItem === void 0 ? void 0 : brandItem.find(function(item) {
        return Number(item === null || item === void 0 ? void 0 : item.price) === Number(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.price);
    });
    var voucherName = (selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.isNewBrand) ? "[GiftCard Voucher]" : "[UrBox Voucher]";
    var findProductUpdate = (0,react.useMemo)(function() {
        if (viewTag === "1") {
            return brandItem === null || brandItem === void 0 ? void 0 : brandItem.find(function(item) {
                return Number(item === null || item === void 0 ? void 0 : item.price) === Number(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.price);
            });
        }
        return "0";
    }, [
        viewTag
    ]);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(priceRoute === undefined && brandRoute === undefined && (selectBrand === undefined || Number(selectRegion) === 0))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch((0,actions/* fetchListProvinceByBrandId */.XN)({
                                brandId: "0"
                            }))
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,actions/* fetchActiveCategory */.To)({
                                category: "0"
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* fetchProvinceId */.ar)({
                                cityId: "0"
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            setIsDefaultProvince(!false)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    // // update
    (0,react.useEffect)(function() {
        if ((dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.price) !== "" && isUpdate && !cardPrice) {
            setCardPrice(findPriceUpdate);
        }
        if (dataVouchers && isUpdate && !cardProduct) {
            setCardProduct(findProductUpdate);
        }
    }, [
        findPriceUpdate,
        findProductUpdate,
        dataVouchers,
        isUpdate,
        findNameUpdateItem,
        selectBrand,
        viewTag,
        cardPrice
    ]);
    (0,react.useEffect)(function() {
        if (dataVouchers && isUpdate) {
            setViewTag(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.viewTag);
        }
    }, [
        ViewTag
    ]);
    (0,react.useEffect)(function() {
        if (cardPrice === undefined && priceRoute && !isUpdate) {
            setCardPrice(priceRoute);
        }
    }, []);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(selectBrand === undefined && !findNameUpdateItem || selectBrand === undefined)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            setSelectBrand(findNameItem)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        if (!(cardPrice === undefined && priceRoute && !isUpdate)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            setCardPrice(findPriceRoute)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (!(cardProduct === undefined && productRoute && !isUpdate)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            setCardProduct(findProductRoute)
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        cardPrice,
        cardProduct,
        findNameItem,
        priceRoute,
        productRoute,
        selectBrand
    ]);
    var handleChangeCategory = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newValue) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setSelectCategory(newValue);
                setIsDefaultBrand(!false);
                setIsDefaultProvince(!false);
                return [
                    2
                ];
            });
        });
        return function handleChangeCategory(newValue) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSelectReliGion = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(option) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSelectProvince(option === null || option === void 0 ? void 0 : (ref = option.provinceId) === null || ref === void 0 ? void 0 : ref.toString());
                        return [
                            4,
                            dispatch((0,actions/* fetchProvinceId */.ar)({
                                cityId: option === null || option === void 0 ? void 0 : option.provinceId
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectReliGion(option) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (findNameUpdateItem && !selectBrand && isUpdate) {
            setSelectBrand(findNameUpdateItem);
        }
    }, [
        findNameUpdateItem,
        selectBrand,
        isUpdate
    ]);
    // validation
    var phoneno = /^\d{10}$/;
    // eslint-disable-next-line no-useless-escape
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var resultFilterCategory = (0,react.useMemo)(function() {
        if (Number(selectCategory) !== 0) {
            return ListBrand === null || ListBrand === void 0 ? void 0 : ListBrand.filter(function(item) {
                return Number(item === null || item === void 0 ? void 0 : item.parent_cat_id) === Number(selectCategory);
            });
        }
        if (Number(selectCategory) === 0) {
            return ListBrand;
        }
        return [];
    }, [
        ListBrand,
        selectCategory
    ]);
    var resultFilterProvince = (0,react.useMemo)(function() {
        if (Number(selectRegion) !== 0) {
            var mapListProvince = ListProvinceId === null || ListProvinceId === void 0 ? void 0 : ListProvinceId.map(function(item) {
                var findItemByCategory = resultFilterCategory === null || resultFilterCategory === void 0 ? void 0 : resultFilterCategory.find(function(dt) {
                    var ref;
                    return (dt === null || dt === void 0 ? void 0 : (ref = dt.id) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()) === (item === null || item === void 0 ? void 0 : item.toLocaleLowerCase());
                });
                return findItemByCategory;
            });
            var resultFilterUndefine = mapListProvince === null || mapListProvince === void 0 ? void 0 : mapListProvince.filter(function(item) {
                return item !== undefined;
            });
            return resultFilterUndefine;
        }
        if (Number(selectRegion) === 0 || selectRegion === undefined) {
            return resultFilterCategory;
        }
        return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectRegion,
        ListProvinceId,
        resultFilterCategory,
        selectCategory
    ]);
    var resultFilterBrand = (0,react.useMemo)(function() {
        if (Number(selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.id) !== 0 && (resultFilterProvince === null || resultFilterProvince === void 0 ? void 0 : resultFilterProvince.length) !== 0) {
            return resultFilterProvince === null || resultFilterProvince === void 0 ? void 0 : resultFilterProvince.find(function(item) {
                var ref, ref1;
                return (item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()) === (selectBrand === null || selectBrand === void 0 ? void 0 : (ref1 = selectBrand.id) === null || ref1 === void 0 ? void 0 : ref1.toLocaleLowerCase());
            });
        }
        return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        resultFilterProvince,
        selectBrand,
        selectCategory,
        selectRegion,
        ListBrand
    ]);
    (0,react.useEffect)(function() {
        if (findProductRoute || priceRoute) {
            if (fillAmount === 0) {
                dispatch((0,actions/* fetchFillAmount */.fZ)({
                    fillAmount: 1
                }));
            }
        }
    }, [
        findProductRoute,
        priceRoute
    ]);
    var handleChangeInput = function(value) {
        dispatch((0,actions/* fetchFillAmount */.fZ)({
            fillAmount: handleDecimalsOnValue(value)
        }));
    };
    var sliderSettings = {
        320: {
            slidesPerView: 3,
            spaceBetween: 5
        },
        680: {
            slidesPerView: 6,
            spaceBetween: 0
        },
        1024: {
            slidesPerView: 8,
            spaceBetween: 8
        },
        1366: {
            slidesPerView: 8,
            spaceBetween: 8
        }
    };
    var handleSelectPrice = function(value) {
        if (value) {
            setCardPrice(value);
        }
    };
    var handleSelectCard = function(value) {
        if (value) {
            setCardProduct(value);
        }
    };
    var handleBack = function() {
        router.back();
    };
    var allOption = [
        {
            id: "0",
            images: "",
            title: "Tất cả"
        },
        {
            id: "1",
            images: "",
            title: "GiftCard"
        }, 
    ];
    var concatCategory = allOption === null || allOption === void 0 ? void 0 : allOption.concat(ListCategory);
    (0,react.useEffect)(function() {
        var getData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var resBrandItem, resBrandItem1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(resultFilterBrand === null || resultFilterBrand === void 0 ? void 0 : resultFilterBrand.isNewBrand)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,fetchData/* fetchNewBrandById */.gq)(resultFilterBrand === null || resultFilterBrand === void 0 ? void 0 : resultFilterBrand.id)
                            ];
                        case 1:
                            resBrandItem = _state.sent();
                            dispatch((0,actions/* fetchDetailBrand */.f7)(resBrandItem));
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                (0,fetchData/* fetchBrandById */.Us)(resultFilterBrand === null || resultFilterBrand === void 0 ? void 0 : resultFilterBrand.id)
                            ];
                        case 3:
                            resBrandItem1 = _state.sent();
                            dispatch((0,actions/* fetchDetailBrand */.f7)(resBrandItem1));
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (resultFilterBrand === null || resultFilterBrand === void 0 ? void 0 : resultFilterBrand.id) {
            getData();
        }
        if (!Number(resultFilterBrand === null || resultFilterBrand === void 0 ? void 0 : resultFilterBrand.id)) {
            setNoProducts([]);
        }
    }, [
        dispatch,
        resultFilterBrand,
        category,
        selectRegion,
        selectBrand
    ]);
    var filterTypeOne = [];
    (ref = config/* TYPE_GIFTCARD */.iw === null || config/* TYPE_GIFTCARD */.iw === void 0 ? void 0 : config/* TYPE_GIFTCARD.PRICE_VOUCHER */.iw.PRICE_VOUCHER) === null || ref === void 0 ? void 0 : ref.map(function(item) {
        var arrayBrandItemNotNone = brandItem === null || brandItem === void 0 ? void 0 : brandItem.filter(function(dt) {
            return Number(dt === null || dt === void 0 ? void 0 : dt.type) === Number(item);
        });
        if ((arrayBrandItemNotNone === null || arrayBrandItemNotNone === void 0 ? void 0 : arrayBrandItemNotNone.length) !== 0) {
            filterTypeOne === null || filterTypeOne === void 0 ? void 0 : filterTypeOne.push(arrayBrandItemNotNone);
        }
        return filterTypeOne;
    });
    var filterTwo = [];
    (ref1 = config/* TYPE_GIFTCARD */.iw === null || config/* TYPE_GIFTCARD */.iw === void 0 ? void 0 : config/* TYPE_GIFTCARD.FEATURED_PRODUCT */.iw.FEATURED_PRODUCT) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
        var arrayBrandItemNotNone = brandItem === null || brandItem === void 0 ? void 0 : brandItem.filter(function(dt) {
            return Number(dt === null || dt === void 0 ? void 0 : dt.type) === Number(item);
        });
        if ((arrayBrandItemNotNone === null || arrayBrandItemNotNone === void 0 ? void 0 : arrayBrandItemNotNone.length) !== 0) {
            filterTwo === null || filterTwo === void 0 ? void 0 : filterTwo.push(arrayBrandItemNotNone);
        }
        return filterTwo;
    });
    var resultFilterTypeOne = (0,react.useMemo)(function() {
        if ((filterTypeOne === null || filterTypeOne === void 0 ? void 0 : filterTypeOne.length) === 0) {
            return [];
        }
        return filterTypeOne === null || filterTypeOne === void 0 ? void 0 : filterTypeOne[0];
    }, [
        filterTypeOne,
        selectBrand
    ]);
    var filterTypeTwo = (0,react.useMemo)(function() {
        if ((filterTwo === null || filterTwo === void 0 ? void 0 : filterTwo.length) === 0) {
            return [];
        }
        return filterTwo === null || filterTwo === void 0 ? void 0 : filterTwo[0];
    }, [
        filterTwo,
        selectBrand
    ]);
    var sortBrandItemOne = (0,react.useMemo)(function() {
        return resultFilterTypeOne === null || resultFilterTypeOne === void 0 ? void 0 : resultFilterTypeOne.sort(function(a, b) {
            return Number(a === null || a === void 0 ? void 0 : a.price) - Number(b === null || b === void 0 ? void 0 : b.price);
        });
    }, [
        selectBrand,
        resultFilterTypeOne
    ]);
    var sortBrandItemTwo = (0,react.useMemo)(function() {
        var ref;
        return filterTypeTwo && ((ref = (0,_to_consumable_array/* default */.Z)(filterTypeTwo)) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
            return Number(a === null || a === void 0 ? void 0 : a.price) - Number(b === null || b === void 0 ? void 0 : b.price);
        }));
    }, [
        selectBrand,
        filterTypeTwo
    ]);
    var filterIsPrice = (0,react.useMemo)(function() {
        var ref;
        var price = cardPrice === undefined ? priceRoute === null || priceRoute === void 0 ? void 0 : priceRoute.toString() : cardPrice === null || cardPrice === void 0 ? void 0 : (ref = cardPrice.price) === null || ref === void 0 ? void 0 : ref.toString();
        return sortBrandItemOne === null || sortBrandItemOne === void 0 ? void 0 : sortBrandItemOne.find(function(item) {
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.price) === null || ref === void 0 ? void 0 : ref.toString()) === (price === null || price === void 0 ? void 0 : price.toString());
        });
    }, [
        cardPrice
    ]);
    var filterIsProduct = (0,react.useMemo)(function() {
        var ref;
        var productFilter = cardProduct === undefined ? productRoute === null || productRoute === void 0 ? void 0 : productRoute.toString() : cardProduct === null || cardProduct === void 0 ? void 0 : (ref = cardProduct.id) === null || ref === void 0 ? void 0 : ref.toString();
        return sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.find(function(item) {
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) === (productFilter === null || productFilter === void 0 ? void 0 : productFilter.toString());
        });
    }, [
        cardProduct
    ]);
    var priceRouteValue = priceRoute && !cardPrice ? priceRoute : filterIsPrice && (filterIsPrice === null || filterIsPrice === void 0 ? void 0 : (ref2 = filterIsPrice.price) === null || ref2 === void 0 ? void 0 : ref2.toString());
    var productRouteValue = productRoute && !cardProduct ? findProductRoute === null || findProductRoute === void 0 ? void 0 : (ref3 = findProductRoute.price) === null || ref3 === void 0 ? void 0 : ref3.toString() : filterIsProduct ? filterIsProduct === null || filterIsProduct === void 0 ? void 0 : (ref4 = filterIsProduct.price) === null || ref4 === void 0 ? void 0 : ref4.toString() : 0;
    var priceQuantity = cardPrice === undefined ? priceRoute === null || priceRoute === void 0 ? void 0 : priceRoute.toString() : cardPrice === null || cardPrice === void 0 ? void 0 : (ref5 = cardPrice.price) === null || ref5 === void 0 ? void 0 : ref5.toString();
    var productQuantity = cardProduct === undefined ? findProductRoute === null || findProductRoute === void 0 ? void 0 : (ref6 = findProductRoute.id) === null || ref6 === void 0 ? void 0 : ref6.toString() : cardProduct === null || cardProduct === void 0 ? void 0 : (ref7 = cardProduct.id) === null || ref7 === void 0 ? void 0 : ref7.toString();
    var checkFilterIsPrice = Number((ref8 = sortBrandItemOne === null || sortBrandItemOne === void 0 ? void 0 : sortBrandItemOne.find(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.price) === null || ref === void 0 ? void 0 : ref.toString()) === (priceQuantity === null || priceQuantity === void 0 ? void 0 : priceQuantity.toString());
    })) === null || ref8 === void 0 ? void 0 : ref8.quantity) || 0;
    var checkFilterIsProduct = Number((ref9 = sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.find(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) === (productQuantity === null || productQuantity === void 0 ? void 0 : productQuantity.toString());
    })) === null || ref9 === void 0 ? void 0 : ref9.quantity) || 0;
    var stockQuantity = viewTag === "1" ? checkFilterIsPrice : checkFilterIsProduct;
    var totalPrice = (0,react.useMemo)(function() {
        if (viewTag === "1") {
            if (priceRouteValue) {
                var ref, ref1;
                if (filterIsPrice !== undefined) {
                    var ref2, ref3;
                    return (ref3 = (ref2 = new bignumber/* default */.Z(fillAmount)) === null || ref2 === void 0 ? void 0 : ref2.multipliedBy(Number(filterIsPrice === null || filterIsPrice === void 0 ? void 0 : filterIsPrice.is_promo) === 2 ? filterIsPrice === null || filterIsPrice === void 0 ? void 0 : filterIsPrice.price_promo : filterIsPrice === null || filterIsPrice === void 0 ? void 0 : filterIsPrice.price)) === null || ref3 === void 0 ? void 0 : ref3.toString();
                }
                if (filterIsPrice === undefined) {
                    var ref4, ref5;
                    return (ref5 = (ref4 = new bignumber/* default */.Z(fillAmount)) === null || ref4 === void 0 ? void 0 : ref4.multipliedBy(Number(findPriceRoute === null || findPriceRoute === void 0 ? void 0 : findPriceRoute.is_promo) === 2 ? findPriceRoute === null || findPriceRoute === void 0 ? void 0 : findPriceRoute.price_promo : findPriceRoute === null || findPriceRoute === void 0 ? void 0 : findPriceRoute.price)) === null || ref5 === void 0 ? void 0 : ref5.toString();
                }
                return (ref1 = (ref = new bignumber/* default */.Z(fillAmount)) === null || ref === void 0 ? void 0 : ref.multipliedBy(priceRouteValue)) === null || ref1 === void 0 ? void 0 : ref1.toString();
            }
        }
        if (viewTag === "2") {
            if (productRouteValue) {
                var ref6, ref7;
                if (filterIsProduct === undefined) {
                    var ref8, ref9;
                    return (ref9 = (ref8 = new bignumber/* default */.Z(fillAmount)) === null || ref8 === void 0 ? void 0 : ref8.multipliedBy(Number(findProductRoute === null || findProductRoute === void 0 ? void 0 : findProductRoute.is_promo) === 2 ? findProductRoute === null || findProductRoute === void 0 ? void 0 : findProductRoute.price_promo : findProductRoute === null || findProductRoute === void 0 ? void 0 : findProductRoute.price)) === null || ref9 === void 0 ? void 0 : ref9.toString();
                }
                if (filterIsProduct !== undefined) {
                    var ref10, ref11;
                    return (ref11 = (ref10 = new bignumber/* default */.Z(fillAmount)) === null || ref10 === void 0 ? void 0 : ref10.multipliedBy(filterIsProduct === null || filterIsProduct === void 0 ? void 0 : filterIsProduct.price)) === null || ref11 === void 0 ? void 0 : ref11.toString();
                }
                return (ref7 = (ref6 = new bignumber/* default */.Z(fillAmount)) === null || ref6 === void 0 ? void 0 : ref6.multipliedBy(productRouteValue)) === null || ref7 === void 0 ? void 0 : ref7.toString();
            }
        }
        return "";
    }, [
        fillAmount,
        cardProduct,
        findProductRoute,
        findPriceRoute,
        selectBrand,
        cardPrice,
        filterIsPrice,
        viewTag,
        sortBrandItemOne,
        sortBrandItemTwo
    ]);
    (0,react.useEffect)(function() {
        if ((sortBrandItemOne === null || sortBrandItemOne === void 0 ? void 0 : sortBrandItemOne.length) !== 0 && priceRoute) {
            setViewTag("1");
        }
        if ((sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.length) !== 0 && productRoute) {
            setViewTag("2");
        }
    }, []);
    (0,react.useEffect)(function() {
        if (cardProduct === undefined && productRoute && !isUpdate) {
            setViewTag("2");
        }
    }, [
        productRoute,
        cardProduct
    ]);
    (0,react.useEffect)(function() {
        if ((sortBrandItemOne === null || sortBrandItemOne === void 0 ? void 0 : sortBrandItemOne.length) !== 0 && (sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.length) === 0) {
            setViewTag("1");
        }
        if ((sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.length) !== 0 && (sortBrandItemOne === null || sortBrandItemOne === void 0 ? void 0 : sortBrandItemOne.length) === 0) {
            setViewTag("2");
        }
    }, [
        viewTag,
        selectBrand,
        sortBrandItemOne,
        sortBrandItemTwo,
        cardProduct
    ]);
    var contractAddress = (0,addressHelpers/* getAddress */.Kn)(contracts/* default.buyVouchers */.Z.buyVouchers, chainId);
    var findTokenPayment = (0,react.useMemo)(function() {
        return tokenSupport.find(function(dt) {
            var ref, ref1;
            return (dt === null || dt === void 0 ? void 0 : (ref = dt.token) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === (activeTokenPayment === null || activeTokenPayment === void 0 ? void 0 : activeTokenPayment.toLowerCase());
        });
    }, [
        tokenSupport,
        activeTokenPayment
    ]);
    (0,giftCards/* UseCoreDataUser */.nK)(contractAddress, account, findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.token, chainId, provider);
    (0,giftCards/* UseCorePaymentMethod */.pN)(totalPrice, chainId, provider, account);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var listTokenByTypeChain, resListBalance;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        listTokenByTypeChain = (0,giftcards/* listTokenGetBalance */.D)(chainId);
                        return [
                            4,
                            (0,fetchData/* fetchBalanceByChain */.yx)(account, listTokenByTypeChain)
                        ];
                    case 1:
                        resListBalance = _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* fetchDataUserByChain */.Q1)(resListBalance))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        account,
        chainId,
        dispatch
    ]);
    var checkViewTag = viewTag === "1" ? priceRoute && !cardPrice ? findPriceRoute === null || findPriceRoute === void 0 ? void 0 : (ref10 = findPriceRoute.id) === null || ref10 === void 0 ? void 0 : ref10.toString() : cardPrice === null || cardPrice === void 0 ? void 0 : (ref11 = cardPrice.id) === null || ref11 === void 0 ? void 0 : ref11.toString() : productRoute && !cardProduct ? findProductRoute === null || findProductRoute === void 0 ? void 0 : (ref12 = findProductRoute.id) === null || ref12 === void 0 ? void 0 : ref12.toString() : cardProduct === null || cardProduct === void 0 ? void 0 : (ref13 = cardProduct.id) === null || ref13 === void 0 ? void 0 : ref13.toString();
    var checkViewTagBrand = viewTag === "1" ? priceRoute && !cardPrice ? findPriceRoute === null || findPriceRoute === void 0 ? void 0 : (ref14 = findPriceRoute.brand) === null || ref14 === void 0 ? void 0 : ref14.toString() : cardPrice === null || cardPrice === void 0 ? void 0 : (ref15 = cardPrice.brand) === null || ref15 === void 0 ? void 0 : ref15.toString() : productRoute && !cardProduct ? findProductRoute === null || findProductRoute === void 0 ? void 0 : (ref16 = findProductRoute.brand) === null || ref16 === void 0 ? void 0 : ref16.toString() : cardProduct === null || cardProduct === void 0 ? void 0 : (ref17 = cardProduct.brand) === null || ref17 === void 0 ? void 0 : ref17.toString();
    var checkViewTagNote = viewTag === "1" ? priceRoute && !cardPrice ? findPriceRoute === null || findPriceRoute === void 0 ? void 0 : (ref18 = findPriceRoute.note) === null || ref18 === void 0 ? void 0 : ref18.toString() : cardPrice === null || cardPrice === void 0 ? void 0 : (ref19 = cardPrice.note) === null || ref19 === void 0 ? void 0 : ref19.toString() : productRoute && !cardProduct ? findProductRoute === null || findProductRoute === void 0 ? void 0 : (ref20 = findProductRoute.note) === null || ref20 === void 0 ? void 0 : ref20.toString() : cardProduct === null || cardProduct === void 0 ? void 0 : (ref21 = cardProduct.note) === null || ref21 === void 0 ? void 0 : ref21.toString();
    var checkViewTagProvince = viewTag === "1" ? priceRoute && !cardPrice ? findPriceRoute : cardPrice : productRoute && !cardProduct ? findProductRoute : cardProduct;
    var handleContinue = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, res, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!phoneAuth.match(phoneno) || !emailAuth.match(mailformat) || Number(fillAmount) < 1 || Number(fillAmount) > 30 || Number(fillAmount) > stockQuantity) {
                            setIsError(true);
                            dispatch((0,actions/* getStatusLoading */.jJ)({
                                isLoading: false
                            }));
                        } else {
                            setIsError(false);
                        }
                        if (!(isError === false && phoneAuth.match(phoneno) && emailAuth.match(mailformat) && !((ref = new bignumber/* default */.Z(totalPrice)) === null || ref === void 0 ? void 0 : ref.isNaN()) && checkViewTag && (fillAmount > 0 || fillAmount <= 30) && fillAmount <= stockQuantity)) return [
                            3,
                            14
                        ];
                        return [
                            4,
                            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("is_sign_again", "true")
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* getStatusLoading */.jJ)({
                                isLoading: true
                            }))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            12,
                            ,
                            14
                        ]);
                        return [
                            4,
                            brand/* BrandApi.order */.X.order({
                                deliveryMethod: deliveryMethod,
                                phoneNo: phoneAuth,
                                email: emailAuth,
                                quantity: Number(fillAmount),
                                itemId: checkViewTag === null || checkViewTag === void 0 ? void 0 : checkViewTag.toString(),
                                chainId: chainId === null || chainId === void 0 ? void 0 : chainId.toString(),
                                isGiftCardVoucher: (selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.isNewBrand) ? !false : false
                            })
                        ];
                    case 4:
                        res = _state.sent();
                        if (!((res === null || res === void 0 ? void 0 : res.statusCode) === 201)) return [
                            3,
                            9
                        ];
                        if (!(res === null || res === void 0 ? void 0 : res.data)) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            dispatch((0,actions/* fetchDataVouchers */.cQ)({
                                dataVouchers: {
                                    deliveryMethod: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.deliveryMethod,
                                    phoneNumber: res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.phoneNo,
                                    email: res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.email,
                                    fillAmount: res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : ref4.quantity,
                                    itemId: res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.itemId,
                                    nameProduct: res === null || res === void 0 ? void 0 : (ref6 = res.data) === null || ref6 === void 0 ? void 0 : ref6.itemName,
                                    price: res === null || res === void 0 ? void 0 : (ref7 = res.data) === null || ref7 === void 0 ? void 0 : ref7.unitPrice,
                                    promoPrice: res === null || res === void 0 ? void 0 : (ref8 = res.data) === null || ref8 === void 0 ? void 0 : ref8.promoPrice,
                                    isPromo: res === null || res === void 0 ? void 0 : (ref9 = res.data) === null || ref9 === void 0 ? void 0 : ref9.isPromo,
                                    orderId: res === null || res === void 0 ? void 0 : (ref10 = res.data) === null || ref10 === void 0 ? void 0 : ref10.orderId,
                                    brandName: res === null || res === void 0 ? void 0 : (ref11 = res.data) === null || ref11 === void 0 ? void 0 : ref11.brandName,
                                    viewTag: viewTag,
                                    tokenPayment: activeTokenPayment
                                }
                            }))
                        ];
                    case 5:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* fetchStatusScreen */.an)({
                                isActiveScreen: 1
                            }))
                        ];
                    case 6:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* getStatusLoading */.jJ)({
                                isLoading: false
                            }))
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            11
                        ];
                    case 9:
                        return [
                            4,
                            dispatch((0,actions/* fetchDataVouchers */.cQ)({
                                dataVouchers: {
                                    deliveryMethod: "",
                                    phoneNumber: "",
                                    email: "",
                                    fillAmount: 0,
                                    itemId: "",
                                    nameProduct: "",
                                    price: "",
                                    promoPrice: "",
                                    isPromo: 0,
                                    orderId: "0",
                                    brandName: "",
                                    viewTag: viewTag
                                }
                            }))
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            14
                        ];
                    case 12:
                        e = _state.sent();
                        console.log("e", e);
                        return [
                            4,
                            dispatch((0,actions/* getStatusLoading */.jJ)({
                                isLoading: false
                            }))
                        ];
                    case 13:
                        _state.sent();
                        return [
                            3,
                            14
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    var isShowListByChangeCategory = (0,react.useMemo)(function() {
        if (isDefaultBrand === true && isDefaultProvince === true && selectCategory) {
            return false;
        }
        return true;
    }, [
        isDefaultBrand,
        isDefaultProvince,
        selectCategory
    ]);
    var handleChangeInfo = function() {
        onOpenModalInfo();
    };
    var ref42 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalInfo/* default */.ZP, {
        title: ""
    }), true, true, "buy_item_".concat(dataAuth)), 1), onOpenModalInfo = ref42[0];
    var funcCheckLink = function(priceParams, brandParams, prod, phoneNum) {
        if (phoneNum) {
            if (brandParams !== undefined && prod !== undefined && phoneNum !== undefined) {
                return "/order/".concat(brandParams, "?product=").concat(prod, "&phoneNumber=").concat(phoneNum);
            }
            if (brandParams !== undefined && priceParams !== undefined && phoneNum !== undefined) {
                return "/order/".concat(brandParams, "?price=").concat(priceParams, "&phoneNumber=").concat(phoneNum);
            }
            if (phoneNum !== undefined) {
                return "/order?phoneNumber=".concat(phoneNum);
            }
        }
        if (brandParams !== undefined && prod !== undefined) {
            return "/order/".concat(brandParams, "?product=").concat(prod);
        }
        if (brandParams !== undefined && priceParams !== undefined) {
            return "/order/".concat(brandParams, "?price=").concat(priceParams);
        }
        if (brandParams !== undefined) {
            return "/order/".concat(brandParams);
        }
        return "/order";
    };
    var deeplinkFunc = funcCheckLink(priceRoute && !cardPrice ? findPriceRoute === null || findPriceRoute === void 0 ? void 0 : findPriceRoute.price : cardPrice === null || cardPrice === void 0 ? void 0 : cardPrice.price, resultFilterBrand === null || resultFilterBrand === void 0 ? void 0 : resultFilterBrand.id, productRoute && !cardProduct ? findProductRoute === null || findProductRoute === void 0 ? void 0 : findProductRoute.id : cardProduct === null || cardProduct === void 0 ? void 0 : cardProduct.id, phoneNumber);
    var listOffice = checkViewTagProvince || [];
    var listProvineSupport = (0,react.useMemo)(function() {
        var ref;
        var listProvine = [];
        if ((listOffice === null || listOffice === void 0 ? void 0 : (ref = listOffice.office) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var ref1;
            var mergeData = listOffice === null || listOffice === void 0 ? void 0 : (ref1 = listOffice.office) === null || ref1 === void 0 ? void 0 : ref1.map(function(it) {
                var findItem = province.find(function(pr) {
                    return Number(pr === null || pr === void 0 ? void 0 : pr.provinceId) === Number(it === null || it === void 0 ? void 0 : it.city_id);
                });
                return {
                    provinceName: findItem === null || findItem === void 0 ? void 0 : findItem.provinceName,
                    provinceId: findItem === null || findItem === void 0 ? void 0 : findItem.provinceId
                };
            });
            var result = mergeData && (Object === null || Object === void 0 ? void 0 : Object.values(mergeData === null || mergeData === void 0 ? void 0 : mergeData.reduce(function(r, e) {
                var k = "".concat(e.provinceName, "|").concat(e.provinceId);
                if (!r[k]) r[k] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e), {
                    amount: 1
                });
                else r[k].amount += 1;
                return r;
            }, {})));
            return [
                {
                    provinceName: "Tất cả c\xe1c khu vực",
                    provinceId: "0"
                }
            ].concat((0,_to_consumable_array/* default */.Z)(result || []));
        }
        return listProvine;
    }, [
        brandItem === null || brandItem === void 0 ? void 0 : brandItem.length,
        listOffice
    ]);
    var ref43 = (0,react.useState)(null), selectProvinceState = ref43[0], setSelectProvinceState = ref43[1];
    var handleSelectProvince = function(option) {
        setSelectProvinceState(option);
    };
    var filterCityIdCardPrice = (0,react.useMemo)(function() {
        var ref;
        var filter = checkViewTagProvince === null || checkViewTagProvince === void 0 ? void 0 : (ref = checkViewTagProvince.office) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            var ref, ref1;
            return (item === null || item === void 0 ? void 0 : (ref = item.city_id) === null || ref === void 0 ? void 0 : ref.toString()) === (selectProvinceState === null || selectProvinceState === void 0 ? void 0 : (ref1 = selectProvinceState.provinceId) === null || ref1 === void 0 ? void 0 : ref1.toString());
        });
        if (Number(selectProvinceState === null || selectProvinceState === void 0 ? void 0 : selectProvinceState.provinceId) !== 0 && (selectProvinceState === null || selectProvinceState === void 0 ? void 0 : selectProvinceState.provinceId) !== undefined) {
            return filter;
        }
        return checkViewTagProvince === null || checkViewTagProvince === void 0 ? void 0 : checkViewTagProvince.office;
    }, [
        selectProvinceState,
        checkViewTagProvince === null || checkViewTagProvince === void 0 ? void 0 : checkViewTagProvince.office
    ]);
    var filterCityIdCardProduct = (0,react.useMemo)(function() {
        var ref;
        var filter = checkViewTagProvince === null || checkViewTagProvince === void 0 ? void 0 : (ref = checkViewTagProvince.office) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            var ref, ref1;
            return (item === null || item === void 0 ? void 0 : (ref = item.city_id) === null || ref === void 0 ? void 0 : ref.toString()) === (selectProvinceState === null || selectProvinceState === void 0 ? void 0 : (ref1 = selectProvinceState.provinceId) === null || ref1 === void 0 ? void 0 : ref1.toString());
        });
        if (Number(selectProvinceState === null || selectProvinceState === void 0 ? void 0 : selectProvinceState.provinceId) !== 0 && (selectProvinceState === null || selectProvinceState === void 0 ? void 0 : selectProvinceState.provinceId) !== undefined) {
            return filter;
        }
        return checkViewTagProvince === null || checkViewTagProvince === void 0 ? void 0 : checkViewTagProvince.office;
    }, [
        selectProvinceState,
        checkViewTagProvince === null || checkViewTagProvince === void 0 ? void 0 : checkViewTagProvince.office
    ]);
    var ref44 = (0,react.useState)(true), isOpenLeft = ref44[0], setIsOpenLeft = ref44[1];
    var ref45 = (0,react.useState)(true), isOpenRight = ref45[0], setIsOpenRight = ref45[1];
    var toggling = function(event) {
        setIsOpenLeft(!isOpenLeft);
        event.stopPropagation();
    };
    var togglingRight = function(event) {
        setIsOpenRight(!isOpenRight);
        event.stopPropagation();
    };
    var notes = cardPrice === null || cardPrice === void 0 ? void 0 : (ref22 = cardPrice.note) === null || ref22 === void 0 ? void 0 : ref22.split("\n");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageFullWidth/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                width: "100%",
                mb: "4rem",
                style: {
                    overflowX: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    flexDirection: "column",
                    style: {
                        gap: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                style: {
                                    gap: "12px",
                                    cursor: "pointer",
                                    width: "fit-content"
                                },
                                onClick: function() {
                                    return handleBack();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftCircle/* default */.Z, {
                                        width: "28px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        scale: "lg",
                                        children: "Quay lại"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            mt: "1rem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsHeading, {
                                    scale: "xl",
                                    children: "Thẻ qu\xe0 điện tử"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    width: "100%",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            mt: "1rem",
                                            fontWeight: "bold",
                                            scale: "lg",
                                            children: "Th\xf4ng tin thẻ qu\xe0 tặng"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mt: "0.5rem",
                                            fontSize: [
                                                "12px",
                                                ,
                                                "14px"
                                            ],
                                            children: "Vui l\xf2ng điền đầy đủ th\xf4ng tin thẻ qu\xe0 tặng."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mt: "1rem",
                                            fontSize: [
                                                "14px",
                                                ,
                                                "16px"
                                            ],
                                            fontWeight: "bold",
                                            children: "Danh mục"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexMobile, {
                                    width: "100%",
                                    style: {
                                        gap: "12px"
                                    },
                                    mt: "2rem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: "100%",
                                        alignItems: "center",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                slidesPerView: 5,
                                                pagination: {
                                                    clickable: true
                                                },
                                                onSlideChange: function() {
                                                    return console.log("slide change");
                                                },
                                                onSwiper: function(swiper) {
                                                    return console.log(swiper);
                                                },
                                                spaceBetween: 0,
                                                breakpoints: sliderSettings,
                                                modules: [
                                                    swiper_esm/* Navigation */.W_
                                                ],
                                                onBeforeInit: function(swiper) {
                                                    swiperRef.current = swiper;
                                                },
                                                children: concatCategory === null || concatCategory === void 0 ? void 0 : concatCategory.map(function(dt) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButton, {
                                                            width: [
                                                                "100px",
                                                                ,
                                                                "140px"
                                                            ],
                                                            variant: new bignumber/* default */.Z(selectCategory).isEqualTo(dt === null || dt === void 0 ? void 0 : dt.id) ? "primary" : "text",
                                                            onClick: function() {
                                                                return handleChangeCategory(dt === null || dt === void 0 ? void 0 : dt.id);
                                                            },
                                                            children: dt === null || dt === void 0 ? void 0 : dt.title
                                                        })
                                                    });
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ElectronicGiftCard_CsFlexNext, {
                                                onClick: function() {
                                                    var ref;
                                                    return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftCircle/* default */.Z, {
                                                    width: "32px",
                                                    style: {
                                                        cursor: "pointer",
                                                        transform: "rotate(180deg)"
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexPc, {
                                    width: "100%",
                                    alignItems: "center",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    mt: "1rem",
                                    children: concatCategory === null || concatCategory === void 0 ? void 0 : concatCategory.map(function(dt) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButton, {
                                            width: [
                                                "100px",
                                                ,
                                                "140px"
                                            ],
                                            variant: new bignumber/* default */.Z(selectCategory).isEqualTo(dt === null || dt === void 0 ? void 0 : dt.id) ? "primary" : "text",
                                            onClick: function() {
                                                return handleChangeCategory(dt === null || dt === void 0 ? void 0 : dt.id);
                                            },
                                            children: dt === null || dt === void 0 ? void 0 : dt.title
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Filter, {
                                    setFillAmount: function(newAmount) {
                                        return dispatch((0,actions/* fetchFillAmount */.fZ)({
                                            fillAmount: newAmount
                                        }));
                                    },
                                    fillAmount: fillAmount,
                                    setSelectBrand: setSelectBrand,
                                    selectBrand: selectBrand,
                                    handleChangeInput: handleChangeInput,
                                    handleSelectReliGion: handleSelectReliGion,
                                    resultFilterProvince: resultFilterProvince,
                                    isError: isError,
                                    isDefaultBrand: isDefaultBrand,
                                    isDefaultProvince: isDefaultProvince,
                                    setIsDefaultBrand: setIsDefaultBrand,
                                    stockQuantity: stockQuantity,
                                    filterIsPrice: filterIsPrice,
                                    filterIsProduct: filterIsProduct,
                                    findProductRoute: findProductRoute,
                                    cardPrice: cardPrice,
                                    cardProduct: cardProduct,
                                    viewTag: viewTag,
                                    selectCategory: selectCategory,
                                    priceRoute: priceRoute,
                                    brandRoute: brandRoute,
                                    setOptionSelected: setOptionSelected,
                                    optionSelected: optionSelected,
                                    setCardPrice: setCardPrice
                                })
                            ]
                        }),
                        (brandRoute || priceRoute || filterIsPrice || filterIsProduct || resultFilterBrand !== undefined) && isShowListByChangeCategory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (resultFilterTypeOne === null || resultFilterTypeOne === void 0 ? void 0 : resultFilterTypeOne.length) !== 0 || (filterTypeTwo === null || filterTypeTwo === void 0 ? void 0 : filterTypeTwo.length) !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            width: "100%",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            mt: [
                                                "3rem",
                                                ,
                                                "5rem"
                                            ],
                                            style: {
                                                gap: "1rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonTab, {
                                                    disabled: (sortBrandItemOne === null || sortBrandItemOne === void 0 ? void 0 : sortBrandItemOne.length) === 0,
                                                    width: [
                                                        "140px",
                                                        ,
                                                        "180px"
                                                    ],
                                                    variant: viewTag === "1" ? "primary" : "text",
                                                    onClick: function() {
                                                        return setViewTag("1");
                                                    },
                                                    children: "Mệnh gi\xe1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonTab, {
                                                    disabled: (sortBrandItemTwo === null || sortBrandItemTwo === void 0 ? void 0 : sortBrandItemTwo.length) === 0,
                                                    width: [
                                                        "140px",
                                                        ,
                                                        "180px"
                                                    ],
                                                    variant: viewTag === "2" ? "primary" : "text",
                                                    onClick: function() {
                                                        return setViewTag("2");
                                                    },
                                                    children: "Sản phẩm nổi bật"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                            width: "100%",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            flexDirection: "row",
                                            style: {
                                                transform: "translateY(-100px)"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                width: "100%",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            fontWeight: "bold",
                                                            children: "Chọn gi\xe1 trị thẻ qu\xe0"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            ml: "4px",
                                                            color: "red",
                                                            children: "*"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }) : "",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GiftCardList, {
                                    priceItem: !cardPrice ? priceRoute === null || priceRoute === void 0 ? void 0 : priceRoute.toString() : cardPrice === null || cardPrice === void 0 ? void 0 : (ref23 = cardPrice.price) === null || ref23 === void 0 ? void 0 : ref23.toString(),
                                    viewTag: viewTag,
                                    setViewTag: setViewTag,
                                    handleSelectPrice: handleSelectPrice,
                                    handleSelectCard: handleSelectCard,
                                    brandItem: !Number(resultFilterBrand === null || resultFilterBrand === void 0 ? void 0 : resultFilterBrand.id) && !(productRoute === null || productRoute === void 0 ? void 0 : productRoute.toString()) ? noProduct : brandItem,
                                    sortBrandItemOne: sortBrandItemOne,
                                    sortBrandItemTwo: sortBrandItemTwo,
                                    activeItem: !cardProduct ? findProductRoute : cardProduct,
                                    isDefaultBrand: isDefaultBrand,
                                    isDiffercent: viewTag === "1" ? checkViewTagBrand !== (selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.id) : checkViewTagBrand !== (selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.id),
                                    isResultFilterProvince: (resultFilterProvince === null || resultFilterProvince === void 0 ? void 0 : resultFilterProvince.length) > 0
                                })
                            ]
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: (cardPrice === null || cardPrice === void 0 ? void 0 : cardPrice.isNewBrand) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: checkViewTagBrand && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsWrapPolicy, {
                                    width: "100%",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            width: [
                                                "100%",
                                                ,
                                                ,
                                                "45%"
                                            ],
                                            flexDirection: "column",
                                            style: {
                                                gap: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    width: "100%",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                            scale: "lg",
                                                            children: "Điều kiện sử dụng"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsIconSort, {
                                                            color: "black",
                                                            onClick: toggling,
                                                            style: {
                                                                transform: isOpenLeft && "rotate(180deg)"
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerNote, {
                                                    isOpen: isOpenLeft,
                                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        width: "100%",
                                                        height: "100%",
                                                        justifyContent: "center",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                                            size: "small"
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: checkViewTagNote ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            children: notes === null || notes === void 0 ? void 0 : notes.map(function(dt) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: dt
                                                                });
                                                            })
                                                        }) : !checkViewTagNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            textAlign: "center",
                                                            mt: "2rem",
                                                            children: "Kh\xf4ng c\xf3 dữ liệu"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            width: [
                                                "100%",
                                                ,
                                                ,
                                                "45%"
                                            ],
                                            flexDirection: "column",
                                            style: {
                                                gap: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                    width: "100%",
                                                    justifyContent: "space-between",
                                                    flexWrap: "wrap",
                                                    alignItems: "center",
                                                    style: {
                                                        gap: "12px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        width: "100%",
                                                        justifyContent: "space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                                scale: "lg",
                                                                children: "Địa điểm \xe1p dụng"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsIconSort, {
                                                                color: "black",
                                                                onClick: togglingRight,
                                                                style: {
                                                                    transform: isOpenRight && "rotate(180deg)"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrapContainerScroll, {
                                                    isOpen: isOpenRight,
                                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        width: "100%",
                                                        height: "100%",
                                                        justifyContent: "center",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                                            size: "small"
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProvinceHome/* default */.Z, {
                                                                className: "select-office-main",
                                                                options: (listProvineSupport === null || listProvineSupport === void 0 ? void 0 : listProvineSupport.length) === 0 ? [] : listProvineSupport,
                                                                placeHolderText: "Tất cả c\xe1c khu vực",
                                                                onOptionChange: handleSelectProvince,
                                                                isDefaultProvince: false,
                                                                selectedOption: (province === null || province === void 0 ? void 0 : province.find(function(item) {
                                                                    var ref;
                                                                    return (item === null || item === void 0 ? void 0 : (ref = item.provinceId) === null || ref === void 0 ? void 0 : ref.toString()) === (selectProvinceState === null || selectProvinceState === void 0 ? void 0 : selectProvinceState.toString());
                                                                })) || selectProvinceState,
                                                                isLoading: false,
                                                                disabled: selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.isNewBrand
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerScroll, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: cardPrice === null || cardPrice === void 0 ? void 0 : (ref24 = cardPrice.office) === null || ref24 === void 0 ? void 0 : ref24.map(function(dt) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerCard, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                                                    width: "60px",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationV2/* default */.Z, {})
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                                                    width: "100%",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                        children: dt
                                                                                    })
                                                                                })
                                                                            ]
                                                                        });
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: isDefaultBrand === false && checkViewTagProvince && (checkViewTagBrand === (selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.id) || checkViewTagBrand === (selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.id)) && (resultFilterProvince === null || resultFilterProvince === void 0 ? void 0 : resultFilterProvince.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsWrapPolicy, {
                                    width: "100%",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            width: [
                                                "100%",
                                                ,
                                                ,
                                                "45%"
                                            ],
                                            flexDirection: "column",
                                            style: {
                                                gap: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    width: "100%",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                            scale: "lg",
                                                            children: "Điều kiện sử dụng"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsIconSort, {
                                                            color: "black",
                                                            onClick: toggling,
                                                            style: {
                                                                transform: isOpenLeft && "rotate(180deg)"
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerNote, {
                                                    isOpen: isOpenLeft,
                                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        width: "100%",
                                                        height: "100%",
                                                        justifyContent: "center",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                                            size: "small"
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            (priceRoute || cardPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: checkViewTagNote ? // eslint-disable-next-line react/no-danger
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: checkViewTagNote
                                                                    }
                                                                }) : !checkViewTagNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                    textAlign: "center",
                                                                    mt: "2rem",
                                                                    children: "Kh\xf4ng c\xf3 dữ liệu"
                                                                })
                                                            }),
                                                            (productRoute || cardProduct) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: checkViewTagNote ? // eslint-disable-next-line react/no-danger
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: checkViewTagNote
                                                                    }
                                                                }) : !checkViewTagNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                    textAlign: "center",
                                                                    mt: "2rem",
                                                                    children: "Kh\xf4ng c\xf3 dữ liệu"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            width: [
                                                "100%",
                                                ,
                                                ,
                                                "45%"
                                            ],
                                            flexDirection: "column",
                                            style: {
                                                gap: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                    width: "100%",
                                                    justifyContent: "space-between",
                                                    flexWrap: "wrap",
                                                    alignItems: "center",
                                                    style: {
                                                        gap: "12px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        width: "100%",
                                                        justifyContent: "space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                                scale: "lg",
                                                                children: "Địa điểm \xe1p dụng"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsIconSort, {
                                                                color: "black",
                                                                onClick: togglingRight,
                                                                style: {
                                                                    transform: isOpenRight && "rotate(180deg)"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrapContainerScroll, {
                                                    isOpen: isOpenRight,
                                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        width: "100%",
                                                        height: "100%",
                                                        justifyContent: "center",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                                            size: "small"
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProvinceHome/* default */.Z, {
                                                                className: "select-office-main",
                                                                options: (listProvineSupport === null || listProvineSupport === void 0 ? void 0 : listProvineSupport.length) === 0 ? [] : listProvineSupport,
                                                                placeHolderText: "Tất cả c\xe1c khu vực",
                                                                onOptionChange: handleSelectProvince,
                                                                isDefaultProvince: false,
                                                                selectedOption: (province === null || province === void 0 ? void 0 : province.find(function(item) {
                                                                    var ref;
                                                                    return (item === null || item === void 0 ? void 0 : (ref = item.provinceId) === null || ref === void 0 ? void 0 : ref.toString()) === (selectProvinceState === null || selectProvinceState === void 0 ? void 0 : selectProvinceState.toString());
                                                                })) || selectProvinceState,
                                                                isLoading: false,
                                                                disabled: selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.isNewBrand
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerScroll, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        (priceRoute || cardPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                            children: // filterCityIdCardPrice?.length === 0 || filterCityIdCardPrice === undefined ?
                                                                            // <Text textAlign="center" mt="2rem">Không có dữ liệu</Text> :
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                children: (filterCityIdCardPrice === null || filterCityIdCardPrice === void 0 ? void 0 : filterCityIdCardPrice.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                    children: filterCityIdCardPrice.map(function(dt) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerCard, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                                                                    width: "60px",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationV2/* default */.Z, {})
                                                                                                }),
                                                                                                (selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.isNewBrand) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                                                                    width: "100%",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                                        children: dt
                                                                                                    })
                                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                                                                    width: "100%",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                                        children: dt === null || dt === void 0 ? void 0 : dt.address
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        });
                                                                                    })
                                                                                })
                                                                            })
                                                                        }),
                                                                        (productRoute || cardProduct) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                            children: (filterCityIdCardProduct === null || filterCityIdCardProduct === void 0 ? void 0 : filterCityIdCardProduct.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                children: filterCityIdCardProduct === null || filterCityIdCardProduct === void 0 ? void 0 : filterCityIdCardProduct.map(function(dt) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerCard, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                                                                width: "60px",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationV2/* default */.Z, {})
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                                                                width: "100%",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                                    children: dt === null || dt === void 0 ? void 0 : dt.address
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    });
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Info, {
                            router: deeplinkFunc,
                            phoneNumber: phoneAuth,
                            phoneNumberRoute: phoneNumberRoute,
                            setPhoneNumber: function(newPhoneNumber) {
                                dispatch((0,actions/* fetchFillPhoneNumber */.gi)({
                                    phoneNumber: newPhoneNumber
                                }));
                            },
                            email: emailAuth,
                            setEmail: function(newEmail) {
                                return dispatch((0,actions/* fetchFillEmail */.cv)({
                                    email: newEmail
                                }));
                            },
                            setDeliveryMethod: setDeliveryMethod,
                            deliveryMethod: deliveryMethod,
                            isError: isError,
                            handleChangeInfo: handleChangeInfo,
                            account: account
                        }),
                        (brandRoute || priceRoute || filterIsPrice || filterIsProduct || resultFilterBrand !== undefined) && isShowListByChangeCategory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    mt: [
                                        "0.5rem",
                                        ,
                                        ,
                                        "1rem"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            width: [
                                                "150px",
                                                ,
                                                "200px"
                                            ],
                                            fontSize: [
                                                "14px",
                                                ,
                                                "16px"
                                            ],
                                            children: "T\xean sản phẩm"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexInfo, {
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: [
                                                    "14px",
                                                    ,
                                                    "16px"
                                                ],
                                                children: viewTag === "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: isDefaultBrand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: priceRoute && !cardPrice ? "".concat(voucherName, " ").concat(selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.title, " ").concat((0,formatNumber/* formatNumber */.u)(priceRoute)).concat(config/* UNIT_TOKEN */.eC) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: filterIsPrice && cardPrice && "".concat(voucherName, " ").concat(selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.title, " ").concat((0,formatNumber/* formatNumber */.u)(cardPrice === null || cardPrice === void 0 ? void 0 : cardPrice.price)).concat(config/* UNIT_TOKEN */.eC)
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: isDefaultBrand ? "" : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: productRoute && !cardProduct ? productRoute ? "".concat(voucherName, " ").concat(findProductRoute === null || findProductRoute === void 0 ? void 0 : findProductRoute.title) : cardProduct === null || cardProduct === void 0 ? void 0 : cardProduct.title : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                " ",
                                                                filterIsProduct && cardProduct && "".concat(voucherName, "] ").concat(cardProduct === null || cardProduct === void 0 ? void 0 : (ref25 = cardProduct.title) === null || ref25 === void 0 ? void 0 : ref25.replace(voucherName, ""))
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justifyContent: [
                                        "space-between",
                                        ,
                                        "flex-start"
                                    ],
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            width: [
                                                "150px",
                                                ,
                                                "200px"
                                            ],
                                            fontSize: [
                                                "14px",
                                                ,
                                                "16px"
                                            ],
                                            children: "Nh\xe0 cung cấp"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexInfo, {
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: [
                                                    "14px",
                                                    ,
                                                    "16px"
                                                ],
                                                children: isDefaultBrand ? "" : productRoute ? selectBrand ? selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.title : findProductRoute === null || findProductRoute === void 0 ? void 0 : findProductRoute.brand_name : selectBrand === null || selectBrand === void 0 ? void 0 : selectBrand.title
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            justifyContent: [
                                "space-between",
                                ,
                                "flex-start"
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: [
                                        "150px",
                                        ,
                                        "200px"
                                    ],
                                    fontSize: [
                                        "14px",
                                        ,
                                        "16px"
                                    ],
                                    children: "Số điện thoại"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexInfo, {
                                    justifyContent: "flex-start",
                                    alignItems: [
                                        "flex-end",
                                        ,
                                        "flex-start"
                                    ],
                                    flexDirection: "column",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: [
                                            "14px",
                                            ,
                                            "16px"
                                        ],
                                        children: phoneAuth
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            justifyContent: [
                                "space-between",
                                ,
                                "flex-start"
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: [
                                        "150px",
                                        ,
                                        "200px"
                                    ],
                                    fontSize: [
                                        "14px",
                                        ,
                                        "16px"
                                    ],
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexInfo, {
                                    justifyContent: "flex-start",
                                    alignItems: [
                                        "flex-end",
                                        ,
                                        "flex-start"
                                    ],
                                    flexDirection: "column",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: [
                                            "14px",
                                            ,
                                            "16px"
                                        ],
                                        children: emailAuth
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            justifyContent: [
                                "space-between",
                                ,
                                "flex-start"
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: [
                                        "150px",
                                        ,
                                        "200px"
                                    ],
                                    fontSize: [
                                        "14px",
                                        ,
                                        "16px"
                                    ],
                                    children: "Tổng gi\xe1 trị"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexInfo, {
                                    justifyContent: "flex-start",
                                    alignItems: [
                                        "flex-end",
                                        ,
                                        "flex-start"
                                    ],
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            fontWeight: 700,
                                            fontSize: [
                                                "14px",
                                                ,
                                                "16px"
                                            ],
                                            children: [
                                                isDefaultBrand ? "0".concat(config/* UNIT_TOKEN */.eC) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        " ",
                                                        (0,formatNumber/* formatNumber */.u)(totalPrice),
                                                        " ",
                                                        config/* UNIT_TOKEN */.eC,
                                                        " "
                                                    ]
                                                }),
                                                " "
                                            ]
                                        }),
                                        findTokenPayment && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubBalance, {
                                            fontSize: [
                                                "12px",
                                                ,
                                                "14px"
                                            ],
                                            children: isDefaultBrand ? "0 điểm ".concat(findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref26 = findTokenPayment.token) === null || ref26 === void 0 ? void 0 : ref26.symbol) : "Tương đương ".concat((0,formatNumber/* formatNumberv2 */.L)(findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.exchangeRate, findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref27 = findTokenPayment.token) === null || ref27 === void 0 ? void 0 : ref27.symbol), " điểm ").concat(findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref28 = findTokenPayment.token) === null || ref28 === void 0 ? void 0 : ref28.symbol)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            mt: "1rem",
                            mb: "1rem",
                            fontWeight: "bold",
                            fontSize: [
                                "14px",
                                ,
                                "16px"
                            ],
                            color: "red",
                            children: "*Lưu \xfd: Vui l\xf2ng kiểm tra th\xf4ng tin trước khi tiếp tục"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            minWidth: "40%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: !account ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConnectWalletButton/* default */.Z, {
                                routePath: deeplinkFunc,
                                children: [
                                    "Kết nối v\xed",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                                        ml: "4px",
                                        color: "white",
                                        style: {
                                            transform: "rotate(270deg)"
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ElectronicGiftCard_CsButtonContinue, {
                                onClick: handleContinue,
                                style: {
                                    cursor: "pointer"
                                },
                                endIcon: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                    color: "white",
                                    spin: true
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                                    ml: "4px",
                                    color: "white",
                                    style: {
                                        transform: "rotate(270deg)"
                                    }
                                }),
                                disabled: isLoading || !(phoneAuth === null || phoneAuth === void 0 ? void 0 : phoneAuth.match(phoneno)) || !(emailAuth === null || emailAuth === void 0 ? void 0 : emailAuth.match(mailformat)) || Number(fillAmount) < 1 || Number(fillAmount) > 30 || Number(fillAmount) > stockQuantity || cardProduct === null && priceRoute === undefined && cardPrice === null && productRoute === undefined || (resultFilterProvince === null || resultFilterProvince === void 0 ? void 0 : resultFilterProvince.length) === 0 || !findTokenPayment,
                                children: "Tiếp tục"
                            })
                        })
                    ]
                })
            })
        })
    });
};
var ElectronicGiftCard_CsButtonContinue = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-5321f850-0"
})(ElectronicGiftCard_templateObject());
var ElectronicGiftCard_CsFlexNext = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5321f850-1"
})(ElectronicGiftCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
});
var CsFlexInfo = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5321f850-2"
})(ElectronicGiftCard_templateObject2(), Text/* default */.Z);
var CsFlexMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5321f850-3"
})(ElectronicGiftCard_templateObject3());
var CsFlexPc = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5321f850-4"
})(ElectronicGiftCard_templateObject4());
var ContainerNote = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5321f850-5"
})(ElectronicGiftCard_templateObject5(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "200px" : "0";
});
var CsWrapContainerScroll = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5321f850-6"
})(ElectronicGiftCard_templateObject6(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "200px" : "0";
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "block" : "none";
});
var ContainerScroll = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5321f850-7"
})(ElectronicGiftCard_templateObject7());
var ContainerCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5321f850-8"
})(ElectronicGiftCard_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CsWrapPolicy = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5321f850-9"
})(ElectronicGiftCard_templateObject9());
var CsIconSort = (0,styled_components_browser_esm/* default */.ZP)(ArrowDownIcon/* default */.Z).withConfig({
    componentId: "sc-5321f850-10"
})(ElectronicGiftCard_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.border;
});
/* harmony default export */ var GiftCards_ElectronicGiftCard = (ElectronicGiftCard);

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(199);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Copy.tsx
var Copy = __webpack_require__(84298);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(98130);
// EXTERNAL MODULE: ./src/state/myvouchers/actions.ts
var myvouchers_actions = __webpack_require__(624);
;// CONCATENATED MODULE: ./src/views/GiftCards/InformationOrder.tsx



function InformationOrder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    text-align: center;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 26px;\n    text-decoration-line: underline;\n    cursor: pointer;\n"
    ]);
    InformationOrder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 4px;\n"
    ]);
    InformationOrder_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        gap: 10px;\n        flex-direction: column;\n        justify-content: flex-start;\n        border: none;\n        ",
        "{\n            font-size: 14px;\n        }\n        @media screen and (max-width: 768px){\n            padding: 1rem;\n            border: 1px solid ",
        ";\n            ",
        "{\n                font-size: 12px;\n            }\n        }\n"
    ]);
    InformationOrder_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    border-radius: 8px;\n    border: none;\n    @media screen and (max-width: 768px){\n        padding: 1rem;\n        border: 1px solid ",
        ";\n    }\n"
    ]);
    InformationOrder_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    flex-direction: column;\n    gap: 10px;\n    ",
        "{\n        font-size: 14px;\n        @media screen and (max-width: 768px){\n            font-size: 12px;\n            text-align: left;\n            justify-content: flex-start;\n        }\n    }\n"
    ]);
    InformationOrder_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    flex-direction: column;\n    gap: 10px;\n    ",
        "{\n        font-size: 14px;\n        text-align: right;\n        @media screen and (max-width: 768px){\n            font-size: 12px;\n            justify-content: flex-end;\n        }\n    }\n"
    ]);
    InformationOrder_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: left;\n    width: 100%;\n    @media screen and (max-width: 768px){\n        width: 100%;\n        text-align: right;\n    }\n"
    ]);
    InformationOrder_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    white-space: nowrap;\n    /* width: 20%; */\n    @media screen and (max-width: 768px){\n        width: 100%;\n        text-align: right;\n    }\n"
    ]);
    InformationOrder_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: right;\n    white-space: nowrap;\n    @media screen and (max-width: 768px){\n        text-align: right;\n        width: 100%;\n    }\n"
    ]);
    InformationOrder_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        gap: 4rem;\n        flex-direction: row;\n        @media screen and (max-width: 768px){\n            flex-direction: column;\n            gap: 1rem;\n            >div{\n                margin-top: 1rem;\n            }\n        }\n"
    ]);
    InformationOrder_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 34px;\n    height: 34px;\n    object-fit: contain;\n    display: flex;\n    justify-content: center;\n    background: ",
        ";\n    border-radius: 36.815px;\n    cursor: pointer;\n    @media screen and (max-width: 768px) {\n        width: 28px;\n        height: 28px;\n        object-fit: contain;\n        svg{\n            width: 14px;\n            height: 14px;\n        }\n    }\n    &:active{\n        transform: translateY(1px);\n    }\n"
    ]);
    InformationOrder_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function InformationOrder_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: ",
        ";\n    position: absolute;\n    top:-34px;\n    right: 0;\n    text-align: center;\n    color: ",
        ";\n    border-radius: 16px;\n    opacity: 0.9;\n    background: ",
        ";\n    padding: 10px;\n    z-index: 1;\n    font-size: 12px;\n"
    ]);
    InformationOrder_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}



















var InformationOrder = function() {
    var displayTooltipCode = function displayTooltipCode() {
        setIsTooltipDisplayed(true);
        setTimeout(function() {
            setIsTooltipDisplayed(false);
        }, 3000);
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var dispatch = (0,es/* useDispatch */.I0)();
    var dataGiftcards = (0,giftCards/* GetDataGiftCards */.n3)();
    var dataBuyVouchers = dataGiftcards.dataBuyVouchers, activeTokenPayment = dataGiftcards.activeTokenPayment, tokenSupport = dataGiftcards.tokenSupport, dataVouchers = dataGiftcards.dataVouchers;
    var ref6 = (0,react.useState)(false), isTooltipDisplayed = ref6[0], setIsTooltipDisplayed = ref6[1];
    var handleBack = function(newValue) {
        dispatch((0,actions/* fetchStatusScreen */.an)({
            isActiveScreen: newValue
        }));
    };
    var handleCoppy = function() {
        if (navigator.clipboard && navigator.permissions) {
            navigator.clipboard.writeText(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.transactionHash).then(function() {
                return displayTooltipCode();
            });
        } else if (document.queryCommandSupported("copy")) {
            var ele = document.createElement("textarea");
            ele.value = dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.transactionHash;
            document.body.appendChild(ele);
            ele.select();
            document.execCommand("copy");
            document.body.removeChild(ele);
            displayTooltipCode();
        }
    };
    var fotmatDate = function(newDate) {
        if ((newDate === null || newDate === void 0 ? void 0 : newDate.length) > 0) {
            var date = new Date(newDate);
            var month = date.getMonth() < 10 ? "0".concat(date.getMonth() + 1) : date.getMonth() + 1;
            return "".concat((0,index_es/* zeroPad */.Bu)(date.getDate()), "/").concat(month, "/").concat(date.getFullYear(), " ").concat((0,index_es/* zeroPad */.Bu)(date === null || date === void 0 ? void 0 : date.getHours()), ":").concat((0,index_es/* zeroPad */.Bu)(date === null || date === void 0 ? void 0 : date.getMinutes()));
        }
        return null;
    };
    var sAccount = function(txHash) {
        if ((txHash === null || txHash === void 0 ? void 0 : txHash.length) > 0) {
            return "".concat(txHash.substring(0, 4), "...").concat(txHash.substring(txHash.length - 4));
        }
        return null;
    };
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,actions/* fetchStatusScreen */.an)({
                                isActiveScreen: 0
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* fetchActivePrice */.kW)({
                                price: null
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* fetchActiveBrand */.fu)({
                                product: null
                            }))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            router === null || router === void 0 ? void 0 : router.push("/order")
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleGoHistory = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,myvouchers_actions/* fetTabActive */.kr)({
                                tabActive: 2
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            router === null || router === void 0 ? void 0 : router.push("/myvoucher")
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleGoHistory() {
            return _ref.apply(this, arguments);
        };
    }();
    var findTokenPayment = (0,react.useMemo)(function() {
        return tokenSupport.find(function(dt) {
            var ref, ref1, ref2;
            return (dt === null || dt === void 0 ? void 0 : (ref = dt.token) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === (dataVouchers === null || dataVouchers === void 0 ? void 0 : (ref2 = dataVouchers.tokenPayment) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase());
        });
    }, [
        tokenSupport,
        dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.tokenPayment
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageFullWidth/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                width: "100%",
                mb: "4rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    flexDirection: "column",
                    style: {
                        gap: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                style: {
                                    gap: "12px",
                                    cursor: "pointer",
                                    width: "fit-content"
                                },
                                onClick: function() {
                                    return handleBack(0);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftCircle/* default */.Z, {
                                        width: "32px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        scale: "lg",
                                        children: "Quay lại"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            mt: "1rem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsHeading, {
                                    scale: "xl",
                                    children: "Th\xf4ng tin đơn h\xe0ng"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexInfoPersonReceipt, {
                            width: "100%",
                            justifyContent: "space-between",
                            mt: [
                                "1rem",
                                ,
                                "3rem"
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            fontWeight: "bold",
                                            fontSize: [
                                                "16px",
                                                ,
                                                "20px"
                                            ],
                                            children: "Th\xf4ng tin người nhận qu\xe0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationOrder_CsWrapInfo, {
                                            width: "100%",
                                            alignItems: "flex-start",
                                            justifyContent: "space-between",
                                            mt: [
                                                "0.5rem",
                                                ,
                                                ,
                                                "2rem"
                                            ],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    width: "100%",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            color: "default",
                                                            children: "Số điện thoại:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            children: dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.phoneNo
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    width: "100%",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            color: "default",
                                                            children: "Email:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            children: dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.email
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            fontWeight: "bold",
                                            fontSize: [
                                                "16px",
                                                ,
                                                "20px"
                                            ],
                                            children: "Chi tiết đơn h\xe0ng"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsGiftCardInfo2, {
                                            mt: [
                                                "0.5rem",
                                                ,
                                                ,
                                                "2rem"
                                            ],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexLine2, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextFirst2, {
                                                            color: "default",
                                                            children: "M\xe3 đơn h\xe0ng:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationOrder_CsText, {
                                                            color: "default",
                                                            children: "TXID:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationOrder_CsText, {
                                                            color: "default",
                                                            children: "Ng\xe0y giao dịch:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextLast, {
                                                            color: "default",
                                                            children: "Ng\xe0y hết hạn voucher:"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexLine2Body, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextFirst2, {
                                                            children: dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.orderId
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                            width: "100%",
                                                            justifyContent: "flex-end",
                                                            style: {
                                                                gap: "4px",
                                                                position: "relative"
                                                            },
                                                            alignItems: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                    external: true,
                                                                    href: (0,utils/* getBlockExploreLink */.C)(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.transactionHash, "transaction", Number(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.chainId)),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationOrder_CsText, {
                                                                        color: "primary",
                                                                        children: sAccount(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.transactionHash)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrapIconCoppy, {
                                                                    onClick: handleCoppy,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy/* default */.Z, {})
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                                                                    isTooltipDisplayed: isTooltipDisplayed,
                                                                    children: "Đ\xe3 sao ch\xe9p"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationOrder_CsText, {
                                                            children: fotmatDate(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.createdAt)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextLast, {
                                                            children: dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.itemExpired
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            mt: "1rem",
                            fontWeight: "bold",
                            fontSize: [
                                "16px",
                                ,
                                "20px"
                            ],
                            children: "Th\xf4ng tin thẻ qu\xe0 tặng"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsGiftCardInfoPC, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexLine, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItemHeading, {
                                            isFirst: true,
                                            color: "default",
                                            children: "T\xean sản phẩm"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItemHeading, {
                                            color: "default",
                                            children: "Số lượng"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItemHeading, {
                                            color: "default",
                                            children: "Gi\xe1 trị thẻ qu\xe0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItemHeading, {
                                            color: "default",
                                            children: "Tổng gi\xe1 trị"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexLine, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItem, {
                                            isFirst: true,
                                            children: dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.itemName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItem, {
                                            children: dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.quantity
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItem, {
                                            children: (dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.isPromo) === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        children: [
                                                            Number(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.promoPrice).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            }),
                                                            config/* UNIT_TOKEN */.eC
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        style: {
                                                            fontSize: "12px",
                                                            textDecoration: "line-through",
                                                            color: "#9596a6"
                                                        },
                                                        children: [
                                                            Number(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.unitPrice).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            }),
                                                            config/* UNIT_TOKEN */.eC
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    children: [
                                                        Number(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.unitPrice).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }),
                                                        config/* UNIT_TOKEN */.eC
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowItem, {
                                            children: [
                                                (0,formatNumber/* formatNumber */.u)(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.totalAmount),
                                                config/* UNIT_TOKEN */.eC,
                                                (findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref = findTokenPayment.token) === null || ref === void 0 ? void 0 : ref.symbol) !== "VNDC" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    style: {
                                                        fontSize: "10px"
                                                    },
                                                    children: [
                                                        "Tương đương ",
                                                        (0,formatNumber/* formatNumberv2 */.L)(findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.exchangeRate, findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref1 = findTokenPayment.token) === null || ref1 === void 0 ? void 0 : ref1.symbol),
                                                        " điểm ",
                                                        findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref2 = findTokenPayment.token) === null || ref2 === void 0 ? void 0 : ref2.symbol
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsGiftCardInfoMobile, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "flex-end",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            style: {
                                                whiteSpace: "nowrap"
                                            },
                                            color: "default",
                                            children: "T\xean sản phẩm"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            textAlign: "right",
                                            children: dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.itemName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "flex-end",
                                    justifyContent: "space-between",
                                    mt: "0.5rem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "default",
                                            children: "Số lượng"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            textAlign: "right",
                                            children: dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.quantity
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "flex-end",
                                    justifyContent: "space-between",
                                    mt: "0.5rem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "default",
                                            children: "Gi\xe1 trị thẻ qu\xe0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            textAlign: "right",
                                            children: (dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.isPromo) === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        children: [
                                                            Number(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.promoPrice).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            }),
                                                            config/* UNIT_TOKEN */.eC
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        style: {
                                                            fontSize: "10px",
                                                            textDecoration: "line-through",
                                                            color: "#9596a6"
                                                        },
                                                        children: [
                                                            Number(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.unitPrice).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            }),
                                                            config/* UNIT_TOKEN */.eC
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    children: [
                                                        Number(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.unitPrice).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }),
                                                        config/* UNIT_TOKEN */.eC
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "flex-end",
                                    justifyContent: "space-between",
                                    mt: "0.5rem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "default",
                                            children: "Tổng gi\xe1 trị"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            flexDirection: "column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    textAlign: "right",
                                                    children: [
                                                        (0,formatNumber/* formatNumber */.u)(dataBuyVouchers === null || dataBuyVouchers === void 0 ? void 0 : dataBuyVouchers.totalAmount),
                                                        config/* UNIT_TOKEN */.eC
                                                    ]
                                                }),
                                                (findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref3 = findTokenPayment.token) === null || ref3 === void 0 ? void 0 : ref3.symbol) !== "VNDC" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    style: {
                                                        fontSize: "10px"
                                                    },
                                                    children: [
                                                        "Tương đương",
                                                        " ",
                                                        (0,formatNumber/* formatNumberv2 */.L)(findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.exchangeRate, findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref4 = findTokenPayment.token) === null || ref4 === void 0 ? void 0 : ref4.symbol),
                                                        " ",
                                                        "điểm ",
                                                        findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref5 = findTokenPayment.token) === null || ref5 === void 0 ? void 0 : ref5.symbol
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            minWidth: "40%",
                            justifyContent: "center",
                            alignItems: "center",
                            mt: "2rem",
                            children: !account ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConnectWalletButton/* default */.Z, {
                                children: [
                                    "Kết nối v\xed",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                                        ml: "4px",
                                        color: "white",
                                        style: {
                                            transform: "rotate(270deg)"
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        onClick: handleGoHistory,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextNextLink, {
                                            children: " Lịch sử giao dịch"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationOrder_CsButtonContinue, {
                                        mt: "1rem",
                                        style: {
                                            cursor: "pointer"
                                        },
                                        onClick: handleClick,
                                        children: [
                                            "Tiếp tục đổi Voucher",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                                                ml: "4px",
                                                color: "white",
                                                style: {
                                                    transform: "rotate(270deg)"
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
var CsTextNextLink = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-ad1e077e-0"
})(InformationOrder_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var InformationOrder_CsButtonContinue = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-ad1e077e-1"
})(InformationOrder_templateObject1());
var InformationOrder_CsWrapInfo = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ad1e077e-2"
})(InformationOrder_templateObject2(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.border;
}, Text/* default */.Z);
var CsGiftCardInfo2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ad1e077e-3"
})(InformationOrder_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.border;
});
var CsFlexLine2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ad1e077e-4"
})(InformationOrder_templateObject4(), Text/* default */.Z);
var CsFlexLine2Body = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ad1e077e-5"
})(InformationOrder_templateObject5(), Text/* default */.Z);
var CsTextFirst2 = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-ad1e077e-6"
})(InformationOrder_templateObject6());
var InformationOrder_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-ad1e077e-7"
})(InformationOrder_templateObject7());
var CsTextLast = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-ad1e077e-8"
})(InformationOrder_templateObject8());
var FlexInfoPersonReceipt = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ad1e077e-9"
})(InformationOrder_templateObject9());
var CsWrapIconCoppy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad1e077e-10"
})(InformationOrder_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.bgBtn;
});
var Tooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad1e077e-11"
})(InformationOrder_templateObject11(), function(param) {
    var isTooltipDisplayed = param.isTooltipDisplayed;
    return isTooltipDisplayed ? "block" : "none";
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.bgBtn;
});
/* harmony default export */ var GiftCards_InformationOrder = (InformationOrder);

// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(78258);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(61135);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TagPriceActiveFullWidth.tsx
var TagPriceActiveFullWidth = __webpack_require__(41410);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/ModalV2.tsx
var ModalV2 = __webpack_require__(82456);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 2 modules
var Toast = __webpack_require__(14605);
// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(96245);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 20 modules
var src = __webpack_require__(50726);
;// CONCATENATED MODULE: ./src/utils/getChainName.ts

var getChainName = function(chainId) {
    switch(chainId){
        case src/* ChainId.BSC */.a_.BSC:
            return "BNB Chain";
        case src/* ChainId.ONUS */.a_.ONUS:
            return "ONUS Chain";
        case src/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET:
            return "BNB Testnet";
        default:
            return "ONUS Chain";
    }
};

// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(86876);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButtonV2.tsx
var IconButtonV2 = __webpack_require__(82274);
;// CONCATENATED MODULE: ./src/views/GiftCards/components/ModalPaymentOnus.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 
function ModalPaymentOnus_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 24px 0;\n    min-width: 470px;\n    border-radius: 24px;\n    background: #fff;\n    box-shadow: 0px 4px 36px 0px rgba(31, 31, 31, 0.1);\n    @media screen and(max-width: 1024px) {\n        min-width: 300px;\n    }\n    @media screen and (max-width: 600px) {\n        min-width: 90%;\n    }\n"
    ]);
    ModalPaymentOnus_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalPaymentOnus_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    width: 100%;\n    display: flex;\n    gap: 12px;\n    border-radius: 12px;\n    padding: 0 10px;\n    @media screen and (max-width: 768px) {\n        padding: 0 15px;\n        gap: 4px;\n    }\n"
    ]);
    ModalPaymentOnus_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalPaymentOnus_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n"
    ]);
    ModalPaymentOnus_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalPaymentOnus_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 350px;\n    border-radius: 8px;\n    align-items: center;\n    justify-content: space-between;\n    height: 48px;\n    padding: 0px 0px 0px 12px;\n    background: #f0f0f0;\n    position: relative;\n    @media screen and (max-width:600px) {\n        width: 300px;\n    }\n"
    ]);
    ModalPaymentOnus_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalPaymentOnus_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: none;\n    height: 48px;\n    width: 48px;\n    border-top-right-radius: 8px;\n    border-bottom-right-radius: 8px;\n    background: #E6E9EC;\n"
    ]);
    ModalPaymentOnus_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalPaymentOnus_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: ",
        ";\n    position: absolute;\n    top:-34px;\n    right: -20px;\n    text-align: center;\n    color: ",
        ";\n    border-radius: 16px;\n    opacity: 0.9;\n    background: ",
        ";\n    padding: 10px;\n    z-index: 1;\n    font-size: 12px;\n"
    ]);
    ModalPaymentOnus_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var ModalPaymentOnus = function(param) {
    var title = param.title, ticketNumber = param.ticketNumber, onDismiss = param.onDismiss;
    var displayTooltipCode = function displayTooltipCode() {
        setIsTooltipDisplayed(true);
        setTimeout(function() {
            setIsTooltipDisplayed(false);
        }, 3000);
    };
    var router = (0,next_router.useRouter)();
    var handleComplete = function() {
        router.push("/myvoucher");
        onDismiss();
    };
    var ref = (0,react.useState)(false), isTooltipDisplayed = ref[0], setIsTooltipDisplayed = ref[1];
    var handleCoppy = function() {
        if (navigator.clipboard && navigator.permissions) {
            navigator.clipboard.writeText(ticketNumber).then(function() {
                return displayTooltipCode();
            });
        } else if (document.queryCommandSupported("copy")) {
            var ele = document.createElement("textarea");
            ele.value = ticketNumber;
            document.body.appendChild(ele);
            ele.select();
            document.execCommand("copy");
            document.body.removeChild(ele);
            displayTooltipCode();
        }
    };
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsModal, {
        title: title,
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            width: "100%",
            style: {
                gap: "1rem"
            },
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://wallet.vndc.io/run/tickets/".concat(ticketNumber, "/qr-code"),
                    alt: "qrcode",
                    style: {
                        width: "200px",
                        height: "200px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalPaymentOnus_CsFlex, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            children: ticketNumber
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsCopyIcon, {
                            onClick: handleCoppy,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPaymentOnus_Tooltip, {
                                    isTooltipDisplayed: isTooltipDisplayed,
                                    children: "Đ\xe3 sao ch\xe9p"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    flexDirection: "column",
                    style: {
                        gap: "1rem"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: isMobile ? "300px" : "350px",
                        onClick: handleComplete,
                        children: "X\xe1c nhận thanh to\xe1n"
                    })
                })
            ]
        })
    });
};
var CsModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
    componentId: "sc-95cdd57d-0"
})(ModalPaymentOnus_templateObject());
var CsContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-95cdd57d-1"
})(ModalPaymentOnus_templateObject1());
var Row = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-95cdd57d-2"
})(ModalPaymentOnus_templateObject2());
var ModalPaymentOnus_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-95cdd57d-3"
})(ModalPaymentOnus_templateObject3());
var CsCopyIcon = (0,styled_components_browser_esm/* default */.ZP)(IconButtonV2/* default */.Z).withConfig({
    componentId: "sc-95cdd57d-4"
})(ModalPaymentOnus_templateObject4());
var ModalPaymentOnus_Tooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-95cdd57d-5"
})(ModalPaymentOnus_templateObject5(), function(param) {
    var isTooltipDisplayed = param.isTooltipDisplayed;
    return isTooltipDisplayed ? "block" : "none";
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.bgBtn;
});
/* harmony default export */ var components_ModalPaymentOnus = (ModalPaymentOnus);

// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var localization_src = __webpack_require__(13193);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./src/hooks/useCallWithMarketGasPrice.ts







function useCallWithMarketGasPrice() {
    /**
     * Perform a contract call with a gas price returned from useGasPrice
     * @param contract Used to perform the call
     * @param methodName The name of the method called
     * @param methodArgs An array of arguments to pass to the method
     * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
     * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
     */ var callWithMarketGasPrice = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, tx, ref;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        (0,esm_exports/* addBreadcrumb */.n_)({
                            type: "Transaction",
                            message: "Call with market gas price",
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = get_default()(contract, methodName);
                        return [
                            4,
                            contractMethod.apply(void 0, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                                (0,_object_spread/* default */.Z)({}, overrides)
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        if (tx) {
                            ;
                            (0,esm_exports/* addBreadcrumb */.n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        callWithMarketGasPrice: callWithMarketGasPrice
    };
}

// EXTERNAL MODULE: ./src/hooks/useContract.ts + 22 modules
var useContract = __webpack_require__(60539);
// EXTERNAL MODULE: ./src/state/index.ts + 59 modules
var state = __webpack_require__(26192);
;// CONCATENATED MODULE: ./src/views/GiftCards/hook/useApprove.tsx













var useApprove = function(contractAddress, account, token, chainId, provider) {
    var ref = (0,useToast/* useToast */.p)(), toastSuccess = ref.toastSuccess, toastError = ref.toastError;
    var callWithMarketGasPrice = useCallWithMarketGasPrice().callWithMarketGasPrice;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var address = (0,useContract/* useCsERC20 */.cn)(token === null || token === void 0 ? void 0 : token.address);
    var ref1 = (0,react.useState)(false), pendingTx = ref1[0], setPendingTx = ref1[1];
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var handleApprove = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var tx, receipt, e, res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPendingTx(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        5,
                        7
                    ]);
                    return [
                        4,
                        callWithMarketGasPrice(address, "approve", [
                            contractAddress,
                            bignumbers/* MaxUint256 */.Bz
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        toastSuccess(t("Chấp thuận th\xe0nh c\xf4ng"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                    } else {
                        // user rejected tx or didn't go thru
                        toastError(t("Đ\xe3 xảy ra lỗi"), t("Vui l\xf2ng thử lại."));
                        setPendingTx(false);
                    }
                    return [
                        3,
                        7
                    ];
                case 4:
                    e = _state.sent();
                    console.error(e);
                    toastError(t("Đ\xe3 xảy ra lỗi"), t("Vui l\xf2ng thử lại."));
                    setPendingTx(false);
                    return [
                        3,
                        7
                    ];
                case 5:
                    setPendingTx(false);
                    return [
                        4,
                        (0,fetchData/* fetchPublicDataUser */.x7)(contractAddress, account, token, chainId, provider)
                    ];
                case 6:
                    res = _state.sent();
                    dispatch((0,actions/* fetchDataUser */.fL)(res));
                    return [
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    }), [
        callWithMarketGasPrice,
        address,
        contractAddress,
        toastSuccess,
        t,
        toastError,
        account,
        token,
        chainId,
        provider,
        dispatch
    ]);
    return {
        handleApprove: handleApprove,
        pendingTx: pendingTx
    };
};

// EXTERNAL MODULE: ./src/state/history/actions.ts
var history_actions = __webpack_require__(32752);
// EXTERNAL MODULE: ./src/state/history/fetchData.ts
var history_fetchData = __webpack_require__(8001);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/views/GiftCards/hook/useBuyVoucher.tsx













var useBuyVouchers = function(contractAddress, tokenAddress, account, chainId, decimal, orderId, amount) {
    var ref = (0,useToast/* useToast */.p)(), toastSuccess = ref.toastSuccess, toastError = ref.toastError;
    var callWithMarketGasPrice = useCallWithMarketGasPrice().callWithMarketGasPrice;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var contract = (0,useContract/* useBuyVoucher */.D4)(contractAddress);
    var ref1 = (0,react.useState)(false), pendingBuyVoucher = ref1[0], setPendingBuyVoucher = ref1[1];
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var currentTime = Date.now();
    var startTime = moment_default()(currentTime).subtract(15, "days").valueOf();
    var handleBuyVoucher = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var tx, receipt, e, resHistory;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPendingBuyVoucher(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        5,
                        7
                    ]);
                    return [
                        4,
                        callWithMarketGasPrice(contract, "buyItem", [
                            tokenAddress,
                            amount,
                            orderId === null || orderId === void 0 ? void 0 : orderId.toString()
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx === null || tx === void 0 ? void 0 : tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        // toastSuccess(
                        //     t('Quy đổi thành công'),
                        //     <ToastDescriptionWithTx txHash={receipt.transactionHash}/>
                        // )
                        dispatch((0,actions/* fetchFillAmount */.fZ)({
                            fillAmount: 0
                        }));
                        dispatch((0,actions/* fetchFillEmail */.cv)({
                            email: ""
                        }));
                        dispatch((0,actions/* fetchFillPhoneNumber */.gi)({
                            phoneNumber: ""
                        }));
                    } else {
                        // user rejected tx or didn't go thru
                        toastError(t("Đ\xe3 xảy ra lỗi"), t("Vui l\xf2ng thử lại."));
                    }
                    console.log("");
                    return [
                        2,
                        {
                            txHash: receipt === null || receipt === void 0 ? void 0 : receipt.transactionHash
                        }
                    ];
                case 4:
                    e = _state.sent();
                    toastError(t("Đ\xe3 xảy ra lỗi"), t("Kh\xf4ng đủ ph\xed gas. Vui l\xf2ng thử lại."));
                    setPendingBuyVoucher(false);
                    return [
                        2,
                        {
                            txHash: ""
                        }
                    ];
                case 5:
                    setPendingBuyVoucher(false);
                    return [
                        4,
                        (0,history_fetchData/* fetchHistoryData */.n)(account, new Date(startTime).toISOString(), new Date(Date.now()).toISOString(), "", "createdAt_des", 0, config/* PAGE_SIZE */.IV, chainId === null || chainId === void 0 ? void 0 : chainId.toString())
                    ];
                case 6:
                    resHistory = _state.sent();
                    dispatch((0,history_actions/* fetchHistory */.eL)(resHistory));
                    return [
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    }), [
        callWithMarketGasPrice,
        contract,
        amount,
        orderId,
        tokenAddress,
        toastSuccess,
        t,
        dispatch,
        toastError,
        account,
        startTime,
        chainId
    ]);
    return {
        handleBuyVoucher: handleBuyVoucher,
        pendingBuyVoucher: pendingBuyVoucher
    };
};

;// CONCATENATED MODULE: ./src/views/GiftCards/OrderSummary.tsx
/* eslint-disable camelcase */ 




function OrderSummary_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n    .classic-4 {\n        display: flex;\n        text-align: center;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        font-weight: bold;\n        height: 100%;\n        width: 100%;\n        font-size: 20px;\n    }\n    .loader {\n        border: 14px solid #fff;\n        border-top: 14px solid #01227a;\n        border-radius: 50%;\n        width: 80px;\n        height: 80px;\n        animation: spin 2s linear infinite;\n    }\n    @keyframes spin {\n        0% {\n            transform: rotate(0deg);\n        }\n        100% {\n            transform: rotate(360deg);\n        }\n    }\n"
    ]);
    OrderSummary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



























var OrderSummary = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var ref15 = (0,useActiveWeb3React/* default */.Z)(), account = ref15.account, chainId = ref15.chainId, provider = ref15.provider;
    var dispatch = (0,es/* useDispatch */.I0)();
    var theme = (0,useTheme/* default */.ZP)().theme;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var router = (0,next_router.useRouter)();
    var ref16 = (0,react.useState)(false), pendingBuyVoucher = ref16[0], setPendingBuyVoucher = ref16[1];
    var contractAddress = (0,addressHelpers/* getAddress */.Kn)(contracts/* default.buyVouchers */.Z.buyVouchers, chainId);
    // UseCoreDataUser(contractAddress, account, token, chainId)
    // useEffect(() => {
    //     (async() => {
    //         const listTokenByTypeChain = listTokenGetBalance(chainId)
    //         const resListBalance = await fetchBalanceByChain(account, listTokenByTypeChain )
    //         await dispatch(fetchDataUserByChain(resListBalance))
    //     })()
    // },[account, chainId, dispatch])
    var dataGiftcards = (0,giftCards/* GetDataGiftCards */.n3)();
    var dataVouchers = dataGiftcards.dataVouchers, isLoading = dataGiftcards.isLoading;
    var dataUser = dataGiftcards.dataUser, ListBalance = dataGiftcards.ListBalance, tokenSupport = dataGiftcards.tokenSupport;
    var handleBack = function(newValue) {
        dispatch((0,actions/* fetchStatusScreen */.an)({
            isActiveScreen: newValue
        }));
    };
    var dataLocalStorage = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(config/* KEY_LOGIN */.kW);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, tokenLocalStorage, decoded;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        tokenLocalStorage = dataLocalStorage;
                        return [
                            4,
                            (0,jwt_decode_esm/* default */.Z)(!tokenLocalStorage ? "" : tokenLocalStorage)
                        ];
                    case 1:
                        decoded = _state.sent();
                        if ((account === null || account === void 0 ? void 0 : account.length) === (decoded === null || decoded === void 0 ? void 0 : (ref = decoded.sub) === null || ref === void 0 ? void 0 : ref.length) && (account === null || account === void 0 ? void 0 : account.toLowerCase()) !== (decoded === null || decoded === void 0 ? void 0 : (ref1 = decoded.sub) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase())) {
                            localStorage.removeItem(config/* KEY_LOGIN */.kW);
                            dispatch((0,actions/* fetchStatusScreen */.an)({
                                isActiveScreen: 0
                            }));
                            dispatch((0,actions/* fetchIsUpdateOrder */.c1)({
                                isUpdate: true
                            }));
                            router === null || router === void 0 ? void 0 : router.push("/order");
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        account,
        dataLocalStorage,
        dispatch,
        router
    ]);
    var findTokenPayment = (0,react.useMemo)(function() {
        return tokenSupport.find(function(dt) {
            var ref, ref1, ref2;
            return (dt === null || dt === void 0 ? void 0 : (ref = dt.token) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === (dataVouchers === null || dataVouchers === void 0 ? void 0 : (ref2 = dataVouchers.tokenPayment) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase());
        });
    }, [
        tokenSupport,
        dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.tokenPayment
    ]);
    var checkPrice = (dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.isPromo) === 2 ? dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.promoPrice : dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.price;
    var totalPrice = (ref1 = (ref = new bignumber/* default */.Z(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.fillAmount)) === null || ref === void 0 ? void 0 : ref.multipliedBy(checkPrice)) === null || ref1 === void 0 ? void 0 : ref1.toString();
    var ref17 = (0,useToast/* useToast */.p)(), toastSuccess = ref17.toastSuccess, toastError = ref17.toastError;
    var ref18 = useApprove(contractAddress, account, findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.token, chainId, provider), handleApprove = ref18.handleApprove, pendingTx = ref18.pendingTx;
    var isNotBanlance = (0,react.useMemo)(function() {
        if (new bignumber/* default */.Z(dataUser === null || dataUser === void 0 ? void 0 : dataUser.balanceOf).isLessThan(findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.exchangeRate)) return !false;
        return false;
    }, [
        dataUser === null || dataUser === void 0 ? void 0 : dataUser.balanceOf,
        findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.exchangeRate
    ]);
    var isNotAllowance = (0,react.useMemo)(function() {
        if (new bignumber/* default */.Z(dataUser === null || dataUser === void 0 ? void 0 : dataUser.allowance).isLessThan(findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.exchangeRate)) return !false;
        return false;
    }, [
        dataUser === null || dataUser === void 0 ? void 0 : dataUser.allowance,
        findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.exchangeRate
    ]);
    var fillAmount = (ref2 = new bignumber/* default */.Z(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.fillAmount).multipliedBy((dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.isPromo) === 2 ? dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.promoPrice : dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.price)) === null || ref2 === void 0 ? void 0 : ref2.toString();
    var handleBuyVoucher = useBuyVouchers(contractAddress, findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref3 = findTokenPayment.token) === null || ref3 === void 0 ? void 0 : ref3.address, account, chainId, findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref4 = findTokenPayment.token) === null || ref4 === void 0 ? void 0 : ref4.decimals, dataVouchers === null || dataVouchers === void 0 ? void 0 : (ref5 = dataVouchers.orderId) === null || ref5 === void 0 ? void 0 : ref5.toString(), Number(fillAmount)).handleBuyVoucher;
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var txHash, ref, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPendingBuyVoucher(!false);
                        return [
                            4,
                            handleBuyVoucher()
                        ];
                    case 1:
                        txHash = _state.sent().txHash;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        return [
                            4,
                            brand/* BrandApi.verify */.X.verify({
                                transactionHash: txHash,
                                chainId: chainId === null || chainId === void 0 ? void 0 : chainId.toString(),
                                orderId: dataVouchers === null || dataVouchers === void 0 ? void 0 : (ref = dataVouchers.orderId) === null || ref === void 0 ? void 0 : ref.toString()
                            })
                        ];
                    case 3:
                        res = _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* fetchBuyVouchers */._Z)({
                                dataBuyVouchers: (0,_object_spread/* default */.Z)({}, res === null || res === void 0 ? void 0 : res.data)
                            }))
                        ];
                    case 4:
                        _state.sent();
                        return [
                            4,
                            setPendingBuyVoucher(false)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,actions/* fetchStatusScreen */.an)({
                                isActiveScreen: 2
                            }))
                        ];
                    case 6:
                        _state.sent();
                        toastSuccess("Quy đổi th\xe0nh c\xf4ng. Vui l\xf2ng kiểm tra email nhận", /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: txHash
                        }));
                        return [
                            3,
                            9
                        ];
                    case 7:
                        error = _state.sent();
                        console.log("error", error);
                        toastError("Đ\xe3 xảy ra lỗi", "Gửi email thất bại.");
                        setPendingBuyVoucher(false);
                        return [
                            3,
                            9
                        ];
                    case 8:
                        setPendingBuyVoucher(false);
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref19 = (0,react.useState)(null), infoPayment = ref19[0], setInfoPayment = ref19[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.isSupportedOnusApp)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            brand/* BrandApi.paymentOnus */.X.paymentOnus({
                                orderId: dataVouchers === null || dataVouchers === void 0 ? void 0 : (ref = dataVouchers.orderId) === null || ref === void 0 ? void 0 : ref.toString()
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        setInfoPayment(res === null || res === void 0 ? void 0 : res.data);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        chainId,
        dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.orderId,
        findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.isSupportedOnusApp
    ]);
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalPaymentOnus, {
        title: "Qu\xe9t m\xe3 để quy đổi",
        ticketNumber: infoPayment === null || infoPayment === void 0 ? void 0 : infoPayment.ticketNumber
    })), 1), openModalPaymentOnus = ref20[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageFullWidth/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                width: "100%",
                mb: "1rem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        flexDirection: "column",
                        style: {
                            gap: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    style: {
                                        gap: "12px",
                                        cursor: "pointer",
                                        width: "fit-content"
                                    },
                                    onClick: function() {
                                        dispatch((0,actions/* fetchStatusScreen */.an)({
                                            isActiveScreen: 0
                                        }));
                                        dispatch((0,actions/* fetchIsUpdateOrder */.c1)({
                                            isUpdate: true
                                        }));
                                        router.push("/order");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftCircle/* default */.Z, {
                                            width: "32px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            scale: "lg",
                                            children: "Quay lại"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                mt: "1rem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    width: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsHeading, {
                                            scale: "xl",
                                            children: "T\xf3m tắt đơn h\xe0ng"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsSubHeading, {
                                            mt: "1.5rem",
                                            onClick: function() {
                                                dispatch((0,actions/* fetchStatusScreen */.an)({
                                                    isActiveScreen: 0
                                                }));
                                                dispatch((0,actions/* fetchIsUpdateOrder */.c1)({
                                                    isUpdate: true
                                                }));
                                                router.push("/order");
                                            },
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: "Thay đổi th\xf4ng tin"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mt: "3rem",
                                fontWeight: "bold",
                                fontSize: [
                                    "16px",
                                    ,
                                    "20px"
                                ],
                                children: "Th\xf4ng tin người nhận qu\xe0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsWrapInfo, {
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: [
                                            "100%",
                                            ,
                                            ,
                                            "50%"
                                        ],
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "default",
                                                children: "Số điện thoại:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.phoneNumber
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hr, {
                                        style: {
                                            height: "30px",
                                            border: "1px solid #E5E5E5"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: [
                                            "100%",
                                            ,
                                            ,
                                            "50%"
                                        ],
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "default",
                                                children: "Email:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mt: "1rem",
                                fontWeight: "bold",
                                fontSize: [
                                    "16px",
                                    ,
                                    "20px"
                                ],
                                children: "Th\xf4ng tin thẻ qu\xe0 tặng"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsGiftCardInfoPC, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexLine, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItemHeading, {
                                                isFirst: true,
                                                color: "default",
                                                children: "T\xean sản phẩm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItemHeading, {
                                                color: "default",
                                                children: "Số lượng"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItemHeading, {
                                                color: "default",
                                                children: "Gi\xe1 trị thẻ qu\xe0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItemHeading, {
                                                color: "default",
                                                children: "Tổng gi\xe1 trị"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexLine, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItem, {
                                                isFirst: true,
                                                children: dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.nameProduct
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItem, {
                                                children: Number(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.fillAmount).toLocaleString("en", {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowItem, {
                                                children: (dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.isPromo) === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                            fontSize: [
                                                                "14px",
                                                                ,
                                                                "16px"
                                                            ],
                                                            children: [
                                                                Number(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.promoPrice).toLocaleString("en", {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }),
                                                                config/* UNIT_TOKEN */.eC
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                            style: {
                                                                fontSize: "12px",
                                                                textDecoration: "line-through",
                                                                color: "#9596a6"
                                                            },
                                                            children: [
                                                                Number(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.price).toLocaleString("en", {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }),
                                                                config/* UNIT_TOKEN */.eC
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        children: [
                                                            Number(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.price).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            }),
                                                            config/* UNIT_TOKEN */.eC
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowItem, {
                                                children: [
                                                    Number(totalPrice).toLocaleString("en", {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    }),
                                                    config/* UNIT_TOKEN */.eC,
                                                    (findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref6 = findTokenPayment.token) === null || ref6 === void 0 ? void 0 : ref6.symbol) !== "VNDC" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        style: {
                                                            fontSize: "10px"
                                                        },
                                                        children: [
                                                            "Tương đương ",
                                                            (0,formatNumber/* formatNumberv2 */.L)(findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.exchangeRate, findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref7 = findTokenPayment.token) === null || ref7 === void 0 ? void 0 : ref7.symbol),
                                                            " điểm ",
                                                            findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref8 = findTokenPayment.token) === null || ref8 === void 0 ? void 0 : ref8.symbol
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsGiftCardInfoMobile, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "flex-end",
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                style: {
                                                    whiteSpace: "nowrap"
                                                },
                                                color: "default",
                                                children: "T\xean sản phẩm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textAlign: "right",
                                                children: dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.nameProduct
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "flex-end",
                                        justifyContent: "space-between",
                                        mt: "0.5rem",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "default",
                                                children: "Số lượng"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textAlign: "right",
                                                children: Number(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.fillAmount).toLocaleString("en", {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "flex-end",
                                        justifyContent: "space-between",
                                        mt: "0.5rem",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "default",
                                                children: "Gi\xe1 trị thẻ qu\xe0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textAlign: "right",
                                                children: (dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.isPromo) === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                            fontSize: [
                                                                "14px",
                                                                ,
                                                                "16px"
                                                            ],
                                                            children: [
                                                                Number(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.promoPrice).toLocaleString("en", {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }),
                                                                config/* UNIT_TOKEN */.eC
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                            style: {
                                                                fontSize: "10px",
                                                                textDecoration: "line-through",
                                                                color: "#9596a6"
                                                            },
                                                            children: [
                                                                Number(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.price).toLocaleString("en", {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                }),
                                                                config/* UNIT_TOKEN */.eC
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        children: [
                                                            Number(dataVouchers === null || dataVouchers === void 0 ? void 0 : dataVouchers.price).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            }),
                                                            config/* UNIT_TOKEN */.eC
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "flex-end",
                                        justifyContent: "space-between",
                                        mt: "0.5rem",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "default",
                                                children: "Tổng gi\xe1 trị"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                flexDirection: "column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        textAlign: "right",
                                                        children: [
                                                            Number(totalPrice).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            }),
                                                            config/* UNIT_TOKEN */.eC
                                                        ]
                                                    }),
                                                    (findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref9 = findTokenPayment.token) === null || ref9 === void 0 ? void 0 : ref9.symbol) !== "VNDC" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        style: {
                                                            fontSize: "10px"
                                                        },
                                                        children: [
                                                            "Tương đương ",
                                                            (0,formatNumber/* formatNumberv2 */.L)(findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.exchangeRate, findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref10 = findTokenPayment.token) === null || ref10 === void 0 ? void 0 : ref10.symbol),
                                                            " điểm ",
                                                            findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref11 = findTokenPayment.token) === null || ref11 === void 0 ? void 0 : ref11.symbol
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mt: "1rem",
                                fontWeight: "bold",
                                fontSize: [
                                    "16px",
                                    ,
                                    "20px"
                                ],
                                children: "Chọn h\xecnh thức quy đổi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mt: "1rem",
                                fontWeight: "bold",
                                fontSize: [
                                    "14px",
                                    ,
                                    "16px"
                                ],
                                color: "red",
                                children: "*Lưu \xfd: Vui l\xf2ng kh\xf4ng tải lại hoặc tho\xe1t trang web trong khi giao dịch đang được thực hiện"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexCard, {
                                width: [
                                    "100%",
                                    ,
                                    "70%"
                                ],
                                my: "1rem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            justifyContent: "flex-start",
                                            width: "100%",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    width: "100%",
                                                    className: "textPoint",
                                                    color: "white",
                                                    children: [
                                                        "Điểm ",
                                                        findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref12 = findTokenPayment.token) === null || ref12 === void 0 ? void 0 : ref12.symbol
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    width: [
                                                        "100%",
                                                        ,
                                                        "85%"
                                                    ],
                                                    alignItems: "flex-end",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    style: {
                                                        gap: "14px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                            fontSize: [
                                                                "12px",
                                                                ,
                                                                ,
                                                                "14px"
                                                            ],
                                                            style: {
                                                                zIndex: 10
                                                            },
                                                            color: "white",
                                                            children: [
                                                                getChainName(chainId),
                                                                ":"
                                                            ]
                                                        }),
                                                        " ",
                                                        "\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                            fontSize: [
                                                                "12px",
                                                                ,
                                                                ,
                                                                "14px"
                                                            ],
                                                            style: {
                                                                zIndex: 10
                                                            },
                                                            color: "white",
                                                            children: [
                                                                (0,formatNumber/* formatNumberv2 */.L)(dataUser === null || dataUser === void 0 ? void 0 : dataUser.balanceOf, findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref13 = findTokenPayment.token) === null || ref13 === void 0 ? void 0 : ref13.symbol),
                                                                " ",
                                                                findTokenPayment === null || findTokenPayment === void 0 ? void 0 : (ref14 = findTokenPayment.token) === null || ref14 === void 0 ? void 0 : ref14.symbol
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTagPrice, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagPriceActiveFullWidth/* default */.Z, {
                                                width: "100%"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                minWidth: "40%",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                style: {
                                    gap: "1rem"
                                },
                                children: [
                                    !account ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConnectWalletButton/* default */.Z, {
                                        children: [
                                            "Kết nối v\xed",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                                                ml: "4px",
                                                color: "white",
                                                style: {
                                                    transform: "rotate(270deg)"
                                                }
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: isNotAllowance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonContinue, {
                                            onClick: handleApprove,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            disabled: pendingTx || isNotBanlance,
                                            endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                                spin: true,
                                                color: "white"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                                                ml: "4px",
                                                color: "white",
                                                style: {
                                                    transform: "rotate(270deg)"
                                                }
                                            }),
                                            children: "Chấp thuận"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonContinue, {
                                            onClick: handleClick,
                                            disabled: isNotBanlance || pendingBuyVoucher,
                                            endIcon: pendingBuyVoucher ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                                color: "white",
                                                spin: true
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                                                ml: "4px",
                                                color: "white",
                                                style: {
                                                    transform: "rotate(270deg)"
                                                }
                                            }),
                                            children: "Quy đổi"
                                        })
                                    }),
                                    (findTokenPayment === null || findTokenPayment === void 0 ? void 0 : findTokenPayment.isSupportedOnusApp) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            onClick: openModalPaymentOnus,
                                            children: "Quy đổi qua Onus"
                                        })
                                    })
                                ]
                            }),
                            account && isNotBanlance && isLoading === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mt: "0.5rem",
                                color: "red",
                                children: "Số dư của bạn kh\xf4ng đủ"
                            })
                        ]
                    }),
                    pendingBuyVoucher ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalV2/* ModalV2 */.k, {
                            isOpen: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapLoading, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "classic-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loader"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mt: "1rem",
                                            children: "Đang xử l\xfd đơn h\xe0ng. Vui l\xf2ng kh\xf4ng tải lại trang"
                                        })
                                    ]
                                })
                            })
                        })
                    }) : ""
                ]
            })
        })
    });
};
var WrapLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-53a8f7b8-0"
})(OrderSummary_templateObject());
/* harmony default export */ var GiftCards_OrderSummary = (OrderSummary);

;// CONCATENATED MODULE: ./src/views/GiftCards/index.tsx







var GiftCards = function(param) {
    var price = param.price, brand = param.brand, product = param.product, phoneNumber = param.phoneNumber, newbrand = param.newbrand;
    (0,giftCards/* UseCoreGiftCard */.Y9)();
    var dataGiftcards = (0,giftCards/* GetDataGiftCards */.n3)();
    var isActiveScreen = dataGiftcards.isActiveScreen;
    (0,react.useEffect)(function() {
        var unloadCallback = function(event) {
            event.preventDefault();
            // eslint-disable-next-line no-param-reassign
            event.returnValue = "";
            return "";
        };
        window.addEventListener("beforeunload", unloadCallback);
        return function() {
            return window.removeEventListener("beforeunload", unloadCallback);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isActiveScreen === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftCards_ElectronicGiftCard, {
                priceRoute: price,
                brandRoute: brand,
                productRoute: product,
                phoneNumberRoute: phoneNumber,
                newbrand: newbrand
            })
        }) : isActiveScreen === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftCards_OrderSummary, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftCards_InformationOrder, {})
    });
};
/* harmony default export */ var views_GiftCards = (GiftCards);

;// CONCATENATED MODULE: ./src/pages/order/[[...brand]].tsx









var GiftCardsPage = function() {
    var router = (0,next_router.useRouter)();
    var _query = router.query, brand = _query.brand, price = _query.price, product = _query.product, phoneNumber = _query.phoneNumber, newbrand = _query.newbrand;
    (0,giftCards/* UseDetailBrand */.yt)(brand === null || brand === void 0 ? void 0 : brand.toString(), newbrand === null || newbrand === void 0 ? void 0 : newbrand.toString());
    var brandItem = (0,giftCards/* GetDataGiftCards */.n3)().brandItem;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,actions/* fetchStatusScreen */.an)({
            isActiveScreen: 0
        }));
    }, [
        dispatch
    ]);
    if ((brandItem === null || brandItem === void 0 ? void 0 : brandItem.length) === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(views_GiftCards, {
        price: price === null || price === void 0 ? void 0 : price.toString(),
        brand: brand === null || brand === void 0 ? void 0 : brand.toString(),
        product: product === null || product === void 0 ? void 0 : product.toString(),
        phoneNumber: phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.toString(),
        newbrand: newbrand === null || newbrand === void 0 ? void 0 : newbrand.toString()
    });
};
GiftCardsPage.chains = wagmi/* SUPPORT_CHAIN_GIFTCARDS */.fd;
/* harmony default export */ var _brand_ = (GiftCardsPage);


/***/ }),

/***/ 8001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ fetchHistoryData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var config_api_history__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86930);



var fetchHistoryData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(account, fromDate, toDate, search, sort, skip, limit, chainId) {
        var ref, ref1, res, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(account === null || account === void 0 ? void 0 : account.length)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        config_api_history__WEBPACK_IMPORTED_MODULE_0__/* .historyApi.history */ .z.history({
                            fromDate: fromDate,
                            toDate: toDate,
                            search: search,
                            sort: sort,
                            skip: skip,
                            limit: limit,
                            chainId: chainId
                        })
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        {
                            dataHistory: {
                                total: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.total,
                                orders: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.orders
                            }
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            dataHistory: null
                        }
                    ];
                case 4:
                    return [
                        2,
                        {
                            dataHistory: null
                        }
                    ];
            }
        });
    });
    return function fetchHistoryData(account, fromDate, toDate, search, sort, skip, limit, chainId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 75660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HO": function() { return /* binding */ toLowerCaseNonAccentVietnamese; },
/* harmony export */   "OF": function() { return /* binding */ latiniseText; }
/* harmony export */ });
/* unused harmony exports Latinise, latinise */
var Latinise = {
    latin_map: {
        τ: "t",
        Τ: "T"
    }
};
var latinise = function(input) {
    return input.replace(/[^A-Za-z0-9[\] ]/g, function(x) {
        return Latinise.latin_map[x] || x;
    });
};
var toLowerCaseNonAccentVietnamese = function(text) {
    var str = text.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "");
    str = str.replace(/\u02C6|\u0306|\u031B/g, "");
    return str;
};
var latiniseText = function(text) {
    var str = text.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng 
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
    return str;
};


/***/ }),

/***/ 64950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13193);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29439);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45388);
/* harmony import */ var components_Layout_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44305);
/* harmony import */ var components_Layout_PageFullWidth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38047);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53918);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    max-width: 1380px;\n    height: 90vh;\n    @media screen and (max-width: 768px) and (min-width: 601px) {\n        padding-left: 0px;\n        padding-right: 0px;\n        margin-bottom: 60px;\n    }\n    @media screen and (max-width: 600px) {\n        padding-left: 15px;\n        padding-right: 15px;\n        height: auto;\n        padding-bottom: 3rem;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    @media screen and (max-width:1000px) and (min-width:601px) {\n        font-size: ",
        ";\n    }\n    @media screen and (max-width:600px){\n        font-size: ",
        ";\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 50%;\n    height: 100%;\n    flex-direction:column;\n    align-items: center;\n    justify-content: center;\n    @media screen and (max-width:600px) {\n        width: 100%;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 50%;\n    height: 100%;\n    flex-direction:column;\n    align-items: center;\n    justify-content: center;\n    > img {\n        width: 450px;\n        height: auto;\n    }\n    @media screen and (max-width:600px) {\n        width: 100%;\n        > img {\n            width: 200px;\n            height: auto;\n        }\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var NotFoundBrand = function() {
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Layout_PageFullWidth__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CsContainer, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                width: "100%",
                height: "100%",
                justifyContent: "space-between",
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ColLeft, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            src: "/images/giftcards/not_found_brand.png",
                            alt: "not-found"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ColRight, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            width: "100%",
                            height: [
                                "200px",
                                ,
                                "250px"
                            ],
                            justifyContent: "space-between",
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    width: "100%",
                                    flexDirection: "column",
                                    alignItems: [
                                        "center",
                                        ,
                                        "flex-start"
                                    ],
                                    justifyContent: [
                                        "center",
                                        ,
                                        "flex-start"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            width: "100%",
                                            justifyContent: [
                                                "center",
                                                ,
                                                "flex-start"
                                            ],
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CsHeading, {
                                                isSmall: false,
                                                children: "Oops!"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            width: "100%",
                                            mt: "2rem",
                                            justifyContent: [
                                                "center",
                                                ,
                                                "flex-start"
                                            ],
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CsHeading, {
                                                isSmall: !false,
                                                children: "Kh\xf4ng t\xecm thấy thương hiệu"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    width: "100%",
                                    justifyContent: [
                                        "center",
                                        ,
                                        "flex-start"
                                    ],
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            style: {
                                                borderRadius: "40px"
                                            },
                                            children: "Quay về trang chủ "
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotFoundBrand);
var CsContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(components_Layout_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d855e5de-0"
})(_templateObject());
var CsHeading = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-d855e5de-1"
})(_templateObject1(), function(param) {
    var isSmall = param.isSmall;
    return isSmall ? "400" : "700";
}, function(param) {
    var isSmall = param.isSmall;
    return isSmall ? "40px" : "70px";
}, function(param) {
    var isSmall = param.isSmall;
    return isSmall ? "30px" : "55px";
}, function(param) {
    var isSmall = param.isSmall;
    return isSmall ? "30px" : "45px";
});
var ColRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d855e5de-2"
})(_templateObject2());
var ColLeft = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d855e5de-3"
})(_templateObject3());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,1372,8255,7333,9545,9774,2888,179], function() { return __webpack_exec__(36899); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);